/* ============================================================
   SKT DESIGN STUDIO  —  assets/skt-design-studio.js
   Reads the existing MRK data blocks, renders the studio over the
   real variant photos, prices with the live tiers, and posts the
   same cart payload the old customizer posted.
   No jQuery. No build step.
   ============================================================ */
(function () {
  'use strict';

  var CFG = {}, PRODUCT = null, IMAGES = {}, SWATCHES = {};
  var VIEWS = [
    { k: 'front', n: 'Front' },
    { k: 'back',  n: 'Back' },
    { k: 'left',  n: 'Left side' },
    { k: 'right', n: 'Right side' }
  ];
  var DTF = [
    { w: 4,  h: 4,  p: 3 },   { w: 6,  h: 6,  p: 4.5 },
    { w: 8,  h: 10, p: 7.5 }, { w: 11, h: 14, p: 14 },
    { w: 12, h: 17, p: 18 },  { w: 15, h: 22, p: 25 }
  ];
  var STYLES = [
    { k: 'classic', n: 'Classic', a: function (l) { l.outline = ''; l.outlineW = 0; l.ls = 0; l.italic = false; } },
    { k: 'sticker', n: 'Sticker', a: function (l) { l.outline = '#FFFFFF'; l.outlineW = 9; l.ls = 0; l.italic = false; } },
    { k: 'jersey',  n: 'Jersey',  a: function (l) { l.outline = l.colour; l.outlineW = 5; l.hollow = true; l.ls = 10; l.italic = false; } },
    { k: 'comic',   n: 'Comic',   a: function (l) { l.outline = '#111111'; l.outlineW = 7; l.ls = 0; l.italic = false; } },
    { k: 'action',  n: 'Action',  a: function (l) { l.outline = ''; l.outlineW = 0; l.italic = true; l.ls = 0; } },
    { k: 'team',    n: 'Team',    a: function (l) { l.outline = '#111111'; l.outlineW = 4; l.ls = 14; l.italic = false; } },
    { k: 'retro',   n: 'Retro',   a: function (l) { l.outline = '#8400FF'; l.outlineW = 6; l.ls = 0; l.italic = false; } },
    { k: 'poster',  n: 'Poster',  a: function (l) { l.outline = ''; l.outlineW = 0; l.ls = -2; l.italic = false; } }
  ];
  var WARPS = [
    { k: 'normal',  n: 'Normal' },  { k: 'arcup',  n: 'Arc up' },
    { k: 'arcdown', n: 'Arc down' },{ k: 'circle', n: 'Circle' },
    { k: 'wave',    n: 'Wave' },    { k: 'slant',  n: 'Slant' }
  ];
  var FONTS = ['Oswald', 'Anton', 'Bebas Neue', 'Impact', 'Inter'];
  var FONT_Q = '';

  /* the old customizer already lists every font you offer, so take its list
     rather than keeping a second one here that goes stale */
  function harvestFonts() {
    /* the snippet carries the list now. Scraping the old customizer's dropdown
       only runs if no list was supplied, so the old markup can be removed. */
    if (CFG && CFG.fonts && CFG.fonts.length > 4) {
      FONTS = CFG.fonts.filter(function (n, i) { return CFG.fonts.indexOf(n) === i; });
      return FONTS;
    }
    var found = [];
    $$('select').forEach(function (sel) {
      if (sel.closest('#skt-studio') || sel.closest('#sktFull')) return;
      var opts = Array.prototype.slice.call(sel.options || []);
      if (opts.length < 8) return;
      var names = opts.map(function (o) { return (o.value || o.textContent || '').trim(); })
                      .filter(function (n) { return n && n.length < 40; });
      /* a font list looks like a font list: mostly title case words, few numbers */
      var looksFonty = names.filter(function (n) { return /^[A-Z][A-Za-z0-9 '\-]+$/.test(n); }).length;
      if (looksFonty > names.length * 0.7 && names.length > found.length) found = names;
    });
    if (!found.length) {
      $$('[data-font],[data-font-family]').forEach(function (el) {
        var n = el.getAttribute('data-font') || el.getAttribute('data-font-family');
        if (n && found.indexOf(n) < 0) found.push(n);
      });
    }
    if (found.length > 5) {
      FONTS = found.filter(function (n, i) { return found.indexOf(n) === i; });
    }
    return FONTS;
  }
  /* load the families on demand, in chunks, only when the font sheet opens */
  var FONTS_LOADED = false;
  function ensureFonts() {
    if (FONTS_LOADED) return;
    FONTS_LOADED = true;
    var fams = FONTS.filter(function (n) { return ['Impact', 'Arial', 'Georgia', 'Verdana'].indexOf(n) < 0; });
    for (var i = 0; i < fams.length; i += 18) {
      var chunk = fams.slice(i, i + 18).map(function (n) {
        return 'family=' + encodeURIComponent(n).replace(/%20/g, '+') + ':wght@400;700;900';
      }).join('&');
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' + chunk + '&display=swap';
      document.head.appendChild(link);
    }
  }

  var S = {
    items: [], ai: 0,
    colour: null, view: 'front', layers: { front: [], back: [], left: [], right: [] },
    sel: null, qty: {}, assets: [], uid: 1, sheet: null, ftab: 'library',
    notes: '', hist: [], redo: [], busy: false
  };

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function fmt(n) { return (Math.round((n || 0) * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function pct(v) { return parseFloat(String(v).replace('%', '')) || 0; }
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* the old customizer published mrk-product-data. The snippet now publishes the
     same thing as skt-product-data, so either one boots the studio and the old
     customizer can be deleted from the template. */
  function readProduct() { return readJSON('mrk-product-data') || readJSON('skt-product-data'); }

  function area(k) {
    var v = k || S.view, p = CFG.positions[v] || {}, i = (CFG.inches || {})[v] || { w: 12, h: 16 };
    var A = { top: pct(p.top), left: pct(p.left), width: pct(p.width), height: pct(p.height), w: i.w, h: i.h };
    /* The box drawn on the photo and the inches in the config can be different
       shapes. One inch across has to equal one inch down or every image comes out
       stretched, so keep the width in inches and let the box decide the height.
       IMG_RATIO is the photo's width over its height. */
    if (IMG_RATIO > 0 && A.width > 0 && A.height > 0) {
      A.h = A.w * (A.height / A.width) / IMG_RATIO;
    }
    return A;
  }
  function L(k) { return S.layers[k || S.view]; }
  function sel() { var l = L().filter(function (x) { return x.id === S.sel; }); return l[0] || null; }
  function isBox(l) { return l.type === 'image' || (l.warp && l.warp !== 'normal' && l.warp !== 'slant'); }
  function topOf(l) { return isBox(l) ? l.y : l.y - l.h / 2; }
  function leftOf(l) { return isBox(l) ? l.x : l.x - l.w / 2; }
  function totalQty() { var n = 0; Object.keys(S.qty).forEach(function (k) { n += S.qty[k] || 0; }); return n; }
  function areasUsed() { return VIEWS.filter(function (v) { return S.layers[v.k].length; }).length; }

  function norm(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().toLowerCase(); }
  function optHas(variant, value) {
    var want = norm(value);
    return norm(variant.option1) === want || norm(variant.option2) === want || norm(variant.option3) === want;
  }
  function optionValues(name) {
    var vals = [];
    if (PRODUCT && PRODUCT.options) {
      var o = PRODUCT.options.filter(function (x) {
        return String(x.name).toLowerCase() === String(name).toLowerCase();
      })[0];
      if (o && o.values) vals = o.values.slice();
    }
    /* Liquid truncates long variant lists, the swatch list does not */
    if ((name === 'Color' || name === 'Colour') && CFG.swatches) {
      Object.keys(CFG.swatches).forEach(function (k) { if (vals.indexOf(k) < 0) vals.push(k); });
    }
    return vals;
  }
  function hasPAOption() { return optionValues('# of Print Areas').length > 0; }
  function paLabel(n) { return n === 1 ? '1 Print Area' : n + ' Print Areas'; }

  function findVariant(colour, size, pa) {
    if (!PRODUCT || !PRODUCT.variants) return null;
    return PRODUCT.variants.filter(function (v) {
      if (!optHas(v, colour) || !optHas(v, size)) return false;
      if (pa && !optHas(v, pa)) return false;
      return true;
    })[0] || null;
  }
  function tierFor(q) {
    var t = CFG.tiers[0];
    CFG.tiers.forEach(function (x) { if (q >= x.min) t = x; });
    return t;
  }
  function surcharge(q) { return q < 24 ? CFG.surchargeUnder24 : CFG.surcharge24Plus; }

  /* the old customizer hydrates variant images lazily, often only once a colour
     is picked. if we have nothing for this colour, watch the data block and
     repaint the moment it lands. */
  var chaseTimer = null;
  function chaseImages(colour, tries) {
    if (chaseTimer) clearInterval(chaseTimer);
    var n = 0;
    chaseTimer = setInterval(function () {
      n++;
      var fresh = readJSON('mrk-variant-images-data');
      if (fresh) IMAGES = fresh;
      var full = readProduct();
      if (full && full.variants && PRODUCT && full.variants.length > PRODUCT.variants.length) PRODUCT = full;
      if (S.colour !== colour || hasRealPhoto(colour) || n > (tries || 24)) {
        clearInterval(chaseTimer); chaseTimer = null;
        if (hasRealPhoto(colour)) {
          if (CFG.mode === 'launch') paintLauncher();
          if (document.getElementById('sktStage')) { drawStage(); render(); }
        }
      }
    }, 400);
  }
  function hasRealPhoto(c) {
    var vs = PRODUCT.variants.filter(function (x) { return optHas(x, c); });
    for (var i = 0; i < vs.length; i++) {
      var im = IMAGES[vs[i].id] || IMAGES[String(vs[i].id)] || {};
      if (im.front && im.front !== 'null' && im.front.indexOf('no-image') < 0) return true;
    }
    return false;
  }

  function swatchFor(c) {
    if (!CFG.swatches) return null;
    if (CFG.swatches[c]) return CFG.swatches[c];
    var keys = Object.keys(CFG.swatches), lc = String(c).trim().toLowerCase();
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].trim().toLowerCase() === lc) return CFG.swatches[keys[i]];
    }
    return null;
  }
  function viewImage(k) {
    var it0 = S.items[S.ai];
    var cp = (it0 && it0.colourPhotos) || COLOUR_PHOTOS;
    if (cp && cp[S.colour] && cp[S.colour][k]) return cp[S.colour][k];
    var vs = PRODUCT.variants.filter(function (x) { return optHas(x, S.colour); });
    /* the four print area photos from the variant metafields */
    for (var i = 0; i < vs.length; i++) {
      var imgs = IMAGES[vs[i].id] || IMAGES[String(vs[i].id)] || {};
      var u = imgs[k];
      if (u && u !== 'null' && u.indexOf('no-image') < 0) return u;
    }
    /* this colour has no print area photos, show its own variant image
       rather than an empty box. the print box still works on top of it. */
    var sw = swatchFor(S.colour);
    if (sw && sw.variantImage) return sw.variantImage;
    for (var n = 0; n < vs.length; n++) {
      if (vs[n].featured_image && vs[n].featured_image.src) return vs[n].featured_image.src;
    }
    var anyView = ['front', 'back', 'left', 'right'];
    for (var a = 0; a < vs.length; a++) {
      var im2 = IMAGES[vs[a].id] || IMAGES[String(vs[a].id)] || {};
      for (var bq = 0; bq < anyView.length; bq++) {
        var u2 = im2[anyView[bq]];
        if (u2 && u2 !== 'null' && u2.indexOf('no-image') < 0) return u2;
      }
    }
    return '';
  }
  /* Move the EXISTING colour picker into the new layout instead of redrawing it.
     Same DOM node, same handlers, same colours it always showed. */
  var PICKER = null, PICKER_HOME = null;
  function findPicker() {
    if (PICKER) return PICKER;
    var best = null, bestN = 0;
    $$('div, ul, section').forEach(function (n) {
      if (n.id === 'skt-studio' || n.closest('#skt-studio') || n.closest('#sktFull')) return;
      var kids = n.querySelectorAll('[class*="swatch"],[data-color],[data-colour]').length;
      if (kids > bestN && kids >= 2 && n.querySelectorAll('div,li,button,span').length < kids * 8) {
        best = n; bestN = kids;
      }
    });
    PICKER = best;
    if (PICKER && !PICKER_HOME) {
      PICKER_HOME = { parent: PICKER.parentElement, next: PICKER.nextSibling };
    }
    return PICKER;
  }
  function mountPicker(slotId) {
    var slot = document.getElementById(slotId);
    var pick = findPicker();
    if (!slot || !pick) return false;
    pick.style.display = '';
    pick.style.visibility = 'visible';
    slot.appendChild(pick);
    if (!pick.__sktBound) {
      pick.__sktBound = true;
      pick.addEventListener('click', function (e) {
        var el = e.target.closest('[data-color],[data-colour],[title],[aria-label]');
        var n = el && (el.getAttribute('data-color') || el.getAttribute('data-colour')
             || el.getAttribute('title') || el.getAttribute('aria-label'));
        if (!n) return;
        var match = optionValues('Color').filter(function (c) {
          return String(c).trim().toLowerCase() === String(n).trim().toLowerCase();
        })[0];
        if (!match) return;
        pickColour(match);
        var lbl = document.getElementById('sktLPCol'); if (lbl) lbl.textContent = match;
        var lbl2 = document.getElementById('sktColName'); if (lbl2) lbl2.textContent = match;
        var img = document.getElementById('sktLPImg');
        if (img) img.innerHTML = viewImage('front') ? '<img src="' + viewImage('front') + '" alt="">' : '';
        if (document.getElementById('sktStage')) { drawStage(); render(); }
      }, true);
    }
    return true;
  }

  /* read the colours straight off the old customizer's own swatches.
     they are already on the page, just hidden, so this is its logic, not mine */
  var HARVEST = {};
  function harvestSwatches() {
    var names = optionValues('Color');
    names.forEach(function (n) {
      if (HARVEST[n]) return;
      var esc2 = String(n).replace(/"/g, '\\"');
      var el = null;
      ['[data-color="', '[data-colour="', '[data-value="', '[title="', '[aria-label="']
        .forEach(function (pre) {
          if (el) return;
          try { el = document.querySelector(pre + esc2 + '"]'); } catch (e) {}
        });
      if (!el) {
        /* last resort: any element whose text is exactly the colour name, take its sibling dot */
        var all = $$('#mrk-customizer *');
        for (var i = 0; i < all.length; i++) {
          if (all[i].children.length === 0 && all[i].textContent.trim() === n) {
            el = all[i].previousElementSibling || all[i].parentElement;
            break;
          }
        }
      }
      if (!el) return;
      var cs = getComputedStyle(el);
      var bg = cs.backgroundColor, bi = cs.backgroundImage;
      if (bi && bi !== 'none' && bi.indexOf('url(') === 0) { HARVEST[n] = { img: bi }; return; }
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') { HARVEST[n] = { hex: bg }; return; }
      var inner = el.querySelector('[style*="background"]');
      if (inner) {
        var cs2 = getComputedStyle(inner);
        if (cs2.backgroundImage && cs2.backgroundImage !== 'none') { HARVEST[n] = { img: cs2.backgroundImage }; return; }
        if (cs2.backgroundColor && cs2.backgroundColor !== 'rgba(0, 0, 0, 0)') HARVEST[n] = { hex: cs2.backgroundColor };
      }
    });
  }

  function swatchLookup(name) {
    if (!SWATCHES) return null;
    if (SWATCHES[name]) return SWATCHES[name];
    var keys = Object.keys(SWATCHES), lower = String(name).trim().toLowerCase();
    for (var i = 0; i < keys.length; i++) {
      if (String(keys[i]).trim().toLowerCase() === lower) return SWATCHES[keys[i]];
    }
    return null;
  }
  function colourHex(name) {
    var s = swatchLookup(name);
    if (s) {
      if (typeof s === 'string') return s;
      if (s.hex) return s.hex;
      if (s.value) return s.value;
    }
    var v = variantForColour(name);
    var cd = v && v.metafields && v.metafields.color && v.metafields.color.values;
    if (typeof cd === 'string' && cd.charAt(0) === '#') return cd;
    if (cd && cd.hex) return cd.hex;
    return '';   /* empty means: use a photo instead of a blank grey dot */
  }
  function variantForColour(name) {
    return PRODUCT.variants.filter(function (x) { return optHas(x, name); })[0] || null;
  }
  function hasCleanPhoto(colour) {
    var it0 = S.items[S.ai];
    var cp = (it0 && it0.colourPhotos) || COLOUR_PHOTOS;
    if (cp && cp[colour] && cp[colour].front) return true;
    var vs = PRODUCT.variants.filter(function (x) { return optHas(x, colour); });
    for (var i = 0; i < vs.length; i++) {
      var im = IMAGES[vs[i].id] || IMAGES[String(vs[i].id)] || {};
      if (im.front && im.front !== 'null' && im.front.indexOf('no-image') < 0) return true;
    }
    return false;
  }
  function photoForColour(c) {
    var it0 = S.items[S.ai];
    var cp = (it0 && it0.colourPhotos) || COLOUR_PHOTOS;
    if (cp && cp[c]) {
      var got = cp[c].front || cp[c].back || cp[c].left || cp[c].right;
      if (got) return got;
    }
    /* the swatch is a crop of the FRONT photo you uploaded for that variant,
       never the marketing mockup */
    var vs = PRODUCT.variants.filter(function (x) { return optHas(x, c); });
    var order = ['front', 'back', 'left', 'right'];
    for (var k = 0; k < order.length; k++) {
      for (var i = 0; i < vs.length; i++) {
        var im = IMAGES[vs[i].id] || IMAGES[String(vs[i].id)] || {};
        var u = im[order[k]];
        if (u && u !== 'null' && u.indexOf('no-image') < 0) return u;
      }
    }
    return null;
  }
  function colourSwatchStyle(c) {
    /* Shopify's own swatch data for this option value, the source that
       already works everywhere else on the site */
    var sw = CFG.swatches && (CFG.swatches[c] || CFG.swatches[String(c).trim()]);
    if (!sw && CFG.swatches) {
      var keys = Object.keys(CFG.swatches), lc = String(c).trim().toLowerCase();
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].trim().toLowerCase() === lc) { sw = CFG.swatches[keys[i]]; break; }
      }
    }
    var photo = photoForColour(c);
    if (photo) return 'background-image:url(' + photo + ')';
    if (sw) {
      if (sw.image) return 'background-image:url(' + sw.image + ');background-size:cover';
      if (sw.color) return 'background-color:' + sw.color;
      if (sw.variantImage) return 'background-image:url(' + sw.variantImage + ')';
    }
    var h = HARVEST[c];
    if (h && h.img) return 'background-image:' + h.img + ';background-size:cover';
    if (h && h.hex) return 'background-color:' + h.hex;
    var hex = colourHex(c);
    if (hex) return 'background-color:' + hex;
    return 'background-color:#e9e9ec';
  }

  /* ---------- text rendering ---------- */
  function txtStyle(l, px) {
    var s = "font-family:'" + l.font + "',sans-serif;font-weight:" + (l.weight || 900) + ';';
    s += 'font-style:' + (l.italic ? 'italic' : 'normal') + ';';
    s += 'color:' + (l.hollow ? 'transparent' : l.colour) + ';';
    s += 'letter-spacing:' + ((l.ls || 0) / 100) + 'em;line-height:' + (l.lh || 1.1) + ';';
    s += 'text-align:' + (l.align || 'center') + ';';
    if (l.outline && l.outlineW) s += '-webkit-text-stroke:' + (l.outlineW / 100) + 'em ' + l.outline + ';';
    if (l.warp === 'slant') s += 'transform:skewX(-' + Math.round((l.intensity == null ? 50 : l.intensity) * 0.22) + 'deg);';
    if (px) s += 'font-size:' + px + 'px;';
    return s;
  }
  /* the arc is centred on its own height, so turning the intensity up bends
     the text without sliding it up or down the garment */
  function arcGeometry(intensity, halfChord) {
    var i = Math.max(0, Math.min(1, (intensity == null ? 50 : intensity) / 100));
    var r = halfChord / Math.max(0.06, 0.06 + i * 0.92);          /* flat to tight */
    if (r < halfChord * 1.02) r = halfChord * 1.02;
    var sag = r - Math.sqrt(Math.max(0, r * r - halfChord * halfChord));
    return { r: r, sag: sag };
  }
  function warpPath(l) {
    var i = (l.intensity == null ? 50 : l.intensity) / 100;
    var cy = 100, half = 180;
    if (l.warp === 'arcup' || l.warp === 'arcdown') {
      var g = arcGeometry(l.intensity, half);
      var chord = l.warp === 'arcup' ? cy + g.sag / 2 : cy - g.sag / 2;
      var sweep = l.warp === 'arcup' ? 1 : 0;
      return 'M ' + (200 - half) + ' ' + chord + ' A ' + g.r + ' ' + g.r
        + ' 0 0 ' + sweep + ' ' + (200 + half) + ' ' + chord;
    }
    if (l.warp === 'wave') return 'M 20 100 C 110 ' + (100 - 60 * i) + ' 190 ' + (100 + 60 * i)
      + ' 290 100 C 340 ' + (100 - 30 * i) + ' 370 100 380 100';
    if (l.warp === 'circle') return 'M 200 190 A 90 90 0 1 1 200 10 A 90 90 0 1 1 200 190';
    return '';
  }
  function warpSVG(l) {
    var id = 'sw' + l.id + Math.random().toString(36).slice(2, 6);
    var st = txtStyle(l).replace(/color:/, 'fill:')
      .replace(/-webkit-text-stroke:([^;]+);/, function (m, v) {
        var p = v.trim().split(' ');
        return 'stroke:' + p[1] + ';stroke-width:' + (parseFloat(p[0]) * 62) + 'px;';
      })
      .replace(/text-align:[^;]+;/, '').replace(/transform:[^;]+;/, '');
    return '<svg class="skt-warp" viewBox="0 0 400 200" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">'
      + '<defs><path id="' + id + '" d="' + warpPath(l) + '" fill="none"/></defs>'
      + '<text style="' + st + 'font-size:62px;paint-order:stroke fill">'
      + '<textPath href="#' + id + '" startOffset="50%" text-anchor="middle">'
      + esc((l.text || '').replace(/\n/g, ' ')) + '</textPath></text></svg>';
  }

  /* ---------- history ---------- */
  function snap() { S.hist.push(JSON.stringify(S.layers)); S.redo = []; if (S.hist.length > 60) S.hist.shift(); }
  function undo() { if (!S.hist.length) return; S.redo.push(JSON.stringify(S.layers)); S.layers = JSON.parse(S.hist.pop()); S.sel = null; render(); }
  function redo() { if (!S.redo.length) return; S.hist.push(JSON.stringify(S.layers)); S.layers = JSON.parse(S.redo.pop()); S.sel = null; render(); }

  /* ---------- layers ---------- */
  function addImage(a) {
    snap();
    var A = area(), r = a.h / a.w, w = Math.min(A.w * 0.75, 8), h = w * r;
    if (h > A.h * 0.75) { h = A.h * 0.75; w = h / r; }
    L().push({
      id: S.uid++, type: 'image', src: a.src, serverUrl: a.serverUrl || null, name: a.name,
      natW: a.w, natH: a.h, x: (A.w - w) / 2, y: (A.h - h) / 2, w: w, h: h, rot: 0, fx: 1, fy: 1
    });
    S.sel = L()[L().length - 1].id;
    render();
  }
  function addText(t) {
    snap();
    var A = area();
    L().push({
      id: S.uid++, type: 'text', text: t, font: 'Oswald', colour: '#FFD300', outline: '', outlineW: 0,
      hollow: false, weight: 900, italic: false, align: 'center', lh: 1.1, ls: 0,
      cap: Math.min(2, A.h * 0.5), style: 'classic', warp: 'normal', intensity: 50,
      x: A.w / 2, y: A.h / 2, w: 0, h: 0, rot: 0, fx: 1, fy: 1
    });
    S.sel = L()[L().length - 1].id;
    render();
  }
  function dpiOf(l) { return l.type === 'image' && l.w > 0 ? Math.round(l.natW / l.w) : 999; }

  /* ---------- upload, same endpoints as the old customizer ---------- */
  function fetchTimeout(url, opts, ms) {
    return new Promise(function (res, rej) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; rej(new Error('timeout')); } }, ms || 25000);
      fetch(url, opts).then(function (r) {
        if (done) return; done = true; clearTimeout(timer); res(r);
      }).catch(function (e) {
        if (done) return; done = true; clearTimeout(timer); rej(e);
      });
    });
  }

  function uploadToServer(file) {
    var ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    var clean = (file.name || 'artwork').replace(/[^a-z0-9._\- ]/gi, '').replace(/ +/g, '-');
    var safe = 'SKT-Artwork-' + ts + '-' + clean;
    return new Promise(function (resolve) {
      var r = new FileReader();
      r.onload = function (e) {
        var b64 = e.target.result.split(',')[1];
        var body = new URLSearchParams();
        body.append('data', b64);
        body.append('fileName', safe);
        body.append('filename', safe);
        body.append('mimeType', file.type || 'application/octet-stream');
        var post = function (url) {
          return fetchTimeout(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
          }, 25000).then(function (res) { return res.json(); })
            .then(function (j) { return (j && (j.fileUrl || j.url || j.webViewLink)) || null; });
        };
        post(CFG.uploadPrimary)
          .catch(function () { return null; })
          .then(function (u) { return u || post(CFG.uploadFallback).catch(function () { return null; }); })
          .then(function (u) { resolve(u || ('UPLOAD FAILED - ' + safe)); });
      };
      r.onerror = function () { resolve('UPLOAD FAILED - ' + safe); };
      r.readAsDataURL(file);
    });
  }
  /* a real Drive link. Not a filename, not a data url. */
  function isUrl(v) { return /^https?:\/\//.test(String(v || '')); }

  /* only the data url survives in the layer, so rebuild a file from it to retry */
  function fileFromDataUrl(src, name) {
    var parts = String(src || '').split(',');
    var mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/png';
    var bin = atob(parts[1] || ''), n = bin.length, arr = new Uint8Array(n);
    while (n--) arr[n] = bin.charCodeAt(n);
    return new File([arr], name || 'artwork.png', { type: mime });
  }

  function retryUploads() {
    var seen = {}, jobs = [];
    VIEWS.forEach(function (v) {
      S.layers[v.k].forEach(function (l) {
        if (l.type !== 'image' || isUrl(l.serverUrl)) return;
        if (!/^data:/.test(l.src) || seen[l.src]) return;
        seen[l.src] = 1;
        jobs.push(uploadToServer(fileFromDataUrl(l.src, l.name)).then(function (url) {
          if (!isUrl(url)) return;
          VIEWS.forEach(function (v2) {
            S.layers[v2.k].forEach(function (x) { if (x.src === l.src) x.serverUrl = url; });
          });
          S.assets.forEach(function (a) { if (a.src === l.src) a.serverUrl = url; });
        }));
      });
    });
    return Promise.all(jobs);
  }

  function takeFiles(files) {
    Array.prototype.forEach.call(files, function (f) {
      if (!/^image\//.test(f.type)) return;
      var rd = new FileReader();
      rd.onload = function () {
        var im = new Image();
        im.onload = function () {
          var asset = { src: rd.result, name: f.name, w: im.naturalWidth || 1000, h: im.naturalHeight || 1000, serverUrl: null };
          S.assets.push(asset);
          addImage(asset);
          closeSheet();
          uploadToServer(f).then(function (url) {
            asset.serverUrl = url;
            VIEWS.forEach(function (v) {
              S.layers[v.k].forEach(function (l) { if (l.src === asset.src) l.serverUrl = url; });
            });
          });
        };
        im.src = rd.result;
      };
      rd.readAsDataURL(f);
    });
  }

  /* ---------- pricing ---------- */
  function viewPrint(k) {
    var ls = S.layers[k];
    if (!ls.length) return 0;
    var w = 0, h = 0;
    ls.forEach(function (l) { w = Math.max(w, leftOf(l) + l.w); h = Math.max(h, topOf(l) + l.h); });
    for (var i = 0; i < DTF.length; i++) if (w <= DTF[i].w + 0.01 && h <= DTF[i].h + 0.01) return DTF[i].p;
    return DTF[DTF.length - 1].p;
  }
  function variantPriceFor(size, areas) {
    var label = hasPAOption() ? paLabel(Math.max(1, areas)) : null;
    var v = findVariant(S.colour, size, label) || findVariant(S.colour, size);
    return v && typeof v.price === 'number' ? v.price / 100 : null;
  }
  function anySizePrice(areas) {
    var sizes = optionValues('Size');
    for (var i = 0; i < sizes.length; i++) {
      var p = variantPriceFor(sizes[i], areas);
      if (p != null) return p;
    }
    return CFG.basePrice / 100;
  }
  function allQty() {
    syncItem();
    var n = 0;
    S.items.forEach(function (it) { n += itemPieces(it); });
    return n;
  }
  function itemAreas(it) {
    var n = 0;
    ['front', 'back', 'left', 'right'].forEach(function (k) {
      if (it.layers && it.layers[k] && it.layers[k].length) n++;
    });
    return Math.max(1, n);
  }
  function itemVariantPriceFor(it, colour, size, areas) {
    var label = null;
    var opt = (it.product.options || []).filter(function (o) {
      return String(o.name).toLowerCase().indexOf('print area') > -1;
    })[0];
    if (opt) label = areas === 1 ? '1 Print Area' : areas + ' Print Areas';
    function pick(withLabel) {
      return it.product.variants.filter(function (x) {
        if (!optHas(x, colour) || !optHas(x, size)) return false;
        if (withLabel && !optHas(x, withLabel)) return false;
        return true;
      })[0];
    }
    var v = (label && pick(label)) || pick(null);
    return v && typeof v.price === 'number' ? v.price / 100 : null;
  }
  function itemVariantPrice(it, size, areas) {
    var label = null;
    var opt = (it.product.options || []).filter(function (o) {
      return String(o.name).toLowerCase().indexOf('print area') > -1;
    })[0];
    if (opt) label = areas === 1 ? '1 Print Area' : areas + ' Print Areas';
    var v = it.product.variants.filter(function (x) {
      var o = [x.option1, x.option2, x.option3];
      if (o.indexOf(it.colour) < 0 || o.indexOf(size) < 0) return false;
      if (label && o.indexOf(label) < 0) return false;
      return true;
    })[0];
    return v && typeof v.price === 'number' ? v.price / 100 : null;
  }
  function priceAll() {
    syncItem();
    var q = allQty(), tier = tierFor(q), sub = 0, pieces = 0;
    S.items.forEach(function (it) {
      var areas = itemAreas(it);
      (it.colours || []).forEach(function (c) {
        Object.keys(c.qty || {}).forEach(function (size) {
          var n = c.qty[size] || 0;
          if (!n) return;
          var unit = itemVariantPriceFor(it, c.name, size, areas);
          if (unit == null) unit = CFG.basePrice / 100;
          sub += unit * n * (1 - tier.off);
          pieces += n;
        });
      });
    });
    return { q: q, tier: tier, sub: sub, each: pieces ? sub / pieces : 0, garments: S.items.length };
  }
  function priceNow() {
    var q = totalQty(), tier = tierFor(q), areas = Math.max(1, areasUsed());
    /* every line priced from its own variant, so the quote is whatever you
       set in Shopify admin for that size and that number of print areas */
    var sub = 0, counted = 0;
    Object.keys(S.qty).forEach(function (size) {
      var n = S.qty[size] || 0;
      if (!n) return;
      var unit = variantPriceFor(size, areas);
      if (unit == null) unit = anySizePrice(areas);
      sub += unit * n * (1 - tier.off);
      counted += n;
    });
    var each = counted ? sub / counted : anySizePrice(areas) * (1 - tier.off);
    return { q: q, tier: tier, areas: areas, each: each, sub: sub, unitBase: anySizePrice(areas) };
  }

  /* ---------- markup ---------- */
  function shell() {
    return ''
    + '<div class="skt-st__bar">'
    +   '<span class="skt-st__logo"><b>SASKATOON</b><em>TEES</em></span>'
    +   '<input class="skt-st__doc" id="sktDoc" value="Untitled design" aria-label="Design name">'
    +   '<div class="skt-st__tools">'
    +     '<button type="button" data-act="undo" class="skt-st__ic" title="Undo" aria-label="Undo">'
    +       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
    +       '<path d="M9 10H5V6"/><path d="M5 10a7 7 0 1 1 2 5"/></svg></button>'
    +     '<button type="button" data-act="redo" class="skt-st__ic" title="Redo" aria-label="Redo">'
    +       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
    +       '<path d="M15 10h4V6"/><path d="M19 10a7 7 0 1 0-2 5"/></svg></button>'
    +     '<button type="button" data-act="preview" class="skt-st__pv" id="sktPv">Preview</button>'
    +   '</div>'
    + '</div>'
    + '<div class="skt-st__canvas" id="sktCanvas">'
    +   '<div class="skt-st__stage" id="sktStage">'
    +     '<img class="skt-st__garment" id="sktGarment" alt="">'
    +     '<div class="skt-st__area" id="sktArea">'
    +       '<span class="skt-st__bound" id="sktBound"></span>'
    +       '<span class="skt-st__yoff" id="sktYoff"></span>'
    +       '<i class="skt-st__x skt-st__x--v"></i><i class="skt-st__x skt-st__x--h"></i>'
    +       '<i class="skt-st__g skt-st__g--v" id="sktGV"></i><i class="skt-st__g skt-st__g--h" id="sktGH"></i>'
    +     '</div>'
    +     '<div class="skt-st__empty" id="sktEmpty">'
    +       '<button type="button" class="is-primary" data-sheet="files">Add artwork</button>'
    +       '<button type="button" data-sheet="addtext">Add text</button>'
    +     '</div>'
    +   '</div>'
    + '</div>'
    + '<div class="skt-st__views" id="sktViews"></div>'
    + '<nav class="skt-st__toolbar" id="sktToolbar"></nav>'
    + '<div class="skt-st__cart">'
    +   '<div><div class="skt-st__price" id="sktPrice">$0.00</div><div class="skt-st__meta" id="sktMeta">No pieces yet</div></div>'
    +   '<button type="button" class="skt-st__save" id="sktSave">Save</button>'
    +   '<button type="button" class="skt-st__cta" id="sktCta" disabled>Add to cart</button>'
    + '</div>'
    + '<div class="skt-st__prog" id="sktProg">'
    +   '<div class="skt-st__progbox">'
    +     '<div class="skt-st__progt" id="sktProgT">Working…</div>'
    +     '<div class="skt-st__pbar"><i id="sktBar"></i></div>'
    +     '<div class="skt-st__steps" id="sktSteps"></div>'
    +   '</div>'
    + '</div>'
    + '<div class="skt-st__scrim" id="sktScrim"></div>'
    + '<div class="skt-st__sheet" id="sktSheet">'
    +   '<div class="skt-st__shead"><b id="sktSTitle"></b><span id="sktSSub"></span>'
    +     '<button type="button" class="skt-st__x2" id="sktSX" aria-label="Close">Close</button></div>'
    +   '<div class="skt-st__stabs" id="sktSTabs"></div>'
    +   '<div class="skt-st__sbody" id="sktSBody"></div>'
    +   '<div class="skt-st__sfoot" id="sktSFoot">'
    +     '<button type="button" class="skt-st__btn2" id="sktSCancel">Cancel</button>'
    +     '<button type="button" class="skt-st__btn" id="sktSApply">Apply changes</button>'
    +   '</div>'
    + '</div>'
    + '<input type="file" id="sktFile" accept="image/*" multiple hidden>';
  }

  /* ---------- stage ---------- */
  function drawStage() {
    var A = area(), el = $('#sktArea'), g = $('#sktGarment');
    var url = viewImage(S.view);
    if (url) {
      S.imgUsed = S.imgUsed || {};
      S.imgUsed[S.ai + ':' + S.view] = url;
      if (g.getAttribute('src') !== url) {
        g.onload = function () { fitStage(); renderLayers(); renderViews(); };
        g.src = url;
      }
      g.style.visibility = 'visible';
    } else { g.removeAttribute('src'); g.style.visibility = 'hidden'; }
    el.style.top = A.top + '%'; el.style.left = A.left + '%';
    el.style.width = A.width + '%'; el.style.height = A.height + '%';
    $('#sktBound').textContent = 'Placement boundary: ' + A.w.toFixed(1) + ' x ' + A.h.toFixed(1) + ' in';
    renderLayers();
  }
  function renderLayers() {
    var host = $('#sktArea');
    $$('.skt-st__l', host).forEach(function (n) { n.remove(); });
    var A = area(), PW = host.clientWidth, PH = host.clientHeight;
    L().forEach(function (l, i) {
      var el = document.createElement('div');
      el.className = 'skt-st__l' + (l.id === S.sel ? ' is-sel' : '');
      el.setAttribute('data-id', l.id);
      el.style.zIndex = 10 + i;
      el.style.left = (l.x / A.w * 100) + '%';
      el.style.top = (l.y / A.h * 100) + '%';
      var flip = ' scale(' + (l.fx || 1) + ',' + (l.fy || 1) + ')';
      if (l.type === 'image' || isBox(l)) {
        el.style.width = (l.w / A.w * 100) + '%';
        el.style.height = (l.h / A.h * 100) + '%';
        el.style.transform = 'rotate(' + (l.rot || 0) + 'deg)' + flip;
        el.innerHTML = l.type === 'image' ? '<img src="' + l.src + '" alt="">' : warpSVG(l);
      } else {
        el.style.transform = 'translate(-50%,-50%) rotate(' + (l.rot || 0) + 'deg)' + flip;
        el.innerHTML = '<div class="skt-st__tx" style="' + txtStyle(l, l.cap / A.h * PH * 1.38) + '">' + esc(l.text) + '</div>';
      }
      el.insertAdjacentHTML('beforeend',
        '<i class="skt-st__fr"></i><i class="skt-st__stem"></i>'
        + '<span class="skt-st__sz">' + fmt(l.w) + ' x ' + fmt(l.h) + ' in</span>'
        + '<button type="button" class="skt-st__kill" data-h="kill">&times;</button>'
        + '<i class="skt-st__h skt-st__h--rot" data-h="rot"></i>'
        + '<i class="skt-st__h skt-st__h--se" data-h="se"></i>'
        + '<i class="skt-st__h skt-st__h--sw" data-h="sw"></i>'
        + '<i class="skt-st__h skt-st__h--ne" data-h="ne"></i>'
        + '<i class="skt-st__h skt-st__h--nw" data-h="nw"></i>');
      host.appendChild(el);
      if (l.type === 'text' && !isBox(l)) { l.w = el.offsetWidth / PW * A.w; l.h = el.offsetHeight / PH * A.h; }
      wire(el, l);
    });
    host.classList.toggle('is-live', !!sel());
    $('#sktEmpty').style.display = L().length ? 'none' : 'flex';
    var s = sel();
    $('#sktYoff').style.display = s ? 'block' : 'none';
    if (s) $('#sktYoff').textContent = 'Y offset: ' + fmt(topOf(s)) + ' in';
  }
  function applyLive(el, l) {
    var A = area(), host = $('#sktArea'), PH = host.clientHeight, PW = host.clientWidth;
    el.style.left = (l.x / A.w * 100) + '%';
    el.style.top = (l.y / A.h * 100) + '%';
    var flip = ' scale(' + (l.fx || 1) + ',' + (l.fy || 1) + ')';
    if (l.type === 'image' || isBox(l)) {
      el.style.width = (l.w / A.w * 100) + '%';
      el.style.height = (l.h / A.h * 100) + '%';
      el.style.transform = 'rotate(' + (l.rot || 0) + 'deg)' + flip;
    } else {
      el.style.transform = 'translate(-50%,-50%) rotate(' + (l.rot || 0) + 'deg)' + flip;
      var tx = el.querySelector('.skt-st__tx');
      if (tx) tx.style.fontSize = (l.cap / A.h * PH * 1.38) + 'px';
      l.w = el.offsetWidth / PW * A.w;
      l.h = el.offsetHeight / PH * A.h;
    }
    var sz = el.querySelector('.skt-st__sz');
    if (sz) sz.textContent = fmt(l.w) + ' x ' + fmt(l.h) + ' in';
    var yo = $('#sktYoff');
    if (yo) yo.textContent = 'Y offset: ' + fmt(topOf(l)) + ' in';
  }

  function wire(el, l) {
    el.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-h="kill"]')) {
        snap();
        var ls0 = L(); ls0.splice(ls0.indexOf(l), 1); S.sel = null; render();
        return;
      }
      var h = e.target.closest('[data-h]');
      var mode = h ? h.getAttribute('data-h') : 'move';

      /* select WITHOUT re-rendering, or the node under the finger disappears */
      if (S.sel !== l.id) {
        S.sel = l.id;
        $$('.skt-st__l').forEach(function (n) {
          n.classList.toggle('is-sel', n.getAttribute('data-id') === String(l.id));
        });
        $('#sktArea').classList.add('is-live');
        $('#sktYoff').style.display = 'block';
        renderToolbar();
      }

      var A = area(), box = $('#sktArea').getBoundingClientRect();
      var pX = box.width / A.w, pY = box.height / A.h;
      var sx = e.clientX, sy = e.clientY;
      var o = { x: l.x, y: l.y, w: l.w, h: l.h, cap: l.cap, rot: l.rot || 0 };
      var cx = box.left + (isBox(l) ? (l.x + l.w / 2) : l.x) * pX;
      var cy = box.top + (isBox(l) ? (l.y + l.h / 2) : l.y) * pY;
      var d0 = Math.hypot(sx - cx, sy - cy) || 1;
      var a0 = Math.atan2(sy - cy, sx - cx);
      var moved = false;
      snap();
      e.preventDefault();
      e.stopPropagation();

      function mv(ev) {
        moved = true;
        if (ev.cancelable) ev.preventDefault();
        if (mode === 'move') {
          l.x = o.x + (ev.clientX - sx) / pX;
          l.y = o.y + (ev.clientY - sy) / pY;
          var mx = isBox(l) ? l.x + l.w / 2 : l.x, my = isBox(l) ? l.y + l.h / 2 : l.y;
          var sX = Math.abs(mx - A.w / 2) < 0.22, sY = Math.abs(my - A.h / 2) < 0.22;
          if (sX) l.x += (A.w / 2 - mx);
          if (sY) l.y += (A.h / 2 - my);
          $('#sktGV').style.display = sX ? 'block' : 'none';
          $('#sktGH').style.display = sY ? 'block' : 'none';
        } else if (mode === 'rot') {
          var deg = o.rot - ((a0 - Math.atan2(ev.clientY - cy, ev.clientX - cx)) * 180 / Math.PI);
          if (Math.abs(deg % 45) < 4 || Math.abs(deg % 45) > 41) deg = Math.round(deg / 45) * 45;
          l.rot = Math.round(deg);
        } else {
          var k = Math.max(0.06, Math.min(8, Math.hypot(ev.clientX - cx, ev.clientY - cy) / d0));
          if (isBox(l)) {
            var nw = o.w * k, nh = o.h * k;
            l.x = o.x - (nw - o.w) / 2;
            l.y = o.y - (nh - o.h) / 2;
            l.w = nw; l.h = nh;
          } else {
            l.cap = Math.max(0.2, o.cap * k);
          }
        }
        applyLive(el, l);
        priceUI();
      }
      function up() {
        document.removeEventListener('pointermove', mv);
        document.removeEventListener('pointerup', up);
        document.removeEventListener('pointercancel', up);
        $('#sktGV').style.display = 'none';
        $('#sktGH').style.display = 'none';
        if (!moved) S.hist.pop();
        render();
      }
      document.addEventListener('pointermove', mv, { passive: false });
      document.addEventListener('pointerup', up);
      document.addEventListener('pointercancel', up);
    });
  }

  /* ---------- view thumbnails, live ---------- */
  function renderViews() {
    var box = $('#sktViews');
    box.innerHTML = VIEWS.map(function (v) {
      var A = area(v.k), n = S.layers[v.k].length, url = viewImage(v.k);
      var inner = '';
      S.layers[v.k].forEach(function (l) {
        var flip = ' scale(' + (l.fx || 1) + ',' + (l.fy || 1) + ')';
        if (l.type === 'image' || isBox(l)) {
          inner += '<span class="skt-st__vl" style="left:' + (l.x / A.w * 100) + '%;top:' + (l.y / A.h * 100)
            + '%;width:' + (l.w / A.w * 100) + '%;height:' + (l.h / A.h * 100)
            + '%;transform:rotate(' + (l.rot || 0) + 'deg)' + flip + '">'
            + (l.type === 'image' ? '<img src="' + l.src + '" alt="">' : warpSVG(l)) + '</span>';
        } else {
          inner += '<span class="skt-st__vl" style="left:' + (l.x / A.w * 100) + '%;top:' + (l.y / A.h * 100)
            + '%;transform:translate(-50%,-50%) rotate(' + (l.rot || 0) + 'deg)' + flip + ';'
            + txtStyle(l, l.cap / A.h * (54 * A.height / 100) * 1.38) + '">' + esc(l.text) + '</span>';
        }
      });
      return '<button type="button" class="skt-st__v' + (v.k === S.view ? ' is-on' : '') + (n ? ' has' : '') + '" data-view="' + v.k + '">'
        + '<span class="skt-st__vt">' + (url ? '<img src="' + url + '" alt="">' : '')
        + '<span class="skt-st__vlayers" style="top:' + A.top + '%;left:' + A.left + '%;width:' + A.width + '%;height:' + A.height + '%">'
        + inner + '</span></span>'
        + '<span class="skt-st__vn">' + v.n + '</span>'
        + (n ? '<i class="skt-st__vc">' + n + '</i>' : '') + '</button>';
    }).join('');
  }

  /* ---------- toolbar ---------- */
  var ICON = {
    product:  '<path d="M8 3 5 4.5 2 6.5l1.6 3.2L6 8.6V21h12V8.6l2.4 1.1L22 6.5 19 4.5 16 3a4 4 0 0 1-8 0Z"/>',
    layers:   '<path d="M12 3 3 8l9 5 9-5-9-5Z"/><path d="M3 13l9 5 9-5"/>',
    files:    '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/>',
    text:     '<path d="M5 6V4h14v2M12 4v16M9 20h6"/>',
    size:     '<path d="M12 3v18M3 12h18"/><path d="m9 6 3-3 3 3M9 18l3 3 3-3M6 9l-3 3 3 3M18 9l3 3-3 3"/>',
    notes:    '<path d="M5 4h11l3 3v13H5z"/><path d="M8 10h8M8 14h6"/>',
    edit:     '<path d="M4 20h4l10-10-4-4L4 16v4Z"/><path d="m14 6 4 4"/>',
    style:    '<path d="m12 4 2.3 5.2 5.7.5-4.3 3.8 1.3 5.5L12 16.1 7 19l1.3-5.5L4 9.7l5.7-.5Z"/>',
    colours:  '<path d="M12 3a9 9 0 1 0 0 18c1 0 1.6-.7 1.6-1.5 0-.9-.8-1.4-.8-2.2 0-.8.7-1.4 1.5-1.4H16a5 5 0 0 0 5-5c0-4.4-4-8-9-8Z"/><circle cx="8" cy="10" r="1"/><circle cx="12" cy="7.5" r="1"/><circle cx="16" cy="10" r="1"/>',
    font:     '<path d="M4 19 10 5l6 14M6.5 14h7M18 19h3"/>',
    shape:    '<path d="M4 16c4-8 12-8 16 0"/>',
    centre:   '<path d="M12 3v18M4 12h16"/><rect x="8" y="8" width="8" height="8" rx="1"/>',
    replace:  '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.6"/><path d="m4 18 5-5 4 4 3-2 4 3"/>',
    flip:     '<path d="M12 3v18"/><path d="M9 7 4 12l5 5V7ZM15 7l5 5-5 5V7Z"/>',
    del:      '<path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/>'
  };
  function ico(k) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" '
      + 'stroke-linecap="round" stroke-linejoin="round">' + (ICON[k] || '') + '</svg>';
  }


  function renderToolbar() {
    var l = sel(), items = [
      { s: 'product', n: 'Pick sizes<br>and colour', i: 'product', key: 1 },
      { s: 'layers', n: 'Artwork<br>and layers', i: 'layers' }
    ];
    if (!l) {
      items.push({ s: 'files', n: 'Add<br>artwork', i: 'files' });
      items.push({ s: 'addtext', n: 'Add<br>text', i: 'text' });
      items.push({ s: 'notes', n: 'Notes', i: 'notes' });
    } else if (l.type === 'text') {
      items.push({ s: 'edittext', n: 'Edit<br>text', i: 'edit' });
      items.push({ s: 'style', n: 'Style', i: 'style' });
      items.push({ s: 'colours', n: 'Colours', i: 'colours' });
      items.push({ s: 'font', n: 'Font', i: 'font' });
      items.push({ s: 'shape', n: 'Shape', i: 'shape' });
      items.push({ a: 'centre', n: 'Center', i: 'centre' });
      items.push({ a: 'del', n: 'Delete', i: 'del', d: 1 });
    } else {
      items.push({ s: 'files', n: 'Replace', i: 'replace' });
      items.push({ s: 'transform', n: 'Size and<br>position', i: 'size' });
      items.push({ a: 'flip', n: 'Flip', i: 'flip' });
      items.push({ a: 'centre', n: 'Center', i: 'centre' });
      items.push({ a: 'del', n: 'Delete', i: 'del', d: 1 });
    }
    $('#sktToolbar').innerHTML = items.map(function (it) {
      return '<button type="button" class="' + (it.d ? 'is-danger' : (it.key ? 'is-key' : '')) + '" '
        + (it.s ? 'data-sheet="' + it.s + '"' : 'data-act="' + it.a + '"') + '>'
        + ico(it.i) + '<span>' + it.n + '</span></button>';
    }).join('');
  }

  /* ---------- sheets ---------- */
  var SHEETS = {
    product:   { t: 'Colour and sizes', foot: false },
    files:     { t: 'Files', foot: false },
    addtext:   { t: 'Add text', foot: true },
    layers:    { t: 'Artwork and layers', foot: false },
    transform: { t: 'Size and position', foot: false },
    edittext:  { t: 'Edit text', foot: true },
    style:     { t: 'Style', foot: true },
    colours:   { t: 'Colours', foot: true },
    font:      { t: 'Font', foot: true },
    shape:     { t: 'Shape', foot: true },
    notes:     { t: 'Notes for the designer', foot: true },
    approve:   { t: 'Approve your mockup', foot: false },
    catalogue: { t: 'Add another garment', foot: false },
    addcolour: { t: 'Add a colour', foot: false }
  };
  var restore = null;

  function openSheet(k) {
    var c = SHEETS[k];
    if (!c) return;
    S.sheet = k;
    $('#sktSTitle').textContent = c.t;
    $('#sktSSub').textContent = (k === 'product' || k === 'files' || k === 'notes') ? '' : '· ' + viewName();
    var foot = $('#sktSFoot');
    if (c.foot) {
      foot.innerHTML = '<button type="button" class="skt-st__btn2" id="sktSCancel">Cancel</button>'
        + '<button type="button" class="skt-st__btn" id="sktSApply">Apply changes</button>';
      foot.style.display = 'flex';
      bindFoot();
    } else if (k === 'approve') {
      foot.style.display = 'none';
    } else {
      var ready = allQty() > 0 && S.items.some(hasAnyLayer);
      foot.innerHTML = '<button type="button" class="skt-st__btn2" data-act="close">Back to design</button>'
        + (ready ? '<button type="button" class="skt-st__btn" id="sktSheetCart">Checkout</button>' : '');
      foot.style.display = 'flex';
      var cb = document.getElementById('sktSheetCart');
      if (cb) cb.addEventListener('click', function () { closeSheet(); addToCart(); });
    }
    restore = sel() ? JSON.stringify(sel()) : null;
    buildSheet(k);
    $('#sktScrim').classList.add('is-on');
    $('#sktSheet').classList.add('is-on');
  }
  function bindFoot() {
    var cn = document.getElementById('sktSCancel');
    if (cn) cn.onclick = function () {
      if (restore) {
        var o = JSON.parse(restore), ls = L(), i = ls.map(function (x) { return x.id; }).indexOf(o.id);
        if (i > -1) ls[i] = o;
      }
      closeSheet(); render();
    };
    var ap = document.getElementById('sktSApply');
    if (ap) ap.onclick = function () {
      if (S.sheet === 'addtext') {
        var tx = document.getElementById('sktTextNew');
        if (tx && tx.value.trim()) addText(tx.value.trim());
      }
      closeSheet(); render();
    };
  }
  /* the footer is built once when the sheet opens, so the Checkout button only
     turned up after closing and reopening. Re-check it whenever the numbers
     change, and only touch the DOM when it actually flips. */
  function syncSheetFoot() {
    if (!S.sheet) return;
    var c = SHEETS[S.sheet];
    if (!c || c.foot || S.sheet === 'approve') return;
    var foot = document.getElementById('sktSFoot');
    if (!foot) return;
    var ready = allQty() > 0 && S.items.some(hasAnyLayer);
    var has = !!document.getElementById('sktSheetCart');
    if (ready === has) return;
    foot.innerHTML = '<button type="button" class="skt-st__btn2" data-act="close">Back to design</button>'
      + (ready ? '<button type="button" class="skt-st__btn" id="sktSheetCart">Checkout</button>' : '');
    var cb = document.getElementById('sktSheetCart');
    if (cb) cb.addEventListener('click', function () { closeSheet(); addToCart(); });
  }

  function closeSheet() {
    S.sheet = null;
    $('#sktScrim').classList.remove('is-on');
    $('#sktSheet').classList.remove('is-on');
  }
  function viewName() { return VIEWS.filter(function (v) { return v.k === S.view; })[0].n; }

  function buildSheet(k) {
    var b = $('#sktSBody'), tabs = $('#sktSTabs');
    tabs.innerHTML = ''; tabs.style.display = 'none'; b.innerHTML = '';
    if (k === 'product') sheetProduct(b);
    if (k === 'files') sheetFiles(b, tabs);
    if (k === 'addtext') sheetAddText(b);
    if (k === 'layers') sheetLayers(b);
    if (k === 'transform') sheetTransform(b);
    if (k === 'edittext') sheetEditText(b);
    if (k === 'style') { harvestFonts(); ensureFonts(); sheetStyle(b); }
    if (k === 'colours') sheetColours(b);
    if (k === 'font') sheetFont(b);
    if (k === 'shape') sheetShape(b);
    if (k === 'notes') sheetNotes(b);
    if (k === 'approve') sheetApprove(b);
    if (k === 'catalogue') sheetCatalogue(b);
    if (k === 'addcolour') sheetAddColour(b);
  }

  function sheetProduct(b) {
    harvestSwatches();
    syncItem();
    var html = '';
    S.items.forEach(function (it, i) {
      var active = i === S.ai;
      html += '<div class="skt-st__item' + (active ? ' is-open' : '') + '" data-item="' + i + '">'
        + '<button type="button" class="skt-st__itemhd" data-openitem="' + i + '">'
        +   '<span class="th">' + (itemThumb(it) ? '<img src="' + itemThumb(it) + '" alt="">' : '') + '</span>'
        +   '<span class="nm"><b>' + esc(it.title) + '</b><small>'
        +     (it.colours || []).length + ((it.colours || []).length === 1 ? ' colour · ' : ' colours · ')
        +     itemQty(it) + (itemQty(it) === 1 ? ' piece' : ' pieces') + '</small></span>'
        +   (S.items.length > 1 ? '<span class="rm" data-removeitem="' + i + '">Remove</span>' : '')
        + '</button>';
      if (active) html += '<div class="skt-st__itembd" id="sktItemBody"></div>';
      html += '</div>';
    });
    if (CFG.allowMultipleProducts) {
      html += '<button type="button" class="skt-st__addmore" id="sktAddMore">+ Add another garment</button>';
    }
    b.innerHTML = html;
    paintItemBody();
    var am = document.getElementById('sktAddMore');
    if (am) am.addEventListener('click', function () { openSheet('catalogue'); });
    b.querySelectorAll('[data-openitem]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-removeitem]')) return;
        activate(parseInt(el.getAttribute('data-openitem'), 10));
        buildSheet('product');
      });
    });
    b.querySelectorAll('[data-removeitem]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        removeGarment(parseInt(el.getAttribute('data-removeitem'), 10));
      });
    });
  }
  function itemThumb(it) {
    var vs = it.product.variants.filter(function (x) { return optHas(x, it.colour); });
    for (var i = 0; i < vs.length; i++) {
      var im = it.images[vs[i].id] || it.images[String(vs[i].id)] || {};
      if (im.front && im.front !== 'null') return im.front;
    }
    return (vs[0] && vs[0].featured_image && vs[0].featured_image.src) || '';
  }
  function itemQty(it) { return itemPieces(it); }
  /* redraw the price numbers in place so the crossed out price and the tier
     highlight follow every keystroke, without stealing focus from the input */
  function refreshPrices() {
    var host = document.getElementById('sktItemBody');
    if (!host) return;
    var areas = Math.max(1, areasUsed());
    var liveTier = tierFor(allQty());
    host.querySelectorAll('.skt-st__size').forEach(function (cell) {
      var input = cell.querySelector('input[data-size]');
      if (!input) return;
      var s = input.getAttribute('data-size');
      var unit = variantPriceFor(s, areas);
      if (unit == null) unit = anySizePrice(areas);
      var now = unit * (1 - liveTier.off);
      var p0 = cell.querySelector('.p0'), p1 = cell.querySelector('.p1');
      if (liveTier.off) {
        if (!p0) {
          p0 = document.createElement('div'); p0.className = 'p0';
          cell.insertBefore(p0, p1);
        }
        p0.innerHTML = '<s>' + money(unit) + '</s>';
        if (p1) { p1.textContent = money(now); p1.classList.add('is-off'); }
      } else {
        if (p0) p0.remove();
        if (p1) { p1.textContent = money(unit); p1.classList.remove('is-off'); }
      }
    });
    var refUnit = anySizePrice(areas), i = 0;
    host.querySelectorAll('.skt-st__tier').forEach(function (row) {
      var tt = CFG.tiers[i++]; if (!tt) return;
      row.classList.toggle('is-on', tt.min === liveTier.min);
      var b = row.querySelector('b'); if (b) b.textContent = money(refUnit * (1 - tt.off));
    });
    var it2 = S.items[S.ai], ce2 = it2 ? colourEntry(it2, S.colour) : null;
    var cn = host.querySelector('.skt-st__col.is-open .skt-st__colhd .n');
    if (cn && ce2) { var cp = colPieces(ce2); cn.textContent = cp + (cp === 1 ? ' piece' : ' pieces'); }
    var hd = document.querySelector('.skt-st__item.is-open .skt-st__itemhd .nm small');
    if (hd && it2) {
      var n = itemPieces(it2);
      hd.textContent = (it2.colours || []).length + (it2.colours.length === 1 ? ' colour · ' : ' colours · ')
        + n + (n === 1 ? ' piece' : ' pieces');
    }
  }

  function paintItemBody() {
    var host = document.getElementById('sktItemBody');
    if (!host) return;
    var it = S.items[S.ai];
    var sizes = optionValues('Size');
    var areas = Math.max(1, areasUsed());
    var liveTier = tierFor(allQty());
    var html = '';

    /* nothing ordered yet: lead with the colour chart, sizes underneath */
    if (itemPieces(it) === 0) {
      var all = optionValues('Color');
      html += '<div class="skt-st__lbl">Choose your colour</div>'
        + '<div class="skt-st__colgrid skt-st__colgrid--chart">' + all.map(function (c) {
            return '<button type="button" class="skt-st__colpick' + (c === S.colour ? ' is-on' : '')
              + '" data-usecol="' + esc(c) + '"><span class="sw" style="' + colourSwatchStyle(c) + '"></span>'
              + '<span class="nm">' + esc(c) + '</span></button>';
          }).join('') + '</div>'
        + '<div class="skt-st__rule"></div>'
        + '<div class="skt-st__lbl">Sizes and quantity — <b>' + esc(S.colour || '') + '</b></div>'
        + '<div class="skt-st__sizes">';
      var ce0 = colourEntry(it, S.colour) || { qty: {} };
      sizes.forEach(function (s) {
        var unit = itemVariantPriceFor(it, S.colour, s, areas);
        if (unit == null) unit = anySizePrice(areas);
        var low = unit * (1 - CFG.tiers[CFG.tiers.length - 1].off);
        html += '<div class="skt-st__size">'
          + '<div class="t">' + esc(s) + '</div>'
          + '<div class="p1">' + money(unit) + '</div>'
          + '<div class="p2">' + money(low) + '</div>'
          + '<input type="number" min="0" value="' + (ce0.qty[s] || 0) + '" data-size="' + esc(s) + '">'
          + '</div>';
      });
      html += '</div>';
      var refUnit0 = anySizePrice(areas);
      html += '<div class="skt-st__tiers">' + CFG.tiers.map(function (tt) {
        return '<div class="skt-st__tier' + (tt.min === liveTier.min ? ' is-on' : '') + '"><span>'
          + tt.min + (tt.max >= 99999 ? '+' : ' to ' + tt.max) + ' pieces</span><b>'
          + money(refUnit0 * (1 - tt.off)) + '</b></div>';
      }).join('') + '</div>';
      html += '<button type="button" class="skt-st__addcol" id="sktAddCol">+ Add another colour</button>';
      html += '<p class="skt-st__note">Each colour keeps its own sizes.</p>';
      host.innerHTML = html;
      document.getElementById('sktAddCol').addEventListener('click', function () { openSheet('addcolour'); });
      host.querySelectorAll('[data-usecol]').forEach(function (el) {
        el.addEventListener('click', function () {
          var it2 = S.items[S.ai];
          /* still empty, so swap the colour rather than stacking a new block */
          if (itemPieces(it2) === 0) it2.colours = [{ name: el.getAttribute('data-usecol'), qty: {} }];
          useColour(el.getAttribute('data-usecol'));
          drawStage(); render(); buildSheet('product');
        });
      });
      return;
    }

    (it.colours || []).forEach(function (c, ci) {
      var open = c.name === S.colour;
      html += '<div class="skt-st__col' + (open ? ' is-open' : '') + '" data-colblock="' + ci + '">'
        + '<div class="skt-st__colhd" data-usecol="' + esc(c.name) + '">'
        +   '<span class="dot" style="' + colourSwatchStyle(c.name) + '"></span>'
        +   '<b>' + esc(c.name) + '</b>'
        +   '<span class="n">' + colPieces(c) + (colPieces(c) === 1 ? ' piece' : ' pieces') + '</span>'
        +   ((it.colours.length > 1) ? '<span class="rm" data-removecol="' + ci + '">Remove</span>' : '')
        + '</div>';
      if (open) {
        html += '<div class="skt-st__sizes">';
        sizes.forEach(function (s) {
          var unit = itemVariantPriceFor(it, c.name, s, areas);
          if (unit == null) unit = anySizePrice(areas);
          var now = unit * (1 - liveTier.off);
          var low = unit * (1 - CFG.tiers[CFG.tiers.length - 1].off);
          var priceRow = liveTier.off
            ? '<div class="p0"><s>' + money(unit) + '</s></div><div class="p1 is-off">' + money(now) + '</div>'
            : '<div class="p1">' + money(unit) + '</div>';
          html += '<div class="skt-st__size' + ((c.qty[s] || 0) > 0 ? ' has' : '') + '">'
            + '<div class="t">' + esc(s) + '</div>' + priceRow
            + '<div class="p2">' + money(low) + '</div>'
            + '<input type="number" min="0" value="' + (c.qty[s] || 0) + '" data-size="' + esc(s) + '">'
            + '</div>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    html += '<button type="button" class="skt-st__addcol" id="sktAddCol">+ Add another colour</button>';

    var p = priceNow(), refUnit = anySizePrice(areas);
    html += '<div class="skt-st__tiers">' + CFG.tiers.map(function (tt) {
      var on = tt.min === liveTier.min ? ' is-on' : '';
      return '<div class="skt-st__tier' + on + '"><span>' + tt.min + (tt.max >= 99999 ? '+' : ' to ' + tt.max)
        + ' pieces</span><b>' + money(refUnit * (1 - tt.off)) + '</b></div>';
    }).join('') + '</div>';
    var ta2 = turnaround();
    html += '<p class="skt-st__note">Prices are for ' + areas + (areas === 1 ? ' print area' : ' print areas')
      + '. Volume pricing counts every colour together.</p>'
      + '<p class="skt-st__ship"><b>Ready ' + ta2.text + '</b> · '
      + (CFG.turnaroundMin || 2) + ' to ' + (CFG.turnaroundMax || 5) + ' business days · '
      + 'rush? call <a href="tel:' + (CFG.phone || '306-290-5120').replace(/[^0-9+]/g, '') + '">'
      + (CFG.phone || '306-290-5120') + '</a></p>';
    host.innerHTML = html;

    host.querySelectorAll('[data-usecol]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-removecol]')) return;
        useColour(el.getAttribute('data-usecol'));
        drawStage(); render(); buildSheet('product');
      });
    });
    host.querySelectorAll('[data-removecol]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        removeColour(parseInt(el.getAttribute('data-removecol'), 10));
      });
    });
    document.getElementById('sktAddCol').addEventListener('click', function () { openSheet('addcolour'); });
  }
  function colPieces(c) {
    var n = 0; Object.keys(c.qty || {}).forEach(function (k) { n += c.qty[k] || 0; }); return n;
  }

  function sheetAddColour(b) {
    var it = S.items[S.ai];
    var taken = (it.colours || []).map(function (c) { return c.name; });
    var list = optionValues('Color').filter(function (c) { return taken.indexOf(c) < 0; });
    if (!list.length) {
      b.innerHTML = '<p class="skt-st__note">Every colour is already in your order.</p>';
      return;
    }
    b.innerHTML = '<p class="skt-st__note" style="margin:0 0 12px">Pick a colour to add. It gets its own sizes.</p>'
      + '<div class="skt-st__colgrid">' + list.map(function (c) {
          return '<button type="button" class="skt-st__colpick" data-addcol="' + esc(c) + '">'
            + '<span class="sw" style="' + colourSwatchStyle(c) + '"></span>'
            + '<span class="nm">' + esc(c) + '</span></button>';
        }).join('') + '</div>';
    b.querySelectorAll('[data-addcol]').forEach(function (el) {
      el.addEventListener('click', function () {
        useColour(el.getAttribute('data-addcol'));
        closeSheet();
        drawStage(); render();
        openSheet('product');
      });
    });
  }

  function sheetCatalogue(b) {
    b.innerHTML = '<div class="skt-st__cattabs" id="sktCatTabs"></div>'
      + '<div class="skt-st__catsearch"><input type="search" id="sktCatQ" placeholder="Search for a product"'
      + ' value="' + esc(CATQ) + '" autocomplete="off"></div>'
      + '<div class="skt-st__cat" id="sktCat"><div class="skt-st__catload">Loading the catalogue…</div></div>';

    var qEl = document.getElementById('sktCatQ');
    qEl.addEventListener('input', function () { CATQ = this.value; paintCat(); });

    loadCollections().then(function (cols) {
      var tabs = document.getElementById('sktCatTabs');
      if (!tabs) return;
      var all = [{ handle: 'all', title: 'All products' }].concat(cols.map(function (c) {
        return { handle: c.handle, title: c.title };
      }));
      tabs.innerHTML = all.map(function (c) {
        return '<button type="button" class="' + (CATTAB === c.handle ? 'is-on' : '') + '" data-cat="'
          + esc(c.handle) + '">' + esc(c.title) + '</button>';
      }).join('');
      tabs.querySelectorAll('[data-cat]').forEach(function (el) {
        el.addEventListener('click', function () {
          CATTAB = el.getAttribute('data-cat');
          tabs.querySelectorAll('[data-cat]').forEach(function (x) { x.classList.remove('is-on'); });
          el.classList.add('is-on');
          paintCat();
        });
      });
    });
    paintCat();
  }
  function paintCat() {
    var host = document.getElementById('sktCat');
    if (!host) return;
    host.innerHTML = '<div class="skt-st__catload">Loading…</div>';
    loadCatalogue(CATTAB).then(function (list) {
      if (!document.getElementById('sktCat')) return;
      var q = CATQ.trim().toLowerCase();
      var shown = list.filter(function (pr) {
        if (!q) return true;
        return (pr.title + ' ' + (pr.vendor || '') + ' ' + (pr.product_type || '')).toLowerCase().indexOf(q) > -1;
      });
      if (!shown.length) {
        host.innerHTML = '<p class="skt-st__note" style="grid-column:1/-1;text-align:center">Nothing matches that.</p>';
        return;
      }
      host.innerHTML = shown.map(function (pr) {
        var img = (pr.images && pr.images[0] && pr.images[0].src) || '';
        var from = pr.variants && pr.variants[0] ? pr.variants[0].price : null;
        var colours = ((pr.options || []).filter(function (o) {
          return String(o.name || o).toLowerCase().indexOf('col') === 0;
        })[0] || {}).values || [];
        return '<button type="button" class="skt-st__ccard" data-add="' + esc(pr.handle) + '">'
          + '<span class="im">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="ti">' + esc(pr.title) + '</span>'
          + (pr.vendor ? '<span class="vn">' + esc(pr.vendor) + '</span>' : '')
          + (colours.length ? '<span class="cc">' + colours.length + ' colours</span>' : '')
          + (from ? '<span class="pr">from $' + parseFloat(from).toFixed(2) + '</span>' : '')
          + '</button>';
      }).join('');
      host.querySelectorAll('[data-add]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeSheet();
          addGarment(el.getAttribute('data-add')).then(function () { openSheet('product'); });
        });
      });
    });
  }

  function sheetFiles(b, tabs) {
    tabs.style.display = 'flex';
    tabs.innerHTML = '<button type="button" class="' + (S.ftab === 'library' ? 'is-on' : '') + '" data-ftab="library">Library</button>'
      + '<button type="button" class="' + (S.ftab === 'upload' ? 'is-on' : '') + '" data-ftab="upload">Upload</button>';
    if (S.ftab === 'upload' || !S.assets.length) {
      b.innerHTML = '<div class="skt-st__drop" id="sktDrop">'
        + '<b>Add your artwork</b>'
        + '<p>Drop a file here or choose one. Transparent PNG at 300 dpi prints sharpest. Max 50 MB.</p>'
        + '<button type="button" class="skt-st__btn" data-act="pick">Choose a file</button>'
        + '<a class="skt-st__help" href="' + CFG.designHelpUrl + '" target="_blank" rel="noopener">Need design help?</a></div>';
      var d = $('#sktDrop');
      ['dragenter', 'dragover'].forEach(function (v) { d.addEventListener(v, function (e) { e.preventDefault(); d.classList.add('hot'); }); });
      ['dragleave', 'drop'].forEach(function (v) { d.addEventListener(v, function (e) { e.preventDefault(); d.classList.remove('hot'); }); });
      d.addEventListener('drop', function (e) { takeFiles(e.dataTransfer.files); });
      return;
    }
    b.innerHTML = '<div class="skt-st__assets">' + S.assets.map(function (a, i) {
      return '<button type="button" class="skt-st__asset" data-asset="' + i + '">'
        + '<img src="' + a.src + '" alt=""><span>' + (a.w / 300).toFixed(1) + ' in max</span></button>';
    }).join('') + '</div><button type="button" class="skt-st__btn2 full" data-act="pick">Upload another</button>';
  }

  function sheetAddText(b) {
    b.innerHTML = '<div class="skt-st__lbl">Your text</div>'
      + '<textarea class="skt-st__in" id="sktTextNew" placeholder="Type it here"></textarea>'
      + '<p class="skt-st__note">Printing on the ' + viewName().toLowerCase() + ', '
      + area().w.toFixed(1) + ' x ' + area().h.toFixed(1) + ' in area.</p>';
    setTimeout(function () { var t = $('#sktTextNew'); if (t) t.focus(); }, 60);
  }
  function sheetEditText(b) {
    var l = sel(); if (!l) return;
    b.innerHTML = '<div class="skt-st__lbl">Edit text</div><textarea class="skt-st__in" id="sktTextEdit">' + esc(l.text) + '</textarea>';
    $('#sktTextEdit').addEventListener('input', function () { l.text = this.value; renderLayers(); renderViews(); });
  }
  function sheetNotes(b) {
    b.innerHTML = '<div class="skt-st__lbl">Notes for the designer</div>'
      + '<textarea class="skt-st__in" id="sktNotes" placeholder="Deadline, colours, placement, anything else.">' + esc(S.notes) + '</textarea>';
    $('#sktNotes').addEventListener('input', function () { S.notes = this.value; });
  }

  function sheetStyle(b) {
    var l = sel(); if (!l) return;
    b.innerHTML = '<div class="skt-st__tiles">' + STYLES.map(function (s) {
      var p = JSON.parse(JSON.stringify(l)); s.a(p);
      return '<button type="button" class="skt-st__tile' + (l.style === s.k ? ' is-on' : '') + '" data-style="' + s.k + '">'
        + '<span class="pv"><span style="' + txtStyle(p, 22) + '">' + esc((l.text || 'Add text').split('\n')[0].slice(0, 10)) + '</span></span>'
        + '<span class="nm">' + s.n + '</span></button>';
    }).join('') + '</div>';
  }
  function sheetShape(b) {
    var l = sel(); if (!l) return;
    b.innerHTML = '<div class="skt-st__lbl">Warp effect</div><div class="skt-st__tiles">' + WARPS.map(function (w) {
      var p = JSON.parse(JSON.stringify(l)); p.warp = w.k;
      var inner = (w.k === 'normal' || w.k === 'slant')
        ? '<span style="' + txtStyle(p, 20) + '">' + esc((l.text || 'Add text').split('\n')[0].slice(0, 9)) + '</span>'
        : warpSVG(p);
      return '<button type="button" class="skt-st__tile' + ((l.warp || 'normal') === w.k ? ' is-on' : '') + '" data-warp="' + w.k + '">'
        + '<span class="pv">' + inner + '</span><span class="nm">' + w.n + '</span></button>';
    }).join('') + '</div>'
      + '<div class="skt-st__lbl" style="margin-top:14px">Intensity</div>'
      + '<input type="range" min="0" max="100" value="' + (l.intensity == null ? 50 : l.intensity) + '" data-prop="intensity">';
  }
  function sheetColours(b) {
    var l = sel(); if (!l) return;
    b.innerHTML = '<div class="skt-st__row3">'
      + '<div><div class="skt-st__lbl">Text colour</div><input type="color" value="' + (l.colour || '#FFD300') + '" data-prop="colour"></div>'
      + '<div><div class="skt-st__lbl">Outline colour</div><input type="color" value="' + (l.outline || '#111111') + '" data-prop="outline"></div>'
      + '<div><div class="skt-st__lbl">Outline width</div><input type="number" min="0" max="20" value="' + (l.outlineW || 0) + '" data-prop="outlineW" class="skt-st__in"></div>'
      + '</div><button type="button" class="skt-st__btn2 full" data-act="nooutline">No outline</button>';
  }
  function sheetFont(b) {
    var l = sel(); if (!l) return;
    harvestFonts();
    ensureFonts();
    b.innerHTML = '<div class="skt-st__row2">'
      + '<div><div class="skt-st__lbl">Cap height, inches</div>'
      + '<input class="skt-st__in" type="number" step="0.25" min="0.25" value="' + fmt(l.cap) + '" data-prop="cap"></div>'
      + '<div><div class="skt-st__lbl">Weight</div><select class="skt-st__in" data-prop="weight">'
      + [400, 700, 900].map(function (w) {
          return '<option value="' + w + '"' + (l.weight == w ? ' selected' : '') + '>'
            + (w === 400 ? 'Regular' : w === 700 ? 'Bold' : 'Black') + '</option>';
        }).join('') + '</select></div></div>'
      + '<div class="skt-st__row3">'
      + '<div><div class="skt-st__lbl">Style</div><select class="skt-st__in" data-prop="italic">'
      + '<option value="0"' + (!l.italic ? ' selected' : '') + '>Normal</option>'
      + '<option value="1"' + (l.italic ? ' selected' : '') + '>Italic</option></select></div>'
      + '<div><div class="skt-st__lbl">Align</div><select class="skt-st__in" data-prop="align">'
      + ['left', 'center', 'right'].map(function (a) {
          return '<option value="' + a + '"' + ((l.align || 'center') === a ? ' selected' : '') + '>' + a + '</option>';
        }).join('') + '</select></div>'
      + '<div><div class="skt-st__lbl">Line height</div>'
      + '<input class="skt-st__in" type="number" step="0.05" min="0.8" max="2.5" value="' + (l.lh || 1.1) + '" data-prop="lh"></div>'
      + '</div>'
      + '<div class="skt-st__lbl">Letter spacing</div>'
      + '<input type="range" min="-5" max="40" value="' + (l.ls || 0) + '" data-prop="ls">'
      + '<div class="skt-st__lbl" style="margin-top:14px">Font</div>'
      + '<input class="skt-st__in" id="sktFontQ" type="search" placeholder="Search fonts" value="' + esc(FONT_Q) + '" autocomplete="off">'
      + '<div class="skt-st__fonts" id="sktFonts"></div>';
    document.getElementById('sktFontQ').addEventListener('input', function () {
      FONT_Q = this.value; paintFonts();
    });
    paintFonts();
  }
  function paintFonts() {
    var host = document.getElementById('sktFonts'), l = sel();
    if (!host || !l) return;
    var q = FONT_Q.trim().toLowerCase();
    var list = FONTS.filter(function (n) { return !q || n.toLowerCase().indexOf(q) > -1; });
    if (!list.length) { host.innerHTML = '<p class="skt-st__note">No font by that name.</p>'; return; }
    host.innerHTML = list.map(function (n) {
      return '<button type="button" class="skt-st__font' + (n === l.font ? ' is-on' : '') + '" data-setfont="'
        + esc(n) + '" style="font-family:\'' + n + '\',sans-serif">' + esc(n) + '</button>';
    }).join('');
    host.querySelectorAll('[data-setfont]').forEach(function (el) {
      el.addEventListener('click', function () {
        var lay = sel(); if (!lay) return;
        lay.font = el.getAttribute('data-setfont');
        host.querySelectorAll('.skt-st__font').forEach(function (x) { x.classList.remove('is-on'); });
        el.classList.add('is-on');
        renderLayers(); renderViews();
      });
    });
  }

  function sheetLayers(b) {
    var ls = L();
    var h = '<div class="skt-st__ltop"><b>' + viewName() + '</b><span>' + ls.length + (ls.length === 1 ? ' layer' : ' layers') + '</span>'
      + '<button type="button" class="skt-st__mini" data-sheet="addtext">Add text</button>'
      + '<button type="button" class="skt-st__mini" data-sheet="files">Add artwork</button>'
      + '<button type="button" class="skt-st__mini" data-act="clear">Delete all</button></div>';
    if (!ls.length) h += '<p class="skt-st__note">Nothing on the ' + viewName().toLowerCase() + ' yet.</p>';
    h += ls.slice().reverse().map(function (l) {
      var warn = '';
      if (l.type === 'image') {
        var d = dpiOf(l);
        warn = d < 150 ? '<i class="bad">' + d + ' dpi, too soft</i>'
             : d < 250 ? '<i class="warn">' + d + ' dpi</i>'
             : '<i class="ok">' + d + ' dpi</i>';
      }
      return '<div class="skt-st__lay' + (l.id === S.sel ? ' is-sel' : '') + '" data-layer="' + l.id + '">'
        + '<span class="th">' + (l.type === 'image' ? '<img src="' + l.src + '" alt="">' : 'T') + '</span>'
        + '<span class="nm">' + esc(l.type === 'image' ? l.name : l.text.split('\n')[0]) + '<small>'
        + fmt(l.w) + ' x ' + fmt(l.h) + ' in ' + warn + '</small></span>'
        + '<button type="button" class="rm" data-dellayer="' + l.id + '">&times;</button></div>';
    }).join('');
    b.innerHTML = h;
  }
  function sheetTransform(b) {
    var l = sel(), A = area();
    if (!l) { b.innerHTML = '<p class="skt-st__note">Select something on the garment first.</p>'; return; }
    var t = l.type === 'text' && !isBox(l);
    b.innerHTML = '<div class="skt-st__row2">'
      + '<div><div class="skt-st__lbl">Across, inches</div><input class="skt-st__in" type="number" step="0.25" value="' + fmt(leftOf(l)) + '" data-prop="px"></div>'
      + '<div><div class="skt-st__lbl">Y offset, inches</div><input class="skt-st__in" type="number" step="0.25" value="' + fmt(topOf(l)) + '" data-prop="py"></div>'
      + '</div><div class="skt-st__row2">'
      + (t ? '<div><div class="skt-st__lbl">Cap height</div><input class="skt-st__in" type="number" step="0.25" value="' + fmt(l.cap) + '" data-prop="cap"></div>'
           : '<div><div class="skt-st__lbl">Width, inches</div><input class="skt-st__in" type="number" step="0.25" value="' + fmt(l.w) + '" data-prop="w"></div>')
      + '<div><div class="skt-st__lbl">Rotation</div><input class="skt-st__in" type="number" step="1" value="' + (l.rot || 0) + '" data-prop="rot"></div>'
      + '</div><div class="skt-st__row3">'
      + '<button type="button" class="skt-st__btn2" data-act="centre">Centre</button>'
      + '<button type="button" class="skt-st__btn2" data-act="fit">Fit area</button>'
      + '<button type="button" class="skt-st__btn2" data-act="flip">Flip</button>'
      + '</div>';
  }

  function sheetApprove(b) {
    var list = (S.proofs || []);
    if (!list.length) {
      b.innerHTML = '<p class="skt-st__note">Could not build the mockup from this photo. You can still order, we will send you a proof by email before printing.</p>'
        + '<button type="button" class="skt-st__btn" data-act="approveAnyway">Add to cart anyway</button>';
      return;
    }
    b.innerHTML = '<p class="skt-st__note" style="margin:0 0 12px">Here is your design on each colour. Have a look at the placement and the spelling before you order. Screen colours can differ a little from the printed result.</p>'
      + '<div class="skt-st__proofs">' + list.map(function (x) {
          var cap = (x.colour ? x.colour + ' · ' : '') + x.v.n;
          return '<figure><img src="' + x.data + '" alt="' + cap + ' mockup"><figcaption>' + esc(cap) + '</figcaption></figure>';
        }).join('') + '</div>'
      + '<p class="skt-st__ship"><b>Ready ' + turnaround().text + '</b> · '
      + (CFG.turnaroundMin || 2) + ' to ' + (CFG.turnaroundMax || 5) + ' business days · '
      + 'need it sooner? call <a href="tel:' + (CFG.phone || '306-290-5120').replace(/[^0-9+]/g, '') + '">'
      + (CFG.phone || '306-290-5120') + '</a></p>'
      + '<label class="skt-st__ok"><input type="checkbox" id="sktOk"> I have checked the placement and the spelling</label>'
      + '<button type="button" class="skt-st__btn" id="sktApprove" disabled>Looks good, add to cart</button>'
      + '<button type="button" class="skt-st__btn2 full" data-act="close">Keep editing</button>';
    $('#sktOk').addEventListener('change', function () { $('#sktApprove').disabled = !this.checked; });
    $('#sktApprove').addEventListener('click', function () {
      S.approved = true; closeSheet(); addToCart();
    });
  }

  function hasAnyLayer(it) {
    return ['front', 'back', 'left', 'right'].some(function (k) {
      return it.layers && it.layers[k] && it.layers[k].length;
    });
  }
  var PROG = { steps: [], at: -1 };
  function progStart(steps) {
    PROG.steps = steps; PROG.at = -1;
    var p = $('#sktProg');
    if (!p) return;
    $('#sktSteps').innerHTML = steps.map(function (s, i) {
      return '<div class="skt-st__step" data-i="' + i + '"><i></i><span>' + s + '</span></div>';
    }).join('');
    p.classList.add('is-on');
    progNext(0);
  }
  function progNext(i, label) {
    PROG.at = i;
    var t2 = $('#sktProgT'); if (t2) t2.textContent = label || PROG.steps[i] || 'Working…';
    var bar = $('#sktBar');
    if (bar) bar.style.width = Math.round(((i + 0.4) / Math.max(1, PROG.steps.length)) * 100) + '%';
    $$('.skt-st__step').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-i'), 10);
      el.classList.toggle('is-done', n < i);
      el.classList.toggle('is-now', n === i);
    });
  }
  function progDone() {
    var bar = $('#sktBar'); if (bar) bar.style.width = '100%';
    var p = $('#sktProg'); if (p) setTimeout(function () { p.classList.remove('is-on'); }, 250);
  }

  /* ---------- price UI ---------- */
  /* prices move as they type, without rebuilding the panel under their cursor */
  function repriceCells() {
    var host = document.getElementById('sktItemBody');
    if (!host) return;
    var areas = Math.max(1, areasUsed());
    var tier = tierFor(allQty());
    $$('.skt-st__size', host).forEach(function (cell) {
      var input = cell.querySelector('input[data-size]');
      if (!input) return;
      var size = input.getAttribute('data-size');
      var unit = variantPriceFor(size, areas);
      if (unit == null) unit = anySizePrice(areas);
      var now = unit * (1 - tier.off);
      var p0 = cell.querySelector('.p0'), p1 = cell.querySelector('.p1');
      if (tier.off) {
        if (!p0) {
          p0 = document.createElement('div');
          p0.className = 'p0';
          cell.insertBefore(p0, p1);
        }
        p0.innerHTML = '<s>' + money(unit) + '</s>';
        if (p1) { p1.textContent = money(now); p1.classList.add('is-off'); }
      } else {
        if (p0) p0.remove();
        if (p1) { p1.textContent = money(unit); p1.classList.remove('is-off'); }
      }
    });
    $$('.skt-st__tier', host).forEach(function (row, i) {
      row.classList.toggle('is-on', CFG.tiers[i] && CFG.tiers[i].min === tier.min);
    });
    var note = host.querySelector('.skt-st__breaknote');
    if (note) {
      var next = CFG.tiers.filter(function (x) { return x.min > allQty(); })[0];
      note.textContent = next
        ? 'Add ' + (next.min - allQty()) + ' more to reach ' + Math.round(next.off * 100) + '% off'
        : 'Best price unlocked';
      note.className = 'skt-st__breaknote' + (next ? '' : ' is-best');
    }
  }

  function priceUI() {
    var p = priceAll();
    var anyArt = S.items.some(function (it) { return itemAreas(it) && hasAnyLayer(it); });
    var ready = p.q > 0 && anyArt;
    $('#sktPrice').textContent = p.q ? money(p.sub) : '$0.00';
    var bits = [];
    if (p.q) bits.push(p.q + ' pieces');
    if (S.items.length > 1) bits.push(S.items.length + ' garments');
    if (areasUsed()) bits.push(areasUsed() + (areasUsed() === 1 ? ' print area' : ' print areas'));
    if (p.tier.off) bits.push(Math.round(p.tier.off * 100) + '% off');
    $('#sktMeta').textContent = p.q ? bits.join(' · ') + ' · ' + money(p.each) + ' each' : 'Pick your sizes to continue';
    var cta = $('#sktCta');
    cta.disabled = S.busy;
    cta.classList.toggle('is-next', !ready && !S.busy);
    cta.textContent = S.busy ? 'Uploading artwork…'
      : !p.q ? 'Pick sizes'
      : !anyArt ? 'Add artwork to continue'
      : pendingUploads() ? 'Uploading artwork…'
      : 'Add to cart';
  }

  /* ---------- cart ---------- */


  /* ============================================================
     VECTOR PRINT FILE
     One SVG per printed side, drawn at true size in inches, so the
     press gets sharp text instead of a screenshot. 100 units = 1 inch.
     ============================================================ */
  function svgEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&apos;');
  }
  /* On screen the browser aligns each line inside a block that is centred on the
     layer. The proof and the print file drew every line centred instead, so a
     left or right justified block came out centred. Same block, same offsets. */
  function lineOffsets(ctx, lines, align) {
    var w = lines.map(function (t) { return ctx.measureText(t).width; });
    var max = 0;
    w.forEach(function (n) { if (n > max) max = n; });
    var a = align || 'center';
    return w.map(function (n) {
      if (a === 'left') return (n - max) / 2;
      if (a === 'right') return (max - n) / 2;
      return 0;
    });
  }
  function measureCtx(l, fs) {
    var c = document.createElement('canvas'), x = c.getContext('2d');
    x.font = (l.italic ? 'italic ' : '') + (l.weight || 900) + ' ' + fs + "px '" + l.font + "', sans-serif";
    try { x.letterSpacing = ((l.ls || 0) / 100) + 'em'; } catch (e) {}
    return x;
  }

  function buildVector(viewKey) {
    var ls = S.layers[viewKey] || [];
    if (!ls.length) return null;
    var A = area(viewKey), U = 100;
    var W = A.w * U, H = A.h * U;
    var defs = '', body = '', uid = 0;

    ls.forEach(function (l) {
      uid++;
      if (l.type === 'image') {
        /* with no link this used to fall back to the whole photo as base64,
           which made the svg too big to upload, so the print file went missing
           as well as the artwork. Draw the gap instead. */
        var href = isUrl(l.serverUrl) ? l.serverUrl : null;
        if (!href) {
          var mx = l.x * U, my = l.y * U, mw = l.w * U, mh = l.h * U;
          body += '\n  <rect x="' + mx + '" y="' + my + '" width="' + mw + '" height="' + mh
               + '" fill="none" stroke="#EF4444" stroke-width="6" stroke-dasharray="20 14"/>'
               + '\n  <text x="' + (mx + mw / 2) + '" y="' + (my + mh / 2) + '" text-anchor="middle"'
               + ' font-family="sans-serif" font-size="' + Math.max(40, mh * 0.08) + '" fill="#EF4444">'
               + svgEsc('ARTWORK MISSING: ' + (l.name || 'unnamed file')) + '</text>';
          return;
        }
        var x0 = l.x * U, y0 = l.y * U, w0 = l.w * U, h0 = l.h * U;
        var tr = 'rotate(' + (l.rot || 0) + ' ' + (x0 + w0 / 2) + ' ' + (y0 + h0 / 2) + ')';
        if ((l.fx || 1) === -1 || (l.fy || 1) === -1) {
          tr += ' translate(' + (x0 + w0 / 2) + ' ' + (y0 + h0 / 2) + ') scale('
             + (l.fx || 1) + ',' + (l.fy || 1) + ') translate(' + (-(x0 + w0 / 2)) + ' ' + (-(y0 + h0 / 2)) + ')';
        }
        body += '\n  <image href="' + svgEsc(href) + '" xlink:href="' + svgEsc(href) + '" x="' + x0 + '" y="' + y0
             + '" width="' + w0 + '" height="' + h0 + '" preserveAspectRatio="none" transform="' + tr + '"/>';
        return;
      }

      var fill = l.hollow ? 'none' : (l.colour || '#000000');
      var stroke = (l.outline && l.outlineW)
        ? ' stroke="' + l.outline + '" stroke-width="' + ((l.outlineW / 100) * (l.cap * 1.38 * U)) + '" paint-order="stroke"'
        : '';
      var common = 'font-family="' + svgEsc(l.font) + '" font-weight="' + (l.weight || 900) + '"'
        + (l.italic ? ' font-style="italic"' : '')
        + ' letter-spacing="' + ((l.ls || 0) / 100) + 'em" fill="' + fill + '"' + stroke;
      var warp = l.warp || 'normal';

      if (warp === 'normal' || warp === 'slant') {
        var fs = l.cap * 1.38 * U;
        var cx = l.x * U, cy = l.y * U;
        var lines = String(l.text || '').split('\n');
        var lineH = fs * (l.lh || 1.1);
        var start = cy - ((lines.length - 1) * lineH) / 2;
        var tr2 = 'rotate(' + (l.rot || 0) + ' ' + cx + ' ' + cy + ')';
        if (warp === 'slant') {
          var sk = Math.round((l.intensity == null ? 50 : l.intensity) * 0.22);
          tr2 += ' translate(' + cx + ' ' + cy + ') skewX(-' + sk + ') translate(' + (-cx) + ' ' + (-cy) + ')';
        }
        var offs = lineOffsets(measureCtx(l, fs), lines, l.align);
        body += '\n  <text ' + common + ' font-size="' + fs + '" text-anchor="middle" dominant-baseline="central"'
             + ' transform="' + tr2 + '">';
        lines.forEach(function (line, i) {
          body += '<tspan x="' + (cx + offs[i]) + '" y="' + (start + i * lineH) + '">' + svgEsc(line) + '</tspan>';
        });
        body += '</text>';
        return;
      }

      /* warped: same 400 x 200 space the studio draws in, mapped onto the box */
      var bw = l.w * U, bh = l.h * U;
      var sc = Math.min(bw / 400, bh / 200);
      var ox = (l.x + l.w / 2) * U, oy = (l.y + l.h / 2) * U;
      var pid = 'skt' + viewKey + uid;
      var path;
      if (warp === 'circle') {
        path = 'M 200 190 A 90 90 0 1 1 200 10 A 90 90 0 1 1 200 190';
      } else if (warp === 'wave') {
        var iw = (l.intensity == null ? 50 : l.intensity) / 100;
        path = 'M 20 100 C 110 ' + (100 - 60 * iw) + ' 190 ' + (100 + 60 * iw)
             + ' 290 100 C 340 ' + (100 - 30 * iw) + ' 370 100 380 100';
      } else {
        var g = arcGeometry(l.intensity, 180);
        var chord = warp === 'arcup' ? 100 + g.sag / 2 : 100 - g.sag / 2;
        path = 'M 20 ' + chord + ' A ' + g.r + ' ' + g.r + ' 0 0 ' + (warp === 'arcup' ? 1 : 0) + ' 380 ' + chord;
      }
      defs += '\n    <path id="' + pid + '" d="' + path + '" fill="none"/>';
      body += '\n  <g transform="rotate(' + (l.rot || 0) + ' ' + ox + ' ' + oy + ') translate(' + ox + ' ' + oy + ') scale(' + sc + ') translate(-200 -100)">'
           + '<text ' + common + ' font-size="62">'
           + '<textPath href="#' + pid + '" xlink:href="#' + pid + '" startOffset="50%" text-anchor="middle">'
           + svgEsc(String(l.text || '').replace(/\n/g, ' ')) + '</textPath></text></g>';
    });

    var fonts = {};
    ls.forEach(function (l) { if (l.type === 'text') fonts[l.font] = 1; });
    var fontNames = Object.keys(fonts);

    return '<?xml version="1.0" encoding="UTF-8"?>\n'
      + '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"'
      + ' width="' + A.w + 'in" height="' + A.h + 'in" viewBox="0 0 ' + W + ' ' + H + '" overflow="visible">\n'
      + '  <title>Saskatoon Tees print file, ' + svgEsc(viewKey) + ', ' + A.w + ' x ' + A.h + ' in</title>\n'
      + '  <desc>PRINT FILE. ' + A.w + ' x ' + A.h + ' inches at 100 units per inch.'
      + (fontNames.length
          ? ' FONTS REQUIRED: ' + svgEsc(fontNames.join(', ')) + '. Install from Google Fonts before opening,'
            + ' or the text will substitute and the layout will shift. Once it looks right,'
            + ' convert text to outlines before printing.'
          : ' No fonts used.')
      + '</desc>\n'
      + (fontNames.length
          ? '  <metadata>Fonts required: ' + svgEsc(fontNames.join(', ')) + ' — https://fonts.google.com</metadata>\n'
            + '  <!-- FONTS REQUIRED: ' + svgEsc(fontNames.join(', ')) + '\n'
            + '       Install from https://fonts.google.com before opening this file. -->\n'
          : '')
      + '  <defs>' + defs + '\n  </defs>' + body
      + (fontNames.length
          ? '\n  <g id="skt-font-note" data-print="ignore">'
            + '<text x="' + (W / 2) + '" y="' + (H + 34) + '" text-anchor="middle" font-family="Arial, sans-serif"'
            + ' font-size="26" fill="#8400FF">Fonts required: ' + svgEsc(fontNames.join(', '))
            + ' — install from Google Fonts, then convert text to outlines</text></g>'
          : '')
      + '\n</svg>';
  }
  function uploadText(content, name, mime) {
    var body = new URLSearchParams();
    body.append('data', btoa(unescape(encodeURIComponent(content))));
    body.append('fileName', name);
    body.append('filename', name);
    body.append('mimeType', mime || 'image/svg+xml');
    var post = function (url) {
      return fetchTimeout(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }, 30000).then(function (r) { return r.json(); })
        .then(function (jj) { return (jj && (jj.fileUrl || jj.url || jj.webViewLink)) || null; });
    };
    return post(CFG.uploadPrimary).catch(function () { return null; })
      .then(function (u) { return u || post(CFG.uploadFallback).catch(function () { return null; }); });
  }

  /* ---------- placement proof, the second file your orders carry ---------- */
  /* the garment image must be on screen before we copy it onto the proof */
  function waitForGarment() {
    return new Promise(function (res) {
      var g = document.getElementById('sktGarment');
      if (!g || !g.getAttribute('src')) return res();
      if (g.complete && g.naturalWidth) return res();
      var done = false;
      var fin = function () { if (!done) { done = true; res(); } };
      g.addEventListener('load', fin, { once: true });
      g.addEventListener('error', fin, { once: true });
      setTimeout(fin, 4000);
    });
  }
  function loadImg(src, cors) {
    return new Promise(function (res, rej) {
      var im = new Image();
      if (cors) im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { rej(new Error('img')); };
      im.src = src;
    });
  }
  function photoFor(colour, viewKey) {
    var it0 = S.items[S.ai];
    var cp = (it0 && it0.colourPhotos) || COLOUR_PHOTOS;
    if (cp && cp[colour] && cp[colour][viewKey]) return cp[colour][viewKey];
    var vs = (it0 ? it0.product : PRODUCT).variants.filter(function (x) { return optHas(x, colour); });
    var imgs = (it0 && it0.images) || IMAGES;
    for (var i = 0; i < vs.length; i++) {
      var im = imgs[vs[i].id] || imgs[String(vs[i].id)] || {};
      if (im[viewKey]) return im[viewKey];
    }
    return null;
  }
  var DETECT_CACHE = {};
  function detectGarment(img, key) {
    if (DETECT_CACHE[key]) return DETECT_CACHE[key];
    try {
      var W = 260, H = Math.max(1, Math.round((img.naturalHeight || 1) * W / (img.naturalWidth || 1)));
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, W, H);
      var d = x.getImageData(0, 0, W, H).data;
      function px(i) { return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
      var cor = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + (W - 1)) * 4].map(px);
      var transparent = cor.every(function (p) { return p[3] < 20; });
      var bg = [0, 1, 2].map(function (k) {
        return Math.round(cor.reduce(function (a, p) { return a + p[k]; }, 0) / 4);
      });
      function fg(ix, iy) {
        var i = (iy * W + ix) * 4;
        if (transparent) return d[i + 3] > 150;
        if (d[i + 3] < 150) return false;
        var dr = d[i] - bg[0], dg = d[i + 1] - bg[1], db = d[i + 2] - bg[2];
        return Math.sqrt(dr * dr + dg * dg + db * db) > 42;
      }
      var minX = W, maxX = 0, minY = -1, maxY = 0;
      for (var y = 0; y < H; y++) {
        var l = -1, r = -1, n = 0;
        for (var i2 = 0; i2 < W; i2++) { if (fg(i2, y)) { n++; if (l < 0) l = i2; r = i2; } }
        if (l < 0 || n < W * 0.05 || (r - l) < W * 0.05) continue;
        if (minY < 0) minY = y;
        maxY = y;
        if (l < minX) minX = l;
        if (r > maxX) maxX = r;
      }
      if (minY < 0 || maxX <= minX) return (DETECT_CACHE[key] = null);
      var box = {
        x: minX / W, y: minY / H,
        w: (maxX - minX) / W, h: (maxY - minY) / H
      };
      DETECT_CACHE[key] = box;
      return box;
    } catch (e) {
      DETECT_CACHE[key] = null;
      return null;
    }
  }

  function buildPlacement(viewKey, colourName) {
    var ls = S.layers[viewKey];
    if (!ls.length) return Promise.resolve(null);
    var A = area(viewKey);
    /* each colour gets its own mockup, drawn on that colour's own photo */
    var url = colourName
      ? (photoFor(colourName, viewKey) || viewImage(viewKey))
      : ((S.imgUsed && S.imgUsed[S.ai + ':' + viewKey]) || viewImage(viewKey));
    if (!url) return Promise.resolve(null);
    var refUrl = (S.imgUsed && S.imgUsed[S.ai + ':' + viewKey]) || url;
    var refP = (refUrl && refUrl !== url) ? loadImg(refUrl, true).catch(function () { return null; })
                                          : Promise.resolve(null);
    return Promise.all([loadImg(url, true), refP]).then(function (pair) {
      var g = pair[0], refImg = pair[1];
      var W = Math.min(g.naturalWidth || 1200, 1400);
      var H = Math.round((g.naturalHeight || 1400) * W / (g.naturalWidth || 1200));
      var HEAD = Math.round(W * 0.135), FOOT = Math.round(W * 0.065), RULE = Math.round(W * 0.008);
      var c = document.createElement('canvas');
      c.width = W; c.height = H + HEAD + RULE + FOOT;
      var x = c.getContext('2d');
      x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height);

      /* header: SASKATOONTEES over the tagline, yellow rule under it */
      x.fillStyle = '#111111'; x.fillRect(0, 0, W, HEAD);
      var big = Math.round(W * 0.055);
      x.textAlign = 'center'; x.textBaseline = 'alphabetic';
      x.font = '900 ' + big + "px 'Oswald', sans-serif";
      var a = 'SASKATOON', bb = 'TEES';
      var wa = x.measureText(a).width, wb = x.measureText(bb).width;
      var startX = W / 2 - (wa + wb) / 2, baseY = HEAD * 0.52;
      x.fillStyle = '#FFFFFF'; x.fillText(a, startX + wa / 2, baseY);
      x.fillStyle = '#FFD300'; x.fillText(bb, startX + wa + wb / 2, baseY);
      var small = Math.round(W * 0.019);
      x.font = '700 ' + small + "px 'Oswald', sans-serif";
      try { x.letterSpacing = '0.28em'; } catch (e) {}
      x.fillStyle = 'rgba(255,255,255,.72)';
      x.fillText('THE PRINT SHOP THAT SAYS YES', W / 2, HEAD * 0.82);
      try { x.letterSpacing = '0em'; } catch (e) {}
      x.fillStyle = '#FFD300'; x.fillRect(0, HEAD, W, RULE);

      /* footer */
      x.fillStyle = '#111111'; x.fillRect(0, c.height - FOOT, W, FOOT);
      x.font = '900 ' + Math.round(W * 0.018) + "px 'Oswald', sans-serif";
      try { x.letterSpacing = '0.22em'; } catch (e) {}
      x.textAlign = 'left';
      var f1 = 'APPROVED MOCKUP', f2 = ' · ', f3 = 'SASKATOONTEES.CA';
      var w1 = x.measureText(f1).width, w2 = x.measureText(f2).width, w3 = x.measureText(f3).width;
      var fx = W / 2 - (w1 + w2 + w3) / 2, fy = c.height - FOOT * 0.36;
      x.fillStyle = '#FFD300'; x.fillText(f1, fx, fy);
      x.fillStyle = 'rgba(255,255,255,.45)'; x.fillText(f2, fx + w1, fy);
      x.fillStyle = '#FFFFFF'; x.fillText(f3, fx + w1 + w2, fy);
      x.textAlign = 'center';
      try { x.letterSpacing = '0em'; } catch (e) {}

      var TOP = HEAD + RULE;
      x.drawImage(g, 0, TOP, W, H);

      var sc = (typeof CFG.proofScale === 'number' && CFG.proofScale > 0) ? CFG.proofScale : 1;
      /* the box is a percentage of the image, but photos are framed differently
         per colour. anchor it to the garment so every colour lines up */
      var aL = A.left / 100, aT = A.top / 100, aW = A.width / 100, aH = A.height / 100;
      if (refImg) {
        var refBox = detectGarment(refImg, refUrl);
        var tgtBox = detectGarment(g, url);
        if (refBox && tgtBox && refBox.w > 0.05 && tgtBox.w > 0.05) {
          var relX = (aL - refBox.x) / refBox.w, relY = (aT - refBox.y) / refBox.h;
          var relW = aW / refBox.w, relH = aH / refBox.h;
          aL = tgtBox.x + relX * tgtBox.w;
          aT = tgtBox.y + relY * tgtBox.h;
          aW = relW * tgtBox.w;
          aH = relH * tgtBox.h;
        }
      }
      var bxC = aL * W + (aW * W) / 2;
      var byC = TOP + aT * H + (aH * H) / 2;
      var bw = aW * W * sc, bh = aH * H * sc;
      var bx = bxC - bw / 2, by = byC - bh / 2;

      var jobs = ls.map(function (l) {
        return function () {
          var lx = bx + (l.x / A.w) * bw, ly = by + (l.y / A.h) * bh;
          var lw = (l.w / A.w) * bw, lh = (l.h / A.h) * bh;
          if (isBox(l) && l.type !== 'image') { lx += lw / 2; ly += lh / 2; }
          if (l.type === 'image') {
            return loadImg(l.src, false).then(function (im) {
              x.save();
              x.translate(lx + lw / 2, ly + lh / 2);
              x.rotate((l.rot || 0) * Math.PI / 180);
              x.scale(l.fx || 1, l.fy || 1);
              x.drawImage(im, -lw / 2, -lh / 2, lw, lh);
              x.restore();
            }).catch(function () {});
          }
          return new Promise(function (done) {
            var px = (l.cap / A.h) * bh * 1.38;
            x.save();
            x.translate(lx, ly);
            x.rotate((l.rot || 0) * Math.PI / 180);
            x.scale(l.fx || 1, l.fy || 1);
            x.font = (l.italic ? 'italic ' : '') + (l.weight || 900) + ' ' + px + "px '" + l.font + "', sans-serif";
            x.textAlign = 'center';
            x.textBaseline = 'middle';
            try { x.letterSpacing = ((l.ls || 0) / 100) + 'em'; } catch (e) {}
            x.lineJoin = 'round';

            var warp = l.warp || 'normal';
            if (warp === 'normal' || warp === 'slant') {
              if (warp === 'slant') x.transform(1, 0, -Math.tan((l.intensity == null ? 50 : l.intensity) * 0.0038), 1, 0, 0);
              var lines = String(l.text || '').split('\n');
              var lineH = px * (l.lh || 1.1);
              var start = -((lines.length - 1) * lineH) / 2;
              var offs = lineOffsets(x, lines, l.align);
              lines.forEach(function (line, i) {
                var yy = start + i * lineH, dx = offs[i];
                if (l.outline && l.outlineW) {
                  x.lineWidth = (l.outlineW / 100) * px * 2;
                  x.strokeStyle = l.outline;
                  x.strokeText(line, dx, yy);
                }
                if (!l.hollow) { x.fillStyle = l.colour; x.fillText(line, dx, yy); }
              });
            } else {
              /* the canvas draws warps inside a 400 x 200 viewBox at 62px.
                 do exactly that here, scaled to the box, so the proof and the
                 screen are the same size and the same shape */
              var VBW = 400, VBH = 200, VF = 62;
              var scale = Math.min((lw || VBW) / VBW, (lh || VBH) / VBH);
              x.scale(scale, scale);
              x.font = (l.italic ? 'italic ' : '') + (l.weight || 900) + ' ' + VF + "px '" + l.font + "', sans-serif";
              x.textAlign = 'center';
              x.textBaseline = 'alphabetic';
              x.lineJoin = 'round';

              var txt = String(l.text || '').replace(/\n/g, ' ');
              var chars = txt.split('');
              var widths = chars.map(function (ch) { return x.measureText(ch).width; });
              var total = widths.reduce(function (a, b) { return a + b; }, 0);
              var inten = (l.intensity == null ? 50 : l.intensity) / 100;
              function paint(ch, fsNow) {
                if (l.outline && l.outlineW) {
                  x.lineWidth = (l.outlineW / 100) * fsNow * 2;
                  x.strokeStyle = l.outline;
                  x.strokeText(ch, 0, 0);
                }
                if (!l.hollow) { x.fillStyle = l.colour; x.fillText(ch, 0, 0); }
              }

              if (warp === 'wave') {
                var cxW = -total / 2;
                chars.forEach(function (ch, i) {
                  var w = widths[i];
                  var tt = (cxW + w / 2) / (total / 2);
                  x.save();
                  x.translate(cxW + w / 2, Math.sin(tt * Math.PI) * (60 * inten));
                  paint(ch, VF);
                  x.restore();
                  cxW += w;
                });
              } else if (warp === 'circle') {
                var rC = 90;
                var angC = -Math.PI / 2 - (total / rC) / 2;
                chars.forEach(function (ch, i) {
                  var w = widths[i], step = w / rC, a2 = angC + step / 2;
                  x.save();
                  x.translate(Math.cos(a2) * rC, Math.sin(a2) * rC);
                  x.rotate(a2 + Math.PI / 2);
                  paint(ch, VF);
                  x.restore();
                  angC += step;
                });
              } else {
                var half2 = 180;
                var g2 = arcGeometry(l.intensity, half2);
                var up = warp === 'arcup';
                var cy2 = up ? (g2.r - g2.sag / 2) : -(g2.r - g2.sag / 2);
                var spread = total / g2.r;
                var ang = -spread / 2;
                chars.forEach(function (ch, i) {
                  var w = widths[i], step = w / g2.r, a2 = ang + step / 2;
                  x.save();
                  x.translate(Math.sin(a2) * g2.r, up ? (cy2 - Math.cos(a2) * g2.r) : (cy2 + Math.cos(a2) * g2.r));
                  x.rotate(up ? a2 : -a2);
                  paint(ch, VF);
                  x.restore();
                  ang += step;
                });
              }
            }
            x.restore();
            done();
          });
        };
      });

      return jobs.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve())
        .then(function () {
          try { return c.toDataURL('image/png'); }
          catch (e) { return null; }  /* tainted canvas, skip rather than break the order */
        });
    }).catch(function () { return null; });
  }
  function uploadDataUrl(dataUrl, name) {
    var b64 = dataUrl.split(',')[1];
    var body = new URLSearchParams();
    body.append('data', b64);
    body.append('fileName', name);
    body.append('filename', name);
    body.append('mimeType', 'image/png');
    var post = function (url) {
      return fetchTimeout(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }, 30000).then(function (r) { return r.json(); })
        .then(function (jj) { return (jj && (jj.fileUrl || jj.url || jj.webViewLink)) || null; });
    };
    return post(CFG.uploadPrimary).catch(function () { return null; })
      .then(function (u) { return u || post(CFG.uploadFallback).catch(function () { return null; }); });
  }

  function pendingUploads() {
    var n = 0;
    VIEWS.forEach(function (v) {
      S.layers[v.k].forEach(function (l) {
        if (l.type === 'image' && !l.serverUrl) n++;
      });
    });
    return n;
  }

  function designKey() { return 'skt-design-' + (CFG.handle || 'product'); }
  function saveDesign() {
    var dn = document.getElementById('sktDoc');
    var payload = {
      name: dn ? dn.value : 'Untitled design',
      colour: S.colour, qty: S.qty, layers: S.layers, notes: S.notes,
      saved: new Date().toISOString()
    };
    try {
      localStorage.setItem(designKey(), JSON.stringify(payload));
      toast('Saved on this device. Open this product again and pick it back up.');
    } catch (e) {
      toast('Could not save on this device. Add it to the cart instead.');
    }
  }
  function restoreOffer() {
    var raw;
    try { raw = localStorage.getItem(designKey()); } catch (e) { return; }
    if (!raw) return;
    var d;
    try { d = JSON.parse(raw); } catch (e) { return; }
    if (!d || !d.layers) return;
    var any = Object.keys(d.layers).some(function (k) { return d.layers[k] && d.layers[k].length; });
    if (!any) return;
    var host = document.getElementById('sktRestore');
    if (!host) return;
    host.innerHTML = '<span>' + esc(d.name || 'Your last design') + ' is saved on this device.</span>'
      + '<button type="button" id="sktRestoreGo">Pick it back up</button>'
      + '<button type="button" id="sktRestoreNo">Start fresh</button>';
    host.style.display = 'flex';
    document.getElementById('sktRestoreGo').addEventListener('click', function () {
      S.layers = d.layers; S.qty = d.qty || S.qty; S.notes = d.notes || '';
      if (d.colour) S.colour = d.colour;
      host.style.display = 'none';
      openFull();
    });
    document.getElementById('sktRestoreNo').addEventListener('click', function () {
      try { localStorage.removeItem(designKey()); } catch (e) {}
      host.style.display = 'none';
    });
  }
  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'skt-st__toast';
    el.textContent = msg;
    (document.getElementById('sktInner') || document.getElementById('skt-studio')).appendChild(el);
    setTimeout(function () { el.classList.add('is-on'); }, 10);
    setTimeout(function () { el.classList.remove('is-on'); setTimeout(function () { el.remove(); }, 300); }, 3200);
  }

  function addToCart() {
    if (S.busy) return;
    /* nothing is a dead end: send them to the step they still need */
    if (!allQty()) { openSheet('product'); return; }
    if (!S.items.some(hasAnyLayer)) { openSheet('files'); return; }
    var p = priceNow();

    /* wait for the uploads, same as the old customizer did */
    if (pendingUploads()) {
      S.busy = true;
      $('#sktCta').textContent = 'Uploading artwork…';
      $('#sktCta').disabled = true;
      var waited = 0;
      var wait = setInterval(function () {
        waited += 400;
        if (!pendingUploads()) { clearInterval(wait); S.busy = false; addToCart(); return; }
        if (waited > 30000) {
          /* the endpoint is not answering. Say so now, offer a retry, and let
             them through either way. An order you can chase beats a lost sale,
             but it has to be labelled. */
          clearInterval(wait);
          S.busy = false;
          var cta0 = document.getElementById('sktCta');
          if (cta0) { cta0.disabled = false; cta0.textContent = 'Add to cart'; }
          var again = window.confirm(
            'Your artwork has not finished uploading.\n\n'
            + 'Press OK to try again, or Cancel to place the order anyway. '
            + 'If you place it anyway we will email you for the file before we print.');
          if (again) {
            S.busy = true;
            if (cta0) { cta0.textContent = 'Uploading artwork…'; cta0.disabled = true; }
            retryUploads().then(function () { S.busy = false; addToCart(); });
            return;
          }
          addToCart();
        }
      }, 400);
      return;
    }

    S.busy = true;
    $('#sktCta').textContent = 'Building your proof…';
    $('#sktCta').disabled = true;

    /* build the proofs, show them, let the customer approve before anything is added */
    if (!S.approved) {
      syncItem();
      var backTo = S.ai, jobs = [], proofs = [];
      S.items.forEach(function (it, idx) {
        var cols = (it.colours || []).filter(function (c) { return colPieces(c) > 0; });
        if (!cols.length) cols = (it.colours || []).slice(0, 1);
        cols.forEach(function (c) {
          VIEWS.forEach(function (v) {
            if (it.layers[v.k] && it.layers[v.k].length) {
              jobs.push({ idx: idx, v: v, title: it.title, colour: c.name });
            }
          });
        });
      });
      progStart(jobs.map(function (jb) { return jb.colour + ' ' + jb.v.n.toLowerCase(); })
        .concat(['Ready to check']));
      jobs.reduce(function (ch, jb, i) {
        return ch.then(function () {
          progNext(i, 'Drawing the ' + jb.colour + ' ' + jb.v.n.toLowerCase() + '…');
          if (S.ai !== jb.idx) { activate(jb.idx); }
          return buildPlacement(jb.v.k, jb.colour).then(function (d) {
            if (d) proofs.push({ v: jb.v, data: d, item: jb.idx, title: jb.title, colour: jb.colour });
          });
        });
      }, Promise.resolve()).then(function () {
        activate(backTo);
        progNext(jobs.length, 'Ready to check');
        progDone();
        S.proofs = proofs;
        S.busy = false; priceUI();
        openSheet('approve');
      });
      return;
    }

    var areas = areasUsed(), label = paLabel(areas);
    var stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    var used = VIEWS.filter(function (v) { return S.layers[v.k].length; });

    var pAll = priceAll();
    var stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    var proofs = S.proofs || [];
    progStart(proofs.map(function (x) { return 'Saving ' + x.colour + ' ' + x.v.n.toLowerCase(); })
      .concat(['Making your print files', 'Adding to your cart', 'Opening your cart']));

    var uploaded = {};   /* item|colour -> { 'Placement Front': url, ... } */
    proofs.reduce(function (ch, x, i) {
      return ch.then(function () {
        progNext(i, 'Saving the ' + x.colour + ' ' + x.v.n.toLowerCase() + '…');
        var safeCol = String(x.colour || '').replace(/[^A-Za-z0-9]+/g, '-');
        return uploadDataUrl(x.data, 'SKT-Placement-' + safeCol + '-' + x.v.n.replace(/ /g, '-') + '-' + stamp + '.png')
          .then(function (u) {
            if (!u) return;
            var key = x.item + '|' + x.colour;
            uploaded[key] = uploaded[key] || {};
            uploaded[key]['Placement ' + x.v.n] = u;
          });
      });
    }, Promise.resolve()).then(function () {
      /* one vector print file per side, shared across colours since the
         artwork is the same, only the garment changes */
      var vectors = {}, fontsUsed = {};
      var vJobs = [];
      S.items.forEach(function (it, idx) {
        VIEWS.forEach(function (v) {
          if (!(it.layers[v.k] || []).length) return;
          (it.layers[v.k] || []).forEach(function (l) {
            if (l.type === 'text' && l.font) fontsUsed[l.font] = 1;
          });
          vJobs.push(function () {
            var svg = buildVector(v.k);
            if (!svg) return Promise.resolve();
            return uploadText(svg, 'SKT-Print-' + v.n.replace(/ /g, '-') + '-' + stamp + '.svg')
              .then(function (u) {
                if (!u) return;
                vectors[idx] = vectors[idx] || {};
                vectors[idx]['Print file ' + v.n] = u;
              });
          });
        });
      });
      return vJobs.reduce(function (p2, fn) { return p2.then(fn); }, Promise.resolve())
        .then(function () { return { vectors: vectors, fonts: Object.keys(fontsUsed) }; });
    }).then(function (vres) {
      var vectors = vres.vectors, fontList = vres.fonts;
      var items = [], missed = [], dn = document.getElementById('sktDoc');
      var designName = dn && dn.value ? dn.value : 'Untitled design';

      S.items.forEach(function (it, idx) {
        var areas = itemAreas(it);
        var label = areas === 1 ? '1 Print Area' : areas + ' Print Areas';
        var hasPA = (it.product.options || []).some(function (o) {
          return String(o.name).toLowerCase().indexOf('print area') > -1;
        });
        var artBase = {};
        VIEWS.forEach(function (v) {
          var ls = it.layers[v.k] || [];
          if (!ls.length) return;
          var files = ls.filter(function (l) { return l.type === 'image'; })
                        .map(function (l) {
                          /* never write a bare filename. It reads like a normal
                             value in the admin, which is how a job reaches the
                             press with no artwork behind it. */
                          return isUrl(l.serverUrl) ? l.serverUrl
                               : 'ARTWORK NOT UPLOADED - ' + (l.name || 'unnamed file');
                        });
          if (files.join(' ').indexOf('ARTWORK NOT UPLOADED') > -1) {
            artBase['!! ACTION NEEDED'] = 'Artwork did not upload. Get the file from the customer before printing.';
          }
          var texts = ls.filter(function (l) { return l.type === 'text'; })
                        .map(function (l) { return l.text.replace(/\n/g, ' '); });
          if (files.length) artBase['Artwork ' + v.k] = files.join(' | ');
          if (texts.length) artBase['Text ' + v.n] = texts.join(' | ');
        });

        (it.colours || []).forEach(function (cEntry) {
        var art = {};
        Object.keys(artBase).forEach(function (k) { art[k] = artBase[k]; });
        var upKey = uploaded[idx + '|' + cEntry.name] || {};
        Object.keys(upKey).forEach(function (k) { art[k] = upKey[k]; });
        var vecKey = vectors[idx] || {};
        Object.keys(vecKey).forEach(function (k) { art[k] = vecKey[k]; });
        if (Object.keys(vecKey).length && fontList.length) {
          art['Fonts to install'] = fontList.join(', ') + ' (Google Fonts)';
        }
        Object.keys(cEntry.qty || {}).forEach(function (size) {
          var q = cEntry.qty[size] || 0;
          if (!q) return;
          function match(withLabel) {
            return it.product.variants.filter(function (x) {
              if (!optHas(x, cEntry.name) || !optHas(x, size)) return false;
              if (withLabel && !optHas(x, withLabel)) return false;
              return true;
            })[0];
          }
          /* this garment may not offer that many print areas, or may name them
             differently. take the closest variant rather than dropping the line */
          var v = (hasPA && match(label)) || match(null);
          if (!v) {
            console.warn('[SKT studio] no variant for', it.title, cEntry.name, size, label);
            missed.push(it.title + ' ' + cEntry.name + ' ' + size);
            return;
          }
          var props = {
            'Color': cEntry.name,
            'Size': size,
            'Base Price': money(v.price / 100),
            'Discount': Math.round(pAll.tier.off * 100) + '%',
            'Final Price per Item': money((v.price / 100) * (1 - pAll.tier.off))
          };
          Object.keys(art).forEach(function (k) { props[k] = art[k]; });
          if (designName && designName !== 'Untitled design') props['Design Name'] = designName;
          props['Ready by'] = turnaround().text;
          if (S.items.length > 1) props['_design_group'] = designName + ' · ' + stamp;
          if (S.notes) props['Designer Notes'] = S.notes;
          items.push({ id: v.id, quantity: q, properties: props });
        });
        });
      });

      console.log('[SKT studio] cart lines', items);
      if (!items.length) {
        progDone(); S.busy = false; priceUI();
        alert('Could not match those sizes to variants. Check the print area option values.');
        return;
      }
      if (missed.length) {
        var go = confirm('These are not available in that size or colour, so they cannot be added:\n\n'
          + missed.join('\n') + '\n\nPress OK to add everything else, or Cancel to go back and change them.');
        if (!go) { progDone(); S.busy = false; priceUI(); return; }
      }
      progNext(proofs.length, 'Adding to your cart…');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        progNext(proofs.length + 1, 'Opening your cart…');
        progDone();
        var code = null, q = pAll.q;
        Object.keys(CFG.discountCodes).sort(function (a, b) { return b - a; }).forEach(function (k) {
          if (!code && q >= parseInt(k, 10)) code = CFG.discountCodes[k];
        });
        window.location.href = code ? '/discount/' + code + '?redirect=/cart' : '/cart';
      });
    }).catch(function () {
      progDone(); S.busy = false; priceUI();
      alert('Could not add to cart. Please try again.');
    });
  }

  /* ---------- events ---------- */
  function quick(act) {
    var l = sel(), A = area();
    if (act === 'undo') return undo();
    if (act === 'redo') return redo();
    if (act === 'preview') {
      var on = $('#sktStage').classList.toggle('is-clean');
      var pv = document.getElementById('sktPv');
      if (pv) { pv.textContent = on ? 'Edit' : 'Preview'; pv.classList.toggle('is-on', on); }
      S.sel = null; return render();
    }
    if (act === 'pick') return $('#sktFile').click();
    if (act === 'close') return closeSheet();
    if (act === 'approveAnyway') { S.approved = true; closeSheet(); return addToCart(); }
    if (act === 'clear') { if (!L().length) return; snap(); S.layers[S.view] = []; S.sel = null; render(); buildSheet('layers'); return; }
    if (!l) return;
    snap();
    if (act === 'centre') { if (isBox(l)) { l.x = (A.w - l.w) / 2; l.y = (A.h - l.h) / 2; } else { l.x = A.w / 2; l.y = A.h / 2; } }
    if (act === 'flip') l.fx = (l.fx || 1) * -1;
    if (act === 'fit') {
      var r = (l.h / l.w) || 1;
      if (isBox(l)) { l.w = A.w; l.h = l.w * r; if (l.h > A.h) { l.h = A.h; l.w = l.h / r; } l.x = (A.w - l.w) / 2; l.y = (A.h - l.h) / 2; }
      else { l.cap = A.h * 0.16; l.x = A.w / 2; l.y = A.h / 2; }
    }
    if (act === 'del') { var ls = L(); ls.splice(ls.indexOf(l), 1); S.sel = null; }
    if (act === 'nooutline') { l.outline = ''; l.outlineW = 0; l.hollow = false; buildSheet('colours'); }
    render();
  }

  function bind(root) {
    root = root || $('#skt-studio');

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sheet]');
      if (t) return openSheet(t.getAttribute('data-sheet'));
      var a = e.target.closest('[data-act]');
      if (a) return quick(a.getAttribute('data-act'));
      var v = e.target.closest('[data-view]');
      if (v) { S.view = v.getAttribute('data-view'); S.sel = null; drawStage(); render(); return; }
      var c = e.target.closest('[data-colour]');
      if (c) {
        pickColour(c.getAttribute('data-colour'));
        drawStage(); render(); buildSheet('product');
        if (!hasRealPhoto(S.colour)) chaseImages(S.colour);
        return;
      }
      var ft = e.target.closest('[data-ftab]');
      if (ft) { S.ftab = ft.getAttribute('data-ftab'); buildSheet('files'); return; }
      var as = e.target.closest('[data-asset]');
      if (as) { addImage(S.assets[parseInt(as.getAttribute('data-asset'), 10)]); closeSheet(); return; }
      var st = e.target.closest('[data-style]');
      if (st) {
        var l1 = sel(); if (!l1) return;
        l1.style = st.getAttribute('data-style'); l1.hollow = false;
        STYLES.filter(function (x) { return x.k === l1.style; })[0].a(l1);
        renderLayers(); renderViews(); buildSheet('style'); return;
      }
      var wp = e.target.closest('[data-warp]');
      if (wp) {
        var l2 = sel(); if (!l2) return;
        setWarp(l2, wp.getAttribute('data-warp'));
        renderLayers(); renderViews(); buildSheet('shape'); return;
      }
      var dl = e.target.closest('[data-dellayer]');
      if (dl) {
        snap();
        var id = parseInt(dl.getAttribute('data-dellayer'), 10), ls = L();
        ls.splice(ls.map(function (x) { return x.id; }).indexOf(id), 1);
        if (S.sel === id) S.sel = null;
        render(); buildSheet('layers'); return;
      }
      var ly = e.target.closest('[data-layer]');
      if (ly) { S.sel = parseInt(ly.getAttribute('data-layer'), 10); render(); buildSheet('layers'); return; }
      if (e.target.id === 'sktStage' || e.target.id === 'sktGarment' || e.target.id === 'sktArea') { S.sel = null; render(); }
    });

    root.addEventListener('input', function (e) {
      var el = e.target;
      if (el.hasAttribute('data-size')) {
        var it0 = S.items[S.ai], ce = it0 ? colourEntry(it0, S.colour) : null;
        if (ce) S.qty = ce.qty;
        S.qty[el.getAttribute('data-size')] = Math.max(0, parseInt(el.value || '0', 10));
        el.closest('.skt-st__size').classList.toggle('has', S.qty[el.getAttribute('data-size')] > 0);
        syncItem(); priceUI(); repriceCells(); syncSheetFoot();
        return;
      }
      if (el.hasAttribute('data-prop')) {
        var l = sel(); if (!l) return;
        var k = el.getAttribute('data-prop'), v = el.value, A = area();
        if (k === 'italic') l.italic = v === '1';
        else if (k === 'weight' || k === 'outlineW' || k === 'ls' || k === 'intensity') l[k] = parseFloat(v) || 0;
        else if (k === 'cap') l.cap = Math.max(0.2, parseFloat(v) || 1);
        else if (k === 'rot') l.rot = parseFloat(v) || 0;
        else if (k === 'lh') l.lh = parseFloat(v) || 1.1;
        else if (k === 'px') l.x = isBox(l) ? parseFloat(v) : parseFloat(v) + l.w / 2;
        else if (k === 'py') l.y = isBox(l) ? parseFloat(v) : parseFloat(v) + l.h / 2;
        else if (k === 'w') { var r = l.h / l.w; l.w = Math.max(0.1, parseFloat(v) || 1); l.h = l.w * r; }
        else l[k] = v;
        if (k === 'outline' && !l.outlineW) l.outlineW = 6;
        if (k === 'colour') l.hollow = false;
        renderLayers(); renderViews(); priceUI();
      }
    });

    $('#sktScrim').addEventListener('click', closeSheet);
    $('#sktSX').addEventListener('click', closeSheet);
    bindFoot();
    $('#sktCta').addEventListener('click', addToCart);
    var sv = $('#sktSave'); if (sv) sv.addEventListener('click', saveDesign);
    $('#sktFile').addEventListener('change', function (e) { takeFiles(e.target.files); e.target.value = ''; });
    window.addEventListener('resize', function () { fitStage(); renderViews(); });
  }

  function setWarp(l, k) {
    var A = area(), was = isBox(l);
    l.warp = k;
    var boxNow = (k !== 'normal' && k !== 'slant');
    if (boxNow && !was) {
      var w = Math.min(A.w, Math.max(3, l.cap * (l.text || '').length * 0.62));
      var h = k === 'circle' ? w : w * 0.5;
      l.x = l.x - w / 2; l.y = l.y - h / 2; l.w = w; l.h = h;
    } else if (!boxNow && was) { l.x = l.x + l.w / 2; l.y = l.y + l.h / 2; }
  }

  var IMG_RATIO = 1;
  function fitStage() {
    var c = $('#sktCanvas'), st = $('#sktStage'), g = $('#sktGarment');
    if (!c || !st) return;
    if (g && g.naturalWidth && g.naturalHeight) IMG_RATIO = g.naturalWidth / g.naturalHeight;
    var w = c.clientWidth - 20, h = c.clientHeight - 20;
    var sw, sh;
    if (w / h > IMG_RATIO) { sh = h; sw = h * IMG_RATIO; } else { sw = w; sh = w / IMG_RATIO; }
    st.style.width = Math.max(180, sw) + 'px';
    st.style.height = Math.max(180, sh) + 'px';
    renderLayers();
  }

  function render() { S.approved = false; S.proofs = null; renderLayers(); renderViews(); renderToolbar(); priceUI(); syncSheetFoot(); }


  /* ---------- styles, injected so there is no extra CSS file ---------- */
  var CSS = "\
..skt-studio-x{}\
.skt-studio{display:flex;flex-direction:column;max-width:900px;margin:0 auto;--k:#111;--y:#FFD300;--p:#8400FF;--g:#F4F4F6;--b:#E5E7EB;--m:#6B7280;\
border:2px solid var(--k);border-radius:14px;overflow:hidden;background:#fff;position:relative;font-size:13px;line-height:1.5}\
.skt-studio *{box-sizing:border-box}\
.skt-studio__boot{padding:40px;text-align:center;color:var(--m)}\
\
.skt-st__mq{height:26px;background:var(--k);overflow:hidden;display:flex;align-items:center;flex:none;border-bottom:1px solid rgba(255,255,255,.12)}\
.skt-st__mqt{display:flex;gap:18px;white-space:nowrap;animation:sktroll 30s linear infinite;font-family:Oswald,sans-serif;font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:.14em;color:var(--y);padding-left:18px}\
.skt-st__mqt i{font-style:normal;color:var(--p)}\
@keyframes sktroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}\
.skt-st__bar{display:flex;align-items:center;gap:14px;padding:16px 18px;background:var(--k);border-bottom:3px solid var(--p);flex:none;overflow:hidden;min-height:68px}\
\
\
.skt-st__logo{font-family:Oswald,sans-serif;font-weight:900;font-size:18px;letter-spacing:.005em;line-height:1;flex:0 0 auto;white-space:nowrap;\
background:#111;color:#fff;padding:10px 14px 12px;border-radius:3px;position:relative;transform:rotate(-1.2deg);border:1px solid rgba(255,255,255,.08)}\
.skt-st__logo::after{content:'';position:absolute;left:6px;right:6px;bottom:4px;height:4px;background:var(--p);border-radius:2px}\
.skt-st__logo b{color:#fff!important}\
.skt-st__logo b{color:#fff;font-weight:900}\
.skt-st__logo em{color:var(--y);font-style:normal}\
\
\
.skt-st__doc{flex:0 1 220px;min-width:120px;background:rgba(255,255,255,.10)!important;border:2px solid rgba(255,255,255,.22);border-radius:6px;\
color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;caret-color:var(--y);\
font-family:Oswald,sans-serif!important;font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.06em;padding:0 14px;outline:none;height:40px;line-height:40px;box-shadow:none}\
.skt-st__doc::placeholder{color:rgba(255,255,255,.45);-webkit-text-fill-color:rgba(255,255,255,.45)}\
.skt-st__doc:focus{border-color:var(--y);background:rgba(255,211,0,.08)}\
.skt-st__crumb{display:none}\
.skt-st__tools{margin-left:auto;display:flex;gap:6px;flex:none}\
\
\
.skt-st__tools{display:flex;align-items:center;gap:8px;margin-left:auto;flex:none}\
.skt-st__ic{width:40px;height:40px;display:inline-flex;align-items:center;justify-content:center;border:2px solid rgba(255,255,255,.18);border-radius:8px;background:rgba(255,255,255,.04);color:rgba(255,255,255,.75);cursor:pointer;padding:0}\
.skt-st__ic svg{width:18px;height:18px}\
.skt-st__pv{height:40px;border:2px solid var(--y);background:transparent;color:var(--y);border-radius:8px;padding:0 18px;font-family:Oswald,sans-serif;font-weight:900;font-size:11px;text-transform:uppercase;letter-spacing:.08em;cursor:pointer}\
.skt-st__pv:hover,.skt-st__pv.is-on{background:var(--y);color:var(--k)}\
.skt-st__ic:hover{border-color:var(--y);color:var(--y);background:rgba(255,211,0,.10)}\
.skt-st__ic:disabled{opacity:.3;cursor:not-allowed}\
.skt-st__canvas{position:relative;background:#fbfbfc;background-image:radial-gradient(rgba(132,0,255,.13) 1px, transparent 1px);background-size:16px 16px;display:grid;place-items:center;padding:10px;height:min(62vh,600px);min-height:320px}\
.skt-st__stage{position:relative;width:300px;height:300px}\
.skt-st__garment{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block}\
.skt-st__area{position:absolute;outline:2px dashed rgba(17,17,17,.55);outline-offset:0;background:rgba(17,17,17,.03)}\
.skt-st__area.is-live{background:rgba(132,0,255,.10);outline-color:var(--p)}\
.skt-st__stage.is-clean .skt-st__area{outline-color:transparent;background:none}\
.skt-st__stage.is-clean .skt-st__bound,.skt-st__stage.is-clean .skt-st__yoff,\
.skt-st__stage.is-clean .skt-st__x,.skt-st__stage.is-clean .skt-st__sz,\
.skt-st__stage.is-clean .skt-st__h,.skt-st__stage.is-clean .skt-st__kill,\
.skt-st__stage.is-clean .skt-st__fr,.skt-st__stage.is-clean .skt-st__stem{display:none!important}\
.skt-st__bound{position:absolute;left:50%;bottom:-24px;transform:translateX(-50%);white-space:nowrap;font-family:Oswald,sans-serif;font-weight:900;font-size:10px;text-transform:uppercase}\
.skt-st__yoff{position:absolute;left:50%;top:-24px;transform:translateX(-50%);white-space:nowrap;font-family:Oswald,sans-serif;font-weight:900;font-size:10px;text-transform:uppercase;display:none}\
.skt-st__x{position:absolute;background:rgba(17,17,17,.18)}\
.skt-st__x--v{width:1px;left:50%;top:0;bottom:0}.skt-st__x--h{height:1px;top:50%;left:0;right:0}\
.skt-st__g{position:absolute;background:var(--p);display:none;z-index:9}\
.skt-st__g--v{width:1px;left:50%;top:-12%;height:124%}.skt-st__g--h{height:1px;top:50%;left:-12%;width:124%}\
.skt-st__l{position:absolute;transform-origin:center;touch-action:none;cursor:move}\
.skt-st__l img{width:100%;height:100%;display:block;pointer-events:none}\
.skt-st__l .skt-warp{width:100%;height:100%;pointer-events:none}\
.skt-st__tx{white-space:pre;pointer-events:none;paint-order:stroke fill}\
.skt-st__fr{position:absolute;inset:-2px;border:1.5px dashed rgba(17,17,17,.6);display:none}\
.skt-st__l.is-sel .skt-st__fr{display:block}\
.skt-st__h{position:absolute;width:13px;height:13px;background:#bfe000;border:2px solid #fff;border-radius:50%;display:none;z-index:3;box-shadow:0 0 0 1px rgba(17,17,17,.3)}\
.skt-st__l.is-sel .skt-st__h{display:block}\
.skt-st__h--se{right:-7px;bottom:-7px}.skt-st__h--sw{left:-7px;bottom:-7px}\
.skt-st__h--ne{right:-7px;top:-7px}.skt-st__h--nw{left:-7px;top:-7px}\
.skt-st__h--rot{left:50%;top:-28px;margin-left:-6px}\
.skt-st__stem{position:absolute;left:50%;top:-22px;width:1.5px;height:22px;background:#bfe000;display:none}\
.skt-st__l.is-sel .skt-st__stem{display:block}\
.skt-st__sz{position:absolute;left:50%;bottom:-28px;transform:translateX(-50%);background:var(--k);color:#fff;border-radius:6px;font-family:Oswald,sans-serif;font-weight:700;font-size:10px;padding:2px 8px;white-space:nowrap;display:none}\
.skt-st__l.is-sel .skt-st__sz{display:block}\
.skt-st__kill{position:absolute;right:-30px;top:-8px;width:22px;height:22px;border-radius:50%;background:#EF4444;color:#fff;border:0;display:none;cursor:pointer;font-size:13px;line-height:1}\
.skt-st__l.is-sel .skt-st__kill{display:block}\
.skt-st__empty{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;z-index:4}\
.skt-st__empty button{width:200px;padding:13px;background:#fff;border:2px solid var(--k);border-radius:8px;box-shadow:4px 4px 0 0 var(--y);font-family:Oswald,sans-serif;font-weight:900;font-size:12.5px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer;transition:.12s}\
.skt-st__empty button:hover{background:var(--y);box-shadow:none;transform:translate(2px,2px)}\
.skt-st__empty button.is-primary{background:var(--y)}\
.skt-st__empty button.is-primary:hover{background:var(--k);color:var(--y)}\
.skt-st__views{display:flex;gap:18px;justify-content:center;padding:14px 14px 12px;border-top:2px solid var(--b);overflow-x:auto;overflow-y:hidden;flex:none;background:#f7f7f9}\
.skt-st__v{background:none;border:0;padding:0;cursor:pointer;position:relative;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.06em;color:var(--m)}\
.skt-st__vt{width:54px;height:54px;border:2px solid #e2e2e7;border-radius:8px;background:#fff;position:relative;overflow:hidden;display:block}\
.skt-st__vt img{width:100%;height:100%;object-fit:contain;display:block}\
.skt-st__vlayers{position:absolute;display:block}\
.skt-st__vl{position:absolute;display:block;white-space:pre;transform-origin:center;paint-order:stroke fill;line-height:1.1}\
.skt-st__vl img,.skt-st__vl svg{width:100%;height:100%;display:block}\
.skt-st__v.is-on{color:var(--k)}\
.skt-st__v.is-on .skt-st__vt{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__vc{position:absolute;top:-5px;left:-5px;min-width:18px;height:18px;border-radius:9px;background:var(--p);color:#fff;font-size:10px;font-weight:900;display:grid;place-items:center;font-style:normal;padding:0 4px}\
.skt-st__toolbar{display:flex;flex-wrap:wrap;border-top:3px solid var(--p);background:var(--k);flex:none}\
\
.skt-st__toolbar button{flex:1 1 20%;min-width:0;padding:12px 6px 10px;background:transparent;border:0;border-right:1px solid rgba(255,255,255,.10);border-bottom:1px solid rgba(255,255,255,.10);cursor:pointer;\
display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:6px;\
font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.06em;color:rgba(255,255,255,.66);line-height:1.25;text-align:center}\
.skt-st__toolbar button svg{width:21px;height:21px;flex:none}\
.skt-st__toolbar button span{display:block;max-width:100%;overflow:hidden}\
.skt-st__toolbar button:hover{color:#fff;background:rgba(255,255,255,.07)}\
.skt-st__toolbar button:active{background:rgba(255,211,0,.16)}\
.skt-st__toolbar button.is-key{color:var(--y)}\
.skt-st__toolbar button.is-key svg{stroke-width:2}\
.skt-st__toolbar button.is-key:hover{background:rgba(255,211,0,.12);color:var(--y)}\
.skt-st__toolbar button.is-danger{color:#FF7A7A}\
.skt-st__toolbar button.is-danger:hover{color:#fff;background:rgba(239,68,68,.22)}\
.skt-st__toolbar button.is-on{color:var(--y);box-shadow:inset 0 -3px 0 var(--y);background:rgba(255,211,0,.10)}\
.skt-st__cart{display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--k);border-top:1px solid rgba(255,255,255,.12);flex:none}\
.skt-st__price{font-family:Oswald,sans-serif;font-weight:900;font-size:20px;color:var(--y);line-height:1.1}\
.skt-st__meta{font-family:Oswald,sans-serif;font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:.05em;color:rgba(255,255,255,.5);max-width:46vw;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\
.skt-st__cta{background:var(--y);color:var(--k);border:2px solid var(--y);border-radius:8px;padding:0 18px;height:44px;white-space:nowrap;font-family:Oswald,sans-serif;font-weight:900;font-size:13px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer}\
\
.skt-st__cta:disabled{background:rgba(255,255,255,.12);color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.18);cursor:wait;box-shadow:none}\
.skt-st__cta.is-next{background:transparent;color:var(--y);border-color:var(--y)}\
.skt-st__cta.is-next:hover{background:var(--y);color:var(--k)}\
.skt-st__scrim{position:absolute;inset:0;background:rgba(17,17,17,.45);display:none;z-index:20}\
.skt-st__scrim.is-on{display:block}\
.skt-st__sheet{position:absolute;left:0;right:0;bottom:0;max-height:82%;background:#fff;border-top:2px solid var(--k);border-radius:14px 14px 0 0;transform:translateY(105%);transition:transform .2s;z-index:25;display:flex;flex-direction:column}\
.skt-st__sheet.is-on{transform:none}\
.skt-st__shead{display:flex;align-items:center;gap:8px;padding:12px 16px;border-bottom:2px solid var(--b)}\
.skt-st__shead b{font-family:Oswald,sans-serif;font-weight:900;font-size:13px;text-transform:uppercase;letter-spacing:.06em}\
.skt-st__shead span{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;color:var(--m)}\
.skt-st__x2{margin-left:auto;background:none;border:0;cursor:pointer;color:var(--m);font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.08em;padding:6px 8px;border-radius:6px}\
.skt-st__x2:hover{background:var(--g);color:var(--k)}\
.skt-st__stabs{display:none;border-bottom:2px solid var(--b)}\
.skt-st__stabs button{flex:1;padding:10px;background:none;border:0;border-bottom:3px solid transparent;cursor:pointer;font-family:Oswald,sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.07em;color:var(--m)}\
.skt-st__stabs button.is-on{color:var(--k);border-bottom-color:var(--y)}\
.skt-st__sbody{overflow:auto;padding:14px}\
.skt-st__sfoot{display:none;gap:10px;padding:12px 14px;border-top:2px solid var(--b)}\
.skt-st__sfoot>*{flex:1}\
.skt-st__lbl{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.12em;color:var(--m);margin-bottom:7px}\
.skt-st__note{font-size:12px;color:var(--m);margin:10px 0 0;line-height:1.5}\
.skt-st__in{width:100%;padding:9px 11px;border:2px solid var(--b);border-radius:8px;background:#fffbeb;font-family:Oswald,sans-serif;font-weight:700;font-size:13px;outline:none}\
textarea.skt-st__in{font-family:inherit;font-weight:400;min-height:76px;resize:vertical}\
.skt-st__in:focus{border-color:var(--p)}\
.skt-st__btn{background:var(--y);color:var(--k);border:2px solid var(--k);border-radius:8px;padding:11px 16px;font-family:Oswald,sans-serif;font-weight:900;font-size:12px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer;width:100%;margin-top:12px}\
.skt-st__btn2{background:#fff;color:var(--k);border:2px solid var(--k);border-radius:8px;padding:10px 14px;font-family:Oswald,sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer}\
.skt-st__btn2.full{width:100%;margin-top:10px}\
.skt-st__sws{display:flex;flex-wrap:wrap;gap:8px}\
.skt-st__sw{width:36px;height:36px;border-radius:50%;border:2px solid var(--b);cursor:pointer;background-size:340%;background-position:center 30%;background-repeat:no-repeat;background-color:#f2f2f4;padding:0}\
.skt-st__sw.is-on{border-color:var(--y);box-shadow:0 0 0 2px #fff,0 0 0 4px var(--y)}\
.skt-st__rule{height:2px;background:var(--g);margin:14px 0}\
.skt-st__sizes{display:grid;grid-template-columns:repeat(auto-fit,minmax(68px,1fr));gap:8px}\
.skt-st__size{border:2px solid var(--b);border-radius:8px;overflow:hidden;text-align:center}\
.skt-st__size.has{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__size .t{font-family:Oswald,sans-serif;font-weight:900;font-size:10px;background:var(--g);padding:3px 0;border-bottom:2px solid var(--b)}\
.skt-st__size.has .t{background:var(--k);color:var(--y)}\
\
.skt-st__size .p0{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;color:var(--m);padding-top:5px;line-height:1.2}\
.skt-st__size .p0 s{text-decoration:line-through;text-decoration-color:#EF4444}\
.skt-st__size .p1{font-family:Oswald,sans-serif;font-weight:900;font-size:12px;padding-top:5px;line-height:1.2}\
.skt-st__size .p1.is-off{color:#16a34a;padding-top:0}\
.skt-st__size .p2{font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;color:var(--p);padding-bottom:5px;line-height:1.2}\
.skt-st__size input{width:100%;border:0;border-top:2px solid var(--b);padding:7px 0;text-align:center;font-family:Oswald,sans-serif;font-weight:900;font-size:14px;background:#fffbeb;outline:none}\
.skt-st__breaknote{margin-top:12px;border:2px solid var(--p);background:#faf5ff;color:var(--p);border-radius:8px;padding:8px 12px;font-family:Oswald,sans-serif;font-weight:900;font-size:10.5px;text-transform:uppercase;letter-spacing:.06em;text-align:center}\
.skt-st__breaknote.is-best{border-color:#16a34a;background:#f0fdf4;color:#16a34a}\
.skt-st__tiers{border:2px solid var(--b);border-radius:8px;overflow:hidden;margin-top:10px}\
.skt-st__tier{display:flex;justify-content:space-between;padding:7px 12px;border-bottom:1px solid var(--b);font-size:12px;color:var(--m)}\
.skt-st__tier:last-child{border-bottom:0}\
.skt-st__tier.is-on{background:#fffdf2;color:var(--k);box-shadow:inset 3px 0 0 var(--y)}\
.skt-st__tier b{font-family:Oswald,sans-serif;font-weight:900;color:var(--k)}\
.skt-st__drop{border:2px dashed var(--b);border-radius:10px;background:var(--g);padding:26px 16px;text-align:center}\
.skt-st__drop.hot{border-color:var(--p);background:#f0e6ff}\
.skt-st__drop b{display:block;font-family:Oswald,sans-serif;font-weight:900;font-size:13px;text-transform:uppercase;margin-bottom:6px}\
.skt-st__drop p{font-size:12px;color:var(--m);margin:0 0 12px}\
.skt-st__help{display:block;margin-top:10px;font-size:11.5px;color:var(--p)}\
.skt-st__assets{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}\
.skt-st__asset{position:relative;aspect-ratio:1;border:2px solid var(--b);border-radius:10px;background:#fff;display:grid;place-items:center;overflow:hidden;cursor:pointer;padding:0}\
.skt-st__asset img{max-width:78%;max-height:78%}\
.skt-st__asset span{position:absolute;left:0;right:0;bottom:0;background:var(--k);color:var(--y);font-family:Oswald,sans-serif;font-weight:700;font-size:8.5px;text-transform:uppercase;padding:2px 0}\
.skt-st__tiles{display:grid;grid-template-columns:1fr 1fr;gap:10px}\
.skt-st__tile{border:2px solid var(--b);border-radius:10px;overflow:hidden;background:#fff;cursor:pointer;padding:0}\
.skt-st__tile.is-on{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__tile .pv{background:var(--k);height:56px;display:grid;place-items:center;overflow:hidden}\
.skt-st__tile .pv span{white-space:nowrap;paint-order:stroke fill}\
.skt-st__tile .pv svg{width:80%;height:44px}\
.skt-st__tile .nm{display:block;font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.06em;padding:6px 0;color:var(--m)}\
.skt-st__row2{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:12px}\
.skt-st__row3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:12px}\
.skt-st__ltop{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding-bottom:10px;border-bottom:2px solid var(--b);margin-bottom:10px}\
.skt-st__ltop b{font-family:Oswald,sans-serif;font-weight:900;font-size:12px;text-transform:uppercase}\
.skt-st__ltop span{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;color:var(--m)}\
.skt-st__mini{margin-left:auto;background:none;border:2px solid var(--b);border-radius:6px;padding:5px 9px;font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.05em;color:var(--m);cursor:pointer}\
.skt-st__mini+.skt-st__mini{margin-left:0}\
.skt-st__mini:hover{border-color:var(--k);color:var(--k)}\
.skt-st__lay{display:flex;align-items:center;gap:10px;border:2px solid var(--b);border-radius:10px;padding:8px;margin-bottom:8px;cursor:pointer}\
.skt-st__lay.is-sel{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__lay .th{width:36px;height:36px;flex:none;border:2px solid var(--b);border-radius:6px;display:grid;place-items:center;overflow:hidden;font-family:Oswald,sans-serif;font-weight:900}\
.skt-st__lay .th img{max-width:100%;max-height:100%}\
.skt-st__lay .nm{flex:1;min-width:0;font-size:12.5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\
.skt-st__lay .nm small{display:block;font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;color:var(--m)}\
.skt-st__lay .nm i{font-style:normal;margin-left:4px}\
.skt-st__lay .nm i.ok{color:#16a34a}.skt-st__lay .nm i.warn{color:#d97706}.skt-st__lay .nm i.bad{color:#EF4444}\
.skt-st__lay .rm{margin-left:auto;background:none;border:0;color:var(--m);font-size:18px;cursor:pointer;line-height:1;padding:4px 6px}\
\
.skt-studio.is-launch{border:0;box-shadow:none}\
.skt-st__lp{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:20px;align-items:start}\
.skt-st__lpimg{border:2px solid var(--k);border-radius:14px;background:var(--g);overflow:hidden;aspect-ratio:1/1;display:grid;place-items:center}\
.skt-st__lpimg img{width:100%;height:100%;object-fit:contain;display:block}\
.skt-st__lplbl{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.12em;color:var(--m);margin-bottom:8px}\
.skt-st__lplbl b{color:var(--k)}\
.skt-st__lpareas{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:16px}\
.skt-st__lpareas span{border:2px solid var(--b);border-radius:6px;padding:5px 10px;font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:var(--m)}\
.skt-st__launch{width:100%;background:var(--y);color:var(--k);border:2px solid var(--k);border-radius:8px;padding:16px;font-family:Oswald,sans-serif;font-weight:900;font-size:15px;text-transform:uppercase;letter-spacing:.08em;cursor:pointer;box-shadow:4px 4px 0 0 var(--k)}\
.skt-st__launch:hover{background:var(--k);color:var(--y);box-shadow:none;transform:translate(2px,2px)}\
.skt-st__full{position:fixed;top:0;left:0;right:0;bottom:0;width:100vw;height:100dvh;background:rgba(17,17,17,.82);z-index:2147483000;display:none}\
.skt-st__full.is-on{display:block}\
.skt-st__fullinner{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:stretch;justify-content:center}\
.skt-studio--in{width:100%;max-width:860px;height:100dvh;max-height:100dvh;border-radius:0;border:0;margin:0;background:#fff;display:flex;flex-direction:column;overflow:hidden}\
.skt-studio--in .skt-st__canvas{height:auto!important;min-height:0!important;flex:1 1 auto}\
.skt-studio--in .skt-st__views{padding:14px 12px 12px}\
.skt-studio--in .skt-st__toolbar button{padding:10px 8px}\
.skt-studio--in .skt-st__canvas{height:auto;flex:1 1 auto;min-height:0}\
.skt-studio--in .skt-st__views,.skt-studio--in .skt-st__toolbar,.skt-studio--in .skt-st__cart,.skt-studio--in .skt-st__bar{flex:0 0 auto}\
.skt-st__close{position:absolute;top:12px;right:12px;z-index:10;width:38px;height:38px;border-radius:50%;background:var(--y);border:2px solid var(--k);font-size:20px;line-height:1;cursor:pointer;box-shadow:2px 2px 0 0 var(--k)}\
@media(min-width:920px){.skt-st__close{right:calc(50% - 430px - 52px)}}\
\
.skt-st__pickslot{display:block;margin-bottom:12px}\
.skt-st__pickslot > *{display:block!important;visibility:visible!important;max-width:100%}\
.skt-st__save{background:transparent;border:2px solid rgba(255,255,255,.28);color:#fff;border-radius:8px;padding:0 14px;height:44px;white-space:nowrap;font-family:Oswald,sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer;margin-left:auto}\
.skt-st__save:hover{border-color:var(--y);color:var(--y)}\
.skt-st__cta{margin-left:0}\
.skt-st__toast{position:absolute;left:50%;bottom:86px;transform:translate(-50%,10px);background:var(--k);color:#fff;border:2px solid var(--y);border-radius:8px;padding:10px 14px;font-size:12.5px;max-width:82%;text-align:center;opacity:0;transition:.25s;z-index:60;pointer-events:none}\
.skt-st__toast.is-on{opacity:1;transform:translate(-50%,0)}\
.skt-st__col{border:2px solid var(--b);border-radius:10px;margin-bottom:8px;overflow:hidden}\
.skt-st__col.is-open{border-color:var(--k)}\
.skt-st__colhd{display:flex;align-items:center;gap:10px;padding:9px 10px;cursor:pointer;background:#fff}\
.skt-st__col.is-open .skt-st__colhd{background:#fffdf5;border-bottom:2px solid var(--b)}\
.skt-st__colhd .dot{width:24px;height:24px;border-radius:50%;border:2px solid var(--k);flex:none;background-size:300%;background-position:center 30%}\
.skt-st__colhd b{font-family:Oswald,sans-serif;font-weight:900;font-size:12px;text-transform:uppercase;letter-spacing:.03em;flex:1;min-width:0}\
.skt-st__colhd .n{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;color:var(--m)}\
.skt-st__colhd .rm{font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;color:var(--m);text-decoration:underline}\
.skt-st__colhd .rm:hover{color:#EF4444}\
.skt-st__col .skt-st__sizes{padding:10px}\
.skt-st__addcol{width:100%;border:2px dashed var(--b);border-radius:10px;padding:11px;background:#fff;color:var(--m);font-family:Oswald,sans-serif;font-weight:900;font-size:11px;text-transform:uppercase;letter-spacing:.06em;cursor:pointer;margin-bottom:12px}\
.skt-st__addcol:hover{border-color:var(--k);color:var(--k);background:#fffdf5}\
.skt-st__colgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:10px}\
.skt-st__colgrid--chart{grid-template-columns:repeat(auto-fill,minmax(74px,1fr));gap:8px;max-height:210px;overflow:auto;padding:2px}\
.skt-st__colgrid--chart .skt-st__colpick{padding:8px 4px}\
.skt-st__colgrid--chart .sw{width:30px;height:30px}\
.skt-st__colgrid--chart .nm{font-size:8.5px}\
.skt-st__colpick.is-on{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y);background:#fffdf5}\
.skt-st__colpick{border:2px solid var(--b);border-radius:10px;background:#fff;padding:10px 6px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:6px}\
.skt-st__colpick:hover{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__colpick .sw{width:34px;height:34px;border-radius:50%;border:2px solid var(--k);background-size:300%;background-position:center 30%}\
.skt-st__colpick .nm{font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;letter-spacing:.04em;text-align:center;line-height:1.2}\
.skt-st__item{border:2px solid var(--b);border-radius:12px;margin-bottom:10px;overflow:hidden}\
.skt-st__item.is-open{border-color:var(--k);box-shadow:4px 4px 0 0 var(--y)}\
.skt-st__itemhd{display:flex;align-items:center;gap:12px;width:100%;padding:10px 12px;background:#fff;border:0;cursor:pointer;text-align:left}\
.skt-st__item.is-open .skt-st__itemhd{background:#fffdf5;border-bottom:2px solid var(--b)}\
.skt-st__itemhd .th{width:44px;height:50px;flex:none;border-radius:6px;background:var(--g);overflow:hidden;display:block}\
.skt-st__itemhd .th img{width:100%;height:100%;object-fit:contain;display:block}\
.skt-st__itemhd .nm{flex:1;min-width:0}\
.skt-st__itemhd .nm b{display:block;font-family:Oswald,sans-serif;font-weight:900;font-size:12.5px;text-transform:uppercase;letter-spacing:.03em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
.skt-st__itemhd .nm small{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--m)}\
.skt-st__itemhd .rm{font-family:Oswald,sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--m);text-decoration:underline;flex:none}\
.skt-st__itemhd .rm:hover{color:#EF4444}\
.skt-st__itembd{padding:14px 12px}\
.skt-st__addmore{width:100%;border:2px dashed var(--p);border-radius:12px;padding:14px;background:#faf5ff;color:var(--p);font-family:Oswald,sans-serif;font-weight:900;font-size:12px;text-transform:uppercase;letter-spacing:.07em;cursor:pointer}\
.skt-st__addmore:hover{background:var(--p);color:#fff}\
.skt-st__fonts{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px;max-height:46vh;overflow:auto;padding-right:4px}\
.skt-st__font{border:2px solid var(--b);border-radius:8px;background:#fff;padding:12px 10px;cursor:pointer;font-size:17px;line-height:1.2;text-align:center;color:var(--k);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\
.skt-st__font:hover{border-color:var(--k)}\
.skt-st__font.is-on{border-color:var(--k);box-shadow:3px 3px 0 0 var(--y);background:#fffdf5}\
.skt-st__fcount{font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;color:var(--p);letter-spacing:.06em;margin-left:6px}\
.skt-st__cattabs{display:flex;gap:8px;overflow-x:auto;padding-bottom:10px;margin-bottom:10px;border-bottom:2px solid var(--b)}\
.skt-st__cattabs button{flex:0 0 auto;border:2px solid var(--b);background:#fff;border-radius:20px;padding:7px 14px;font-family:Oswald,sans-serif;font-weight:700;font-size:10.5px;text-transform:uppercase;letter-spacing:.05em;color:var(--m);cursor:pointer;white-space:nowrap}\
.skt-st__cattabs button.is-on{background:var(--k);border-color:var(--k);color:var(--y)}\
.skt-st__catsearch{margin-bottom:12px}\
.skt-st__catsearch input{width:100%;padding:11px 14px;border:2px solid var(--b);border-radius:8px;font-size:13px;outline:none;background:#fff}\
.skt-st__catsearch input:focus{border-color:var(--p)}\
.skt-st__ccard .vn{display:block;font-size:10.5px;color:var(--m);padding:0 8px}\
.skt-st__ccard .cc{display:block;font-family:Oswald,sans-serif;font-weight:700;font-size:9.5px;text-transform:uppercase;color:var(--p);padding:2px 8px 0}\
.skt-st__cat{display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:12px}\
.skt-st__catload{grid-column:1/-1;text-align:center;color:var(--m);padding:24px;font-size:12.5px}\
.skt-st__ccard{border:2px solid var(--b);border-radius:12px;background:#fff;padding:0;cursor:pointer;overflow:hidden;text-align:left;display:flex;flex-direction:column}\
.skt-st__ccard:hover{border-color:var(--k);box-shadow:4px 4px 0 0 var(--y)}\
.skt-st__ccard .im{display:block;aspect-ratio:1;background:var(--g);overflow:hidden}\
.skt-st__ccard .im img{width:100%;height:100%;object-fit:contain;display:block}\
.skt-st__ccard .ti{display:block;font-family:Oswald,sans-serif;font-weight:900;font-size:10.5px;text-transform:uppercase;letter-spacing:.03em;padding:8px 8px 2px;line-height:1.25}\
.skt-st__ccard .pr{display:block;font-family:Oswald,sans-serif;font-weight:700;font-size:10px;color:var(--m);padding:0 8px 8px}\
.skt-st__restore{display:none;align-items:center;gap:10px;flex-wrap:wrap;border:2px dashed var(--p);background:#f7f0ff;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12.5px}\
.skt-st__restore button{background:none;border:0;font-family:Oswald,sans-serif;font-weight:900;font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:var(--p);cursor:pointer;text-decoration:underline}\
.skt-st__restore button:last-child{color:var(--m)}\
.skt-st__prog{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(17,17,17,.92);z-index:40;display:none;align-items:center;justify-content:center;padding:24px}\
.skt-st__prog.is-on{display:flex}\
.skt-st__progbox{width:100%;max-width:380px;text-align:left}\
.skt-st__progt{font-family:Oswald,sans-serif;font-weight:900;font-size:17px;text-transform:uppercase;letter-spacing:.04em;color:var(--y);margin-bottom:14px}\
.skt-st__pbar{height:8px;background:rgba(255,255,255,.15);border-radius:4px;overflow:hidden;margin-bottom:16px}\
.skt-st__pbar i{display:block;height:100%;width:0;background:var(--y);transition:width .35s ease}\
.skt-st__step{display:flex;align-items:center;gap:10px;padding:5px 0;font-family:Oswald,sans-serif;font-weight:700;font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:rgba(255,255,255,.4)}\
.skt-st__step i{width:16px;height:16px;border-radius:50%;border:2px solid rgba(255,255,255,.3);flex:none;position:relative}\
.skt-st__step.is-now{color:#fff}\
.skt-st__step.is-now i{border-color:var(--y);animation:sktpulse 1s ease-in-out infinite}\
.skt-st__step.is-done{color:rgba(255,255,255,.65)}\
.skt-st__step.is-done i{background:var(--y);border-color:var(--y)}\
.skt-st__step.is-done i::after{content:'';position:absolute;left:4px;top:1px;width:4px;height:8px;border:solid #111;border-width:0 2px 2px 0;transform:rotate(45deg)}\
@keyframes sktpulse{0%,100%{box-shadow:0 0 0 0 rgba(255,211,0,.5)}50%{box-shadow:0 0 0 6px rgba(255,211,0,0)}}\
.skt-st__proofs{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px;margin-bottom:14px}\
.skt-st__proofs figure{margin:0;border:2px solid var(--k);border-radius:10px;overflow:hidden;box-shadow:3px 3px 0 0 var(--y)}\
.skt-st__proofs img{width:100%;display:block}\
.skt-st__proofs figcaption{font-family:Oswald,sans-serif;font-weight:900;font-size:10px;text-transform:uppercase;letter-spacing:.08em;padding:6px;text-align:center;background:var(--g)}\
.skt-st__ship{font-size:12px;color:var(--m);line-height:1.5;margin:10px 0 0;padding:9px 12px;background:var(--g);border-left:3px solid var(--p);border-radius:0 8px 8px 0}\
.skt-st__ship b{color:var(--k)}\
.skt-st__ship a{color:var(--p);font-weight:700}\
.skt-st__rush{display:inline-block;margin-top:4px;color:var(--m)}\
.skt-st__rush a{color:var(--p);font-weight:700}\
.skt-st__warn{border-left:4px solid var(--y);background:#fffbe8;padding:10px 12px;font-size:12px;line-height:1.5;margin-bottom:12px;border-radius:0 8px 8px 0}\
.skt-st__ok{display:flex;align-items:center;gap:10px;font-size:12.5px;padding:10px 12px;border:2px solid var(--b);border-radius:8px;margin-bottom:10px;cursor:pointer}\
.skt-st__ok input{width:18px;height:18px;accent-color:var(--p)}\
.skt-st__btn:disabled{opacity:.45;cursor:not-allowed}\
.skt-studio.no-measure .skt-st__bound,\
.skt-studio.no-measure .skt-st__yoff,\
.skt-studio.no-measure .skt-st__sz{display:none!important}\
@media(max-width:700px){.skt-st__lp{grid-template-columns:1fr}}\
@media(max-width:560px){\
.skt-st__toolbar button{flex:1 1 25%;padding:10px 4px 8px;font-size:8.5px;letter-spacing:.03em;gap:5px}\
.skt-st__toolbar button svg{width:19px;height:19px}\
.skt-st__fonts{grid-template-columns:1fr}\
.skt-st__price{font-size:17px}\
}\
@media(min-width:900px){.skt-st__canvas{height:min(56vh,540px)}}\
@media(max-width:600px){.skt-st__canvas{height:min(50vh,420px)}.skt-st__toolbar button{min-width:78px;font-size:9px}}\
";
  function injectCSS() {
    if (document.getElementById('skt-studio-css')) return;
    var st = document.createElement('style');
    st.id = 'skt-studio-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------- hide the old customizer, whatever mode we are in ---------- */
  function hideOldUI() {
    findPicker();                                  /* grab it before the parent is hidden */
    var old = document.getElementById('mrk-customizer');
    if (old) old.style.display = 'none';
    $$('[id^="skt-text-overlay-"]').forEach(function (n) { n.style.display = 'none'; });
    var sticky = document.getElementById('skt-steps-wrapper');
    if (sticky) sticky.style.display = 'none';
    ['#mrk-color-modal', '#mrk-upload-modal', '#mrk-size-chart-modal', '#mrk-text-modal',
     '#mrk-sticky-bar', '.mrk-sticky-bar', '#mrk-quantity-section', '#mrk-steps']
      .forEach(function (sel) {
        try { $$(sel).forEach(function (n) { n.style.display = 'none'; }); } catch (e) {}
      });
  }

  /* ---------- hide the theme gallery, without guessing class names ---------- */
  function hideGallery() {
    if (CFG.hideGallery === false) return;
    var host = document.getElementById('skt-studio');
    if (!host) return;
    var hit = false;
    ['media-gallery', '.product-media-container', '[id^="MediaGallery"]', '.product-media-gallery',
     '.product__media-wrapper', '.product-information__media', '[class*="product-media"]']
      .forEach(function (sel) {
        try {
          $$(sel).forEach(function (n) {
            if (host.contains(n)) return;
            n.style.display = 'none';
            hit = true;
          });
        } catch (e) {}
      });
    if (hit) { widenColumn(host); return; }

    // fallback: find the biggest image on the page that is not ours and hide its column
    var sec = host.closest('.shopify-section') || document.body;
    var imgs = $$('img', sec).filter(function (i) {
      return !host.contains(i) && (i.naturalWidth || i.width) > 300;
    });
    if (!imgs.length) return;
    var node = imgs[0], stop = 0;
    while (node && node.parentElement && stop < 8) {
      if (node.parentElement === sec || node.parentElement.childElementCount > 1) break;
      node = node.parentElement; stop++;
    }
    var col = node;
    while (col && col.parentElement && col.parentElement !== sec && !host.contains(col)) {
      if (col.parentElement.childElementCount > 1 && col.parentElement.contains(host) === false) break;
      col = col.parentElement;
    }
    if (col && !host.contains(col)) { col.style.display = 'none'; widenColumn(host); }
  }
  function widenColumn(host) {
    var n = host.parentElement, stop = 0;
    while (n && stop < 6) {
      n.style.width = '100%';
      n.style.maxWidth = '100%';
      n = n.parentElement; stop++;
    }
  }


  /* ============================================================
     STOREFRONT API  —  one path for every product
     No page scraping, no 250 variant cap, no hydration wait.
     Returns options, every variant, and the four print photos.
     ============================================================ */
  var SF_VERSION = '2024-10';
  function sfToken() { return CFG.storefrontToken || window.__SKT_SF_TOKEN || null; }
  function sfQuery(query, variables) {
    var token = sfToken();
    if (!token) return Promise.reject(new Error('no storefront token'));
    return fetch('/api/' + SF_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.errors) throw new Error(j.errors[0] && j.errors[0].message || 'storefront error');
        return j.data;
      });
  }
  function gidNum(gid) {
    var m = String(gid || '').match(/(\d+)$/);
    return m ? parseInt(m[1], 10) : null;
  }
  function mfUrl(mf) {
    if (!mf) return null;
    if (mf.reference && mf.reference.image && mf.reference.image.url) return mf.reference.image.url;
    var v = mf.value;
    if (typeof v === 'string' && v.indexOf('http') === 0) return v;
    return null;
  }

  var SF_Q = '' +
    'query P($handle:String!,$cursor:String){' +
    '  product(handle:$handle){' +
    '    id title handle' +
    '    options{name values}' +
    '    positions: metafield(namespace:"custom",key:"positions_area"){value}' +
    '    inches: metafield(namespace:"custom",key:"print_inches"){value}' +
    '    variants(first:250, after:$cursor){' +
    '      pageInfo{hasNextPage endCursor}' +
    '      nodes{' +
    '        id title availableForSale' +
    '        price{amount}' +
    '        selectedOptions{name value}' +
    '        front: metafield(namespace:"custom",key:"front_image"){value reference{... on MediaImage{image{url}}}}' +
    '        back:  metafield(namespace:"custom",key:"back_image"){value reference{... on MediaImage{image{url}}}}' +
    '        left:  metafield(namespace:"custom",key:"left_image"){value reference{... on MediaImage{image{url}}}}' +
    '        right: metafield(namespace:"custom",key:"right_image"){value reference{... on MediaImage{image{url}}}}' +
    '      }' +
    '    }' +
    '  }' +
    '}';

  var SF_CACHE = {};
  function loadProductData(handle) {
    if (SF_CACHE[handle]) return Promise.resolve(SF_CACHE[handle]);
    var out = { title: '', options: [], variants: [], images: {}, positions: null, inches: null };
    function page(cursor) {
      return sfQuery(SF_Q, { handle: handle, cursor: cursor || null }).then(function (d) {
        var p = d && d.product;
        if (!p) throw new Error('product not found');
        out.title = p.title;
        out.options = (p.options || []).map(function (o) { return { name: o.name, values: o.values }; });
        if (p.positions && p.positions.value) {
          try { out.positions = JSON.parse(p.positions.value); } catch (e) {}
        }
        if (p.inches && p.inches.value) {
          try { out.inches = JSON.parse(p.inches.value); } catch (e) {}
        }
        (p.variants.nodes || []).forEach(function (v) {
          var id = gidNum(v.id);
          var row = { id: id, price: Math.round(parseFloat(v.price.amount) * 100), available: v.availableForSale };
          (v.selectedOptions || []).forEach(function (so, i) { row['option' + (i + 1)] = so.value; });
          out.variants.push(row);
          var imgs = {};
          ['front', 'back', 'left', 'right'].forEach(function (k) {
            var u = mfUrl(v[k]);
            if (u) imgs[k] = u;
          });
          if (Object.keys(imgs).length) out.images[id] = imgs;
        });
        if (p.variants.pageInfo.hasNextPage) return page(p.variants.pageInfo.endCursor);
        return out;
      });
    }
    return page(null).then(function (res) {
      SF_CACHE[handle] = res;
      console.log('[SKT studio] loaded', handle, res.variants.length, 'variants,',
        Object.keys(res.images).length, 'with photos');
      return res;
    });
  }
  function colourPhotos(data) {
    /* one entry per colour rather than per variant, which is what we actually need */
    var byColour = {};
    var colourOpt = (data.options.filter(function (o) {
      return norm(o.name) === 'color' || norm(o.name) === 'colour';
    })[0] || {}).name;
    data.variants.forEach(function (v) {
      var c = null;
      ['option1', 'option2', 'option3'].forEach(function (k, i) {
        if (colourOpt && data.options[i] && data.options[i].name === colourOpt) c = v[k];
      });
      if (!c) return;
      var im = data.images[v.id];
      if (!im) return;
      if (!byColour[c]) byColour[c] = {};
      ['front', 'back', 'left', 'right'].forEach(function (k) {
        if (im[k] && !byColour[c][k]) byColour[c][k] = im[k];
      });
    });
    return byColour;
  }

  /* ---------- multiple garments ---------- */
  function syncItem() {
    var it = S.items[S.ai];
    if (!it) return;
    it.colour = S.colour; it.qty = S.qty; it.layers = S.layers;
    if (!it.colours) it.colours = [{ name: S.colour, qty: S.qty }];
  }
  function colourEntry(it, name) {
    if (!it.colours) it.colours = [];
    var e = it.colours.filter(function (c) { return c.name === name; })[0];
    return e || null;
  }
  function useColour(name) {
    var it = S.items[S.ai];
    if (!it) return;
    var e = colourEntry(it, name);
    if (!e) { e = { name: name, qty: {} }; it.colours.push(e); }
    S.colour = name; S.qty = e.qty; it.colour = name; it.qty = e.qty;
  }
  /* Picking a colour has to move the order with it, not just the photo. Setting
     S.colour on its own left the item still holding the colour it booted with,
     and every size typed afterwards went into that old colour's basket, so the
     cart came back in the wrong colour. While nothing is ordered yet there is
     only ever one colour block, so swap it rather than stacking a second. */
  function pickColour(name) {
    if (!name) return;
    var it = S.items[S.ai];
    if (it && itemPieces(it) === 0) it.colours = [{ name: name, qty: {} }];
    useColour(name);
  }

  function removeColour(i) {
    var it = S.items[S.ai];
    if (!it || it.colours.length < 2) return;
    it.colours.splice(i, 1);
    useColour(it.colours[0].name);
    drawStage(); render(); buildSheet('product');
  }
  function itemPieces(it) {
    var n = 0;
    (it.colours || []).forEach(function (c) {
      Object.keys(c.qty || {}).forEach(function (k) { n += c.qty[k] || 0; });
    });
    return n;
  }
  function activate(i) {
    if (!S.items[i]) return;
    syncItem();
    S.ai = i;
    var it = S.items[i];
    PRODUCT = it.product; IMAGES = it.images;
    CFG.positions = it.positions; CFG.inches = it.inches; CFG.handle = it.handle;
    S.colour = it.colour; S.qty = it.qty; S.layers = it.layers; S.sel = null;
    drawStage(); fitStage(); render();
  }
  function blankLayers() { return { front: [], back: [], left: [], right: [] }; }
  function cloneLayers(src) {
    var out = blankLayers();
    Object.keys(out).forEach(function (k) {
      out[k] = (src[k] || []).map(function (l) {
        var c = JSON.parse(JSON.stringify(l)); c.id = S.uid++; return c;
      });
    });
    return out;
  }
  /* every product page renders the studio config, so we can read another
     product's print areas straight off its own page */
  function configFor(handle) {
    return fetch('/products/' + handle)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/id="skt-studio-config"[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return null;
        try { return JSON.parse(m[1]); } catch (e) { return null; }
      }).catch(function () { return null; });
  }
  function imagesFor(handle) {
    return fetch('/products/' + handle)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/id="mrk-variant-images-data"[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return {};
        try { return JSON.parse(m[1]); } catch (e) { return {}; }
      }).catch(function () { return {}; });
  }
  function addGarment(handle) {
    progStart(['Loading that garment', 'Copying your artwork']);
    var loader = sfToken()
      ? loadProductData(handle).then(function (d) {
          return {
            product: { id: d.id, title: d.title, options: d.options, variants: d.variants },
            images: d.images, photos: colourPhotos(d),
            positions: d.positions, inches: d.inches, title: d.title
          };
        })
      : Promise.all([
          fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }),
          configFor(handle), imagesFor(handle)
        ]).then(function (res) {
          var full = res[0];
          if (!full) return null;
          return {
            product: {
              id: full.id, title: full.title,
              options: (full.options || []).map(function (o, i) {
                return typeof o === 'string' ? { name: o, values: uniqueOptionValues(full.variants, i) } : o;
              }),
              variants: full.variants
            },
            images: res[2] || {}, photos: {},
            positions: res[1] && res[1].positions, inches: res[1] && res[1].inches,
            title: full.title
          };
        });

    return loader.then(function (res) {
      if (!res) { progDone(); toast('Could not load that product.'); return; }
      progNext(1, 'Copying your artwork…');
      var prod = res.product, imgs = res.images, cfg2 = { positions: res.positions, inches: res.inches };
      var full = { title: res.title };
      var colours = (prod.options.filter(function (o) {
        return String(o.name).toLowerCase() === 'color' || String(o.name).toLowerCase() === 'colour';
      })[0] || {}).values || [];
      var qty = {};
      var sizes = (prod.options.filter(function (o) { return String(o.name).toLowerCase() === 'size'; })[0] || {}).values || [];
      sizes.forEach(function (s) { qty[s] = 0; });
      syncItem();
      S.items.push({
        handle: handle, title: full.title, product: prod, images: imgs,
        colourPhotos: res.photos || {},
        positions: (cfg2 && cfg2.positions) || CFG.positions,
        inches: (cfg2 && cfg2.inches) || CFG.inches,
        colour: colours[0] || null, qty: qty,
        colours: [{ name: colours[0] || null, qty: qty }],
        layers: cloneLayers(S.items[S.ai] ? S.items[S.ai].layers : S.layers)
      });
      progDone();
      activate(S.items.length - 1);
      buildSheet('product');
      toast('Added. Your artwork was copied over, edit it here if you want it different.');
    });
  }
  function removeGarment(i) {
    if (S.items.length < 2) return;
    S.items.splice(i, 1);
    activate(Math.max(0, i - 1));
    buildSheet('product');
  }

  /* ---------- catalogue picker ---------- */
  var CATALOGUE = {}, COLLECTIONS = null, CATTAB = 'all', CATQ = '';
  function loadCatalogue(handle) {
    var key = handle || 'all';
    if (CATALOGUE[key]) return Promise.resolve(CATALOGUE[key]);
    var src = key === 'all'
      ? (CFG.catalogueCollection ? '/collections/' + CFG.catalogueCollection + '/products.json?limit=250'
                                 : '/products.json?limit=250')
      : '/collections/' + key + '/products.json?limit=250';
    return fetch(src).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        CATALOGUE[key] = (d && d.products) ? d.products : [];
        return CATALOGUE[key];
      }).catch(function () { CATALOGUE[key] = []; return CATALOGUE[key]; });
  }
  function loadCollections() {
    if (COLLECTIONS) return Promise.resolve(COLLECTIONS);
    return fetch('/collections.json?limit=250').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.collections) ? d.collections : [];
        /* only collections that actually hold garments worth printing */
        COLLECTIONS = list.filter(function (c) {
          return (c.products_count == null || c.products_count > 0)
            && ['frontpage', 'all'].indexOf(c.handle) < 0;
        }).slice(0, 12);
        return COLLECTIONS;
      }).catch(function () { COLLECTIONS = []; return COLLECTIONS; });
  }


  /* ---------- turnaround in business days, Saskatchewan ---------- */
  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  function nthWeekday(y, month, weekday, n) {
    var d = new Date(y, month, 1);
    var add = (weekday - d.getDay() + 7) % 7;
    d.setDate(1 + add + (n - 1) * 7);
    return d;
  }
  function holidaysFor(y) {
    var list = [
      new Date(y, 0, 1),                    /* New Year */
      nthWeekday(y, 1, 1, 3),               /* Family Day, 3rd Monday Feb */
      new Date(easterSunday(y).getTime() - 2 * 864e5), /* Good Friday */
      nthWeekday(y, 4, 1, 3),               /* Victoria Day, Monday before May 25 */
      new Date(y, 6, 1),                    /* Canada Day */
      nthWeekday(y, 7, 1, 1),               /* Saskatchewan Day */
      nthWeekday(y, 8, 1, 1),               /* Labour Day */
      new Date(y, 8, 30),                   /* Truth and Reconciliation */
      nthWeekday(y, 9, 1, 2),               /* Thanksgiving */
      new Date(y, 10, 11),                  /* Remembrance Day */
      new Date(y, 11, 25),                  /* Christmas */
      new Date(y, 11, 26)                   /* Boxing Day */
    ];
    /* Victoria Day is the Monday on or before May 24 */
    var vd = new Date(y, 4, 24);
    while (vd.getDay() !== 1) vd.setDate(vd.getDate() - 1);
    list[3] = vd;
    var extra = [];
    list.forEach(function (d) {
      if (d.getDay() === 6) extra.push(new Date(d.getTime() + 2 * 864e5));   /* observed Monday */
      if (d.getDay() === 0) extra.push(new Date(d.getTime() + 864e5));
    });
    return list.concat(extra).map(function (d) {
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    });
  }
  var HOL = {};
  function isBusinessDay(d) {
    if (d.getDay() === 0 || d.getDay() === 6) return false;
    var y = d.getFullYear();
    if (!HOL[y]) HOL[y] = holidaysFor(y);
    return HOL[y].indexOf(y + '-' + (d.getMonth() + 1) + '-' + d.getDate()) < 0;
  }
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) left--;
    }
    return d;
  }
  /* always reckon in shop time, so a customer in Toronto or Vancouver sees
     the same promise your shop can actually keep */
  function shopNow() {
    var tz = CFG.timezone || 'America/Regina';
    try {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
    } catch (e) {
      return new Date();
    }
  }
  function turnaround() {
    var now = shopNow();
    var cutoff = (typeof CFG.cutoffHour === 'number') ? CFG.cutoffHour : 15;
    var start = new Date(now.getTime());
    /* after the cutoff, or on a day we are closed, the clock starts next business day */
    if (now.getHours() >= cutoff || !isBusinessDay(now)) start = addBusinessDays(now, 1);
    /* day one is the next business day, today is never counted */
    var lo = addBusinessDays(start, (CFG.turnaroundMin || 2));
    var hi = addBusinessDays(start, (CFG.turnaroundMax || 5));
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function f(d) { return m[d.getMonth()] + ' ' + d.getDate(); }
    var sameMonth = lo.getMonth() === hi.getMonth();
    return {
      from: lo, to: hi,
      text: f(lo) + ' to ' + (sameMonth ? hi.getDate() : f(hi)),
      late: (now.getHours() >= cutoff)
    };
  }

  /* ---------- launch mode ---------- */
  function launcher() {
    return ''
    + '<div class="skt-st__lp">'
    +   '<div class="skt-st__lpimg" id="sktLPImg"></div>'
    +   '<div class="skt-st__lpbody">'
    +     '<div class="skt-st__lplbl">Colour — <b id="sktLPCol"></b></div>'
    +     '<div class="skt-st__pickslot" id="sktLPPick"></div>'
    +     '<div class="skt-st__sws" id="sktLPSws"></div>'
    +     '<div class="skt-st__lplbl" style="margin-top:14px">Print areas</div>'
    +     '<div class="skt-st__lpareas">' + VIEWS.map(function (v) {
            return '<span>' + v.n + '</span>'; }).join('') + '</div>'
    +     '<div class="skt-st__restore" id="sktRestore"></div>'
    +     '<button type="button" class="skt-st__launch" id="sktLaunch">Start designing</button>'
    +     '<p class="skt-st__note" id="sktLPShip"></p>'
    +   '</div>'
    + '</div>';
  }
  function paintLauncher() {
    harvestSwatches();
    var img = viewImage('front');
    if (!img) {
      var sw0 = swatchFor(S.colour);
      img = (sw0 && (sw0.variantImage || sw0.image)) || '';
    }
    $('#sktLPImg').innerHTML = img ? '<img src="' + img + '" alt="">' : '';
    $('#sktLPCol').textContent = S.colour || '';
    if (mountPicker('sktLPPick')) {
      $('#sktLPSws').innerHTML = '';
    } else {
      $('#sktLPSws').innerHTML = optionValues('Color').map(function (c) {
        return '<button type="button" class="skt-st__sw' + (c === S.colour ? ' is-on' : '')
          + '" data-lcolour="' + esc(c) + '" title="' + esc(c) + '" style="' + colourSwatchStyle(c) + '"></button>';
      }).join('');
    }
    $$('[data-lcolour]').forEach(function (b) {
      b.addEventListener('click', function () {
        pickColour(b.getAttribute('data-lcolour'));
        paintLauncher();
        if (!hasRealPhoto(S.colour)) chaseImages(S.colour);
      });
    });
    var ta = turnaround();
    var phone = CFG.phone || '306-290-5120';
    $('#sktLPShip').innerHTML =
      '<b>Ready ' + ta.text + '</b>, printed in Saskatoon. '
      + (CFG.turnaroundMin || 2) + ' to ' + (CFG.turnaroundMax || 5) + ' business days'
      + (ta.late ? ', counted from tomorrow since today\'s orders are already in production' : '') + '.'
      + '<br><span class="skt-st__rush">Need it sooner? Call <a href="tel:'
      + phone.replace(/[^0-9+]/g, '') + '">' + phone + '</a> and we will see what we can do.</span>';
  }
  function fullHost() {
    var f = document.getElementById('sktFull');
    if (!f) {
      f = document.createElement('div');
      f.id = 'sktFull';
      f.className = 'skt-st__full';
      document.body.appendChild(f);   /* body, not the section, or fixed breaks */
    }
    return f;
  }
  function openFull() {
    var full = fullHost();
    full.innerHTML = '<div class="skt-st__fullinner">'
      + '<button type="button" class="skt-st__close" id="sktClose">&times;</button>'
      + '<div class="skt-studio skt-studio--in" id="sktInner"></div></div>';
    if (CFG.showMeasurements === false || CFG.showMeasurements == null) $('#sktInner').classList.add('no-measure');
    $('#sktInner').innerHTML = shell();
    document.body.style.overflow = 'hidden';
    full.classList.add('is-on');
    bind($('#sktInner'));
    drawStage();
    fitStage();
    render();
    $('#sktClose').addEventListener('click', closeFull);
  }
  function closeFull() {
    var f = document.getElementById('sktFull');
    if (f) f.classList.remove('is-on');
    document.body.style.overflow = '';
    paintLauncher();
  }
  document.addEventListener('keydown', function (e) {
    var f = document.getElementById('sktFull');
    if (e.key === 'Escape' && f && f.classList.contains('is-on')) closeFull();
  });

  function loadFullProduct() {
    if (!CFG.handle) return;
    if (sfToken()) {
      loadProductData(CFG.handle).then(function (d) {
        PRODUCT = { id: d.id, title: d.title, options: d.options, variants: d.variants };
        IMAGES = d.images;
        COLOUR_PHOTOS = colourPhotos(d);
        if (d.positions) CFG.positions = d.positions;
        if (d.inches) CFG.inches = d.inches;
        if (S.items[0]) {
          S.items[0].product = PRODUCT; S.items[0].images = IMAGES;
          S.items[0].colourPhotos = COLOUR_PHOTOS;
          S.items[0].positions = CFG.positions; S.items[0].inches = CFG.inches;
        }
        if (!S.colour) { S.colour = optionValues('Color')[0] || null; useColour(S.colour); }
        if (CFG.mode === 'launch') paintLauncher();
        if (document.getElementById('sktStage')) { drawStage(); render(); }
        if (S.sheet === 'product') buildSheet('product');
      }).catch(function (e) {
        console.warn('[SKT studio] storefront load failed, falling back', e && e.message);
        legacyLoadFullProduct();
      });
      return;
    }
    legacyLoadFullProduct();
  }
  var COLOUR_PHOTOS = {};
  function legacyLoadFullProduct() {
    if (!CFG.handle) return;
    fetch('/products/' + CFG.handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (full) {
        if (!full || !full.variants || !full.variants.length) return;
        PRODUCT = {
          id: full.id,
          title: full.title,
          options: (full.options || []).map(function (o, i) {
            return typeof o === 'string'
              ? { name: o, values: uniqueOptionValues(full.variants, i) }
              : o;
          }),
          variants: full.variants
        };
        if (!S.colour) S.colour = optionValues('Color')[0] || null;
        if (S.items[0]) { S.items[0].product = PRODUCT; S.items[0].images = IMAGES; }
        if (CFG.mode === 'launch') paintLauncher();
        if (document.getElementById('sktStage')) { drawStage(); render(); }
        if (S.sheet === 'product') buildSheet('product');
      })
      .catch(function () {
        setTimeout(function () {
          fetch('/products/' + CFG.handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (f2) {
              if (!f2 || !f2.variants) return;
              PRODUCT = { id: f2.id, title: f2.title,
                options: (f2.options || []).map(function (o, i) {
                  return typeof o === 'string' ? { name: o, values: uniqueOptionValues(f2.variants, i) } : o;
                }),
                variants: f2.variants };
              if (CFG.mode === 'launch') paintLauncher();
              if (document.getElementById('sktStage')) { drawStage(); render(); }
            }).catch(function () {});
        }, 1500);
      });
  }
  function uniqueOptionValues(variants, idx) {
    var key = 'option' + (idx + 1), seen = {}, out = [];
    variants.forEach(function (v) {
      var val = v[key];
      if (val && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  }

  /* ---------- boot ---------- */
  function boot() {
    CFG = readJSON('skt-studio-config');
    PRODUCT = readProduct();
    IMAGES = readJSON('mrk-variant-images-data') || {};
    SWATCHES = readJSON('mrk-color-swatches-data') || {};
    var host = $('#skt-studio');
    if (!CFG || !PRODUCT || !host) { console.warn('[SKT studio] missing data, leaving the page alone'); return; }
    if (typeof CFG.positions === 'string') { try { CFG.positions = JSON.parse(CFG.positions); } catch (e) {} }
    if (typeof CFG.inches === 'string') { try { CFG.inches = JSON.parse(CFG.inches); } catch (e) {} }

    /* Liquid caps variant loops at 250, which is why colours past the eighth
       had no variant, no image and no swatch. Pull the full list from Shopify. */
    loadFullProduct();

    harvestFonts();
    S.colour = optionValues('Color')[0] || null;
    optionValues('Size').forEach(function (s) { S.qty[s] = 0; });
    S.items = [{
      handle: CFG.handle, title: CFG.title || 'This garment',
      product: PRODUCT, images: IMAGES,
      positions: CFG.positions, inches: CFG.inches,
      colour: S.colour, qty: S.qty,
      colours: [{ name: S.colour, qty: S.qty }],
      layers: S.layers
    }];
    S.ai = 0;

    injectCSS();
    harvestSwatches();
    hideOldUI();
    hideGallery();
    setTimeout(function () { hideOldUI(); hideGallery(); }, 900);
    setTimeout(hideOldUI, 2500);
    if (CFG.mode === 'launch') {
      host.classList.add('is-launch');
      host.innerHTML = launcher();
    setTimeout(function () { if (S.colour && !hasRealPhoto(S.colour)) chaseImages(S.colour, 40); }, 800);
      $('#sktLaunch').addEventListener('click', openFull);
      paintLauncher();
      restoreOffer();
      return;
    }
    host.innerHTML = shell();
    bind();
    drawStage();
    fitStage();
    render();

    hideOldUI();

    // re-read images once the Storefront hydration finishes
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var fresh = readJSON('mrk-variant-images-data');
      var freshSw = readJSON('mrk-color-swatches-data');
      var changed = (fresh && Object.keys(fresh).length !== Object.keys(IMAGES).length)
        || (freshSw && Object.keys(freshSw).length !== Object.keys(SWATCHES || {}).length);
      if (changed) {
        IMAGES = fresh || IMAGES;
        SWATCHES = freshSw || SWATCHES;
        PRODUCT = readProduct() || PRODUCT;
        if (CFG.mode === 'launch') paintLauncher();
        if (document.getElementById('sktStage')) { drawStage(); render(); }
        if (S.sheet === 'product') buildSheet('product');
      }
      if (tries > 40) clearInterval(poll);
    }, 700);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.SKTStudio = {
    state: S,
    cfg: function () { return CFG; },
    proof: function (k) { return buildPlacement(k || S.view); },
    vector: function (k) { return buildVector(k || S.view); },
    turnaround: function () { return turnaround(); },
    check: function (k) {
      k = k || S.view;
      var A = area(k), g = document.getElementById('sktGarment'), ar = document.getElementById('sktArea');
      var gr = g.getBoundingClientRect(), arr = ar.getBoundingClientRect();
      var l = (S.layers[k] || [])[0] || null;
      var el = document.querySelector('.skt-st__l');
      var er = el ? el.getBoundingClientRect() : null;
      return {
        view: k,
        area_percent: { top: A.top, left: A.left, width: A.width, height: A.height },
        area_inches: { w: A.w, h: A.h },
        image_natural: [g.naturalWidth, g.naturalHeight],
        image_on_screen: [Math.round(gr.width), Math.round(gr.height)],
        area_on_screen: [Math.round(arr.width), Math.round(arr.height)],
        area_share_of_image: [ +(arr.width / gr.width).toFixed(3), +(arr.height / gr.height).toFixed(3) ],
        layer: l ? { type: l.type, x: +l.x.toFixed(2), y: +l.y.toFixed(2), w: +l.w.toFixed(2), h: +l.h.toFixed(2), cap: l.cap, warp: l.warp } : null,
        layer_share_of_shirt: er ? +(er.width / gr.width).toFixed(3) : null,
        image_used: (S.imgUsed || {})[S.ai + ':' + k] || viewImage(k)
      };
    },
    debug: function () {
      var c = S.colour;
      var vs = PRODUCT.variants.filter(function (x) {
        return [x.option1, x.option2, x.option3].indexOf(c) > -1;
      });
      var withImg = vs.filter(function (v) {
        var im = IMAGES[v.id] || IMAGES[String(v.id)] || {};
        return im.front && im.front !== 'null';
      });
      return {
        colour: c,
        variantsLoaded: PRODUCT.variants.length,
        imageEntries: Object.keys(IMAGES).length,
        variantsForThisColour: vs.length,
        firstVariantId: vs[0] ? vs[0].id : null,
        variantsWithFrontPhoto: withImg.length,
        resolvedImage: viewImage('front') || '(none)'
      };
    }
  };

  /* ============================================================
     MOCKUP LAB BRIDGE  —  added block, nothing above is changed
     Lets templates/page.mockup-lab.liquid drive this same engine
     with no product page and no cart. Product pages are untouched:
     boot() still runs exactly as before.
     PASTE THIS DIRECTLY ABOVE THE FINAL  })();  OF THIS FILE.
     ============================================================ */

  /* the launcher only exists on a product page. on the lab there is none,
     so anything that repaints it has to become a no-op rather than throw */
  var _paintLauncher = paintLauncher;
  paintLauncher = function () {
    if (!document.getElementById('sktLPImg')) return;
    return _paintLauncher.apply(null, arguments);
  };

  function labParse(v) {
    if (typeof v !== 'string') return v;
    try { return JSON.parse(v); } catch (e) { return null; }
  }

  /* start the engine from a config object instead of #skt-studio-config,
     and from the Storefront API instead of mrk-product-data */
  function labBoot(cfgObj, handle) {
    CFG = cfgObj || {};
    CFG.positions = labParse(CFG.positions) || CFG.positions;
    CFG.inches = labParse(CFG.inches) || CFG.inches;
    injectCSS();
    return labUseProduct(handle, true);
  }

  /* make `handle` the active garment. first call sets up item 0, later calls
     either switch to an item already loaded or add one, copying the design
     across in inches the way the studio already does between garments */
  function labUseProduct(handle, isFirst) {
    var at = -1;
    S.items.forEach(function (it, i) { if (it.handle === handle) at = i; });
    if (at > -1) { activate(at); return Promise.resolve(S.items[at]); }

    if (!isFirst && S.items.length) {
      return addGarment(handle).then(function () { return S.items[S.ai]; });
    }

    return loadProductData(handle).then(function (d) {
      PRODUCT = { id: d.id, title: d.title, options: d.options, variants: d.variants };
      IMAGES = d.images;
      COLOUR_PHOTOS = colourPhotos(d);
      CFG.handle = handle;
      CFG.title = d.title;
      if (d.positions) CFG.positions = d.positions;
      if (d.inches) CFG.inches = d.inches;
      S.colour = optionValues('Color')[0] || null;
      S.qty = {};
      S.layers = blankLayers();
      S.items = [{
        handle: handle, title: d.title, product: PRODUCT, images: IMAGES,
        colourPhotos: COLOUR_PHOTOS,
        positions: CFG.positions, inches: CFG.inches,
        colour: S.colour, qty: S.qty,
        colours: [{ name: S.colour, qty: S.qty }],
        layers: S.layers
      }];
      S.ai = 0;
      return S.items[0];
    });
  }

  function labSetColour(name) {
    if (!name) return;
    var vals = optionValues('Color');
    var match = vals.filter(function (c) { return norm(c) === norm(name); })[0];
    useColour(match || name);
    if (document.getElementById('sktStage')) { drawStage(); render(); }
  }

  function labViewsWithLayers() {
    return VIEWS.filter(function (v) { return (S.layers[v.k] || []).length; }).map(function (v) { return v.k; });
  }
  function labHasAnyLayers() { return labViewsWithLayers().length > 0; }

  /* open and close the full screen studio without a launcher behind it */
  function labOpen() {
    openFull();
    document.body.setAttribute('data-skt-lab-open', '1');
  }
  function labClose() {
    var f = document.getElementById('sktFull');
    if (f) f.classList.remove('is-on');
    document.body.style.overflow = '';
    document.body.removeAttribute('data-skt-lab-open');
  }

  /* mount the studio straight into a container on the page, no overlay.
     same shell, same bindings the full screen version uses. */
  function labMount(host) {
    host = (typeof host === 'string') ? document.getElementById(host) : host;
    if (!host) return false;
    host.style.display = '';
    host.classList.add('skt-studio');
    if (CFG.showMeasurements === false || CFG.showMeasurements == null) host.classList.add('no-measure');
    host.innerHTML = shell();
    bind(host);
    drawStage();
    fitStage();
    render();
    return true;
  }
  function labRefresh() {
    if (!document.getElementById('sktStage')) return;
    drawStage(); fitStage(); render();
  }

  /* the branded mockup, same one the orders carry */
  function labProof(viewKey, colourName) {
    return buildPlacement(viewKey, colourName || S.colour);
  }
  /* the true size vector print file */
  function labVector(viewKey) { return buildVector(viewKey); }

  /* the design on its own, transparent, at print resolution.
     same drawing the proof does, minus the garment and the chrome. */
  function labDesignPNG(viewKey, dpi) {
    var k = viewKey || S.view;
    var ls = S.layers[k] || [];
    if (!ls.length) return Promise.resolve(null);
    var A = area(k);
    var d = dpi || 300;
    var W = Math.max(64, Math.round(A.w * d));
    var H = Math.max(64, Math.round(A.h * d));
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');

    var jobs = ls.map(function (l) {
      return function () {
        var lx = (l.x / A.w) * W, ly = (l.y / A.h) * H;
        var lw = (l.w / A.w) * W, lh = (l.h / A.h) * H;
        if (isBox(l) && l.type !== 'image') { lx += lw / 2; ly += lh / 2; }
        if (l.type === 'image') {
          return loadImg(l.src, false).then(function (im) {
            x.save();
            x.translate(lx + lw / 2, ly + lh / 2);
            x.rotate((l.rot || 0) * Math.PI / 180);
            x.scale(l.fx || 1, l.fy || 1);
            x.drawImage(im, -lw / 2, -lh / 2, lw, lh);
            x.restore();
          }).catch(function () {});
        }
        return new Promise(function (done) {
          var px = (l.cap / A.h) * H * 1.38;
          x.save();
          x.translate(lx, ly);
          x.rotate((l.rot || 0) * Math.PI / 180);
          x.scale(l.fx || 1, l.fy || 1);
          x.font = (l.italic ? 'italic ' : '') + (l.weight || 900) + ' ' + px + "px '" + l.font + "', sans-serif";
          x.textAlign = 'center';
          x.textBaseline = 'middle';
          try { x.letterSpacing = ((l.ls || 0) / 100) + 'em'; } catch (e) {}
          x.lineJoin = 'round';
          var warp = l.warp || 'normal';

          if (warp === 'normal' || warp === 'slant') {
            if (warp === 'slant') x.transform(1, 0, -Math.tan((l.intensity == null ? 50 : l.intensity) * 0.0038), 1, 0, 0);
            var lines = String(l.text || '').split('\n');
            var lineH = px * (l.lh || 1.1);
            var start = -((lines.length - 1) * lineH) / 2;
            var offs = lineOffsets(x, lines, l.align);
            lines.forEach(function (line, i) {
              var yy = start + i * lineH, dx = offs[i];
              if (l.outline && l.outlineW) {
                x.lineWidth = (l.outlineW / 100) * px * 2;
                x.strokeStyle = l.outline;
                x.strokeText(line, dx, yy);
              }
              if (!l.hollow) { x.fillStyle = l.colour; x.fillText(line, dx, yy); }
            });
          } else {
            var VBW = 400, VBH = 200, VF = 62;
            var scale = Math.min((lw || VBW) / VBW, (lh || VBH) / VBH);
            x.scale(scale, scale);
            x.font = (l.italic ? 'italic ' : '') + (l.weight || 900) + ' ' + VF + "px '" + l.font + "', sans-serif";
            x.textAlign = 'center';
            x.textBaseline = 'alphabetic';
            x.lineJoin = 'round';
            var txt = String(l.text || '').replace(/\n/g, ' ');
            var chars = txt.split('');
            var widths = chars.map(function (ch) { return x.measureText(ch).width; });
            var total = widths.reduce(function (a, b) { return a + b; }, 0);
            var inten = (l.intensity == null ? 50 : l.intensity) / 100;
            function paint(ch, fsNow) {
              if (l.outline && l.outlineW) {
                x.lineWidth = (l.outlineW / 100) * fsNow * 2;
                x.strokeStyle = l.outline;
                x.strokeText(ch, 0, 0);
              }
              if (!l.hollow) { x.fillStyle = l.colour; x.fillText(ch, 0, 0); }
            }
            if (warp === 'wave') {
              var cxW = -total / 2;
              chars.forEach(function (ch, i) {
                var w = widths[i];
                var tt = (cxW + w / 2) / (total / 2);
                x.save();
                x.translate(cxW + w / 2, Math.sin(tt * Math.PI) * (60 * inten));
                paint(ch, VF);
                x.restore();
                cxW += w;
              });
            } else if (warp === 'circle') {
              var rC = 90, angC = -Math.PI / 2 - (total / rC) / 2;
              chars.forEach(function (ch, i) {
                var w = widths[i], step = w / rC, a2 = angC + step / 2;
                x.save();
                x.translate(Math.cos(a2) * rC, Math.sin(a2) * rC);
                x.rotate(a2 + Math.PI / 2);
                paint(ch, VF);
                x.restore();
                angC += step;
              });
            } else {
              var g2 = arcGeometry(l.intensity, 180);
              var up = warp === 'arcup';
              var cy2 = up ? (g2.r - g2.sag / 2) : -(g2.r - g2.sag / 2);
              var ang = -(total / g2.r) / 2;
              chars.forEach(function (ch, i) {
                var w = widths[i], step = w / g2.r, a2 = ang + step / 2;
                x.save();
                x.translate(Math.sin(a2) * g2.r, up ? (cy2 - Math.cos(a2) * g2.r) : (cy2 + Math.cos(a2) * g2.r));
                x.rotate(up ? a2 : -a2);
                paint(ch, VF);
                x.restore();
                ang += step;
              });
            }
          }
          x.restore();
          done();
        });
      };
    });

    return jobs.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve())
      .then(function () {
        try { return { url: c.toDataURL('image/png'), w: W, h: H, inW: A.w, inH: A.h }; }
        catch (e) { return null; }
      });
  }

  /* same upload path the orders use, so the lab never needs its own */
  function labUpload(dataUrl, name) { return uploadDataUrl(dataUrl, name); }
  function labUploadText(text, name, mime) { return uploadText(text, name, mime); }

  window.SKTStudio = window.SKTStudio || {};
  window.SKTStudio.lab = {
    boot: labBoot,
    useProduct: labUseProduct,
    setColour: labSetColour,
    colours: function () { return optionValues('Color'); },
    open: labOpen,
    mount: labMount,
    refresh: labRefresh,
    close: labClose,
    proof: labProof,
    vector: labVector,
    designPNG: labDesignPNG,
    upload: labUpload,
    uploadText: labUploadText,
    viewsWithLayers: labViewsWithLayers,
    hasLayers: labHasAnyLayers,
    area: function (k) { return area(k); },
    state: S,
    views: VIEWS
  };
})();
